import React, { Component } from 'react';
import { Modal, notification, Icon, Alert } from 'antd';
import memoize from "memoize-one";
import ACTIONTYPES from "./ActionTypes";
import { history } from '../container/History';
import Cookies from 'js-cookie';
import moment, { now } from 'moment'
import md5 from "md5";
import Refetch from 'fetch-retry'
import { Admin } from '../auth';
import { AlumniSpecialist, REMOVED_SEARCHFILTERS } from '../auth';

import * as Sentry from "@sentry/react";
import { func } from 'prop-types';
import { functions, result } from 'lodash';



const AdminAccess = Admin
const NESA_MID = process.env.REACT_APP_NESA_MID;
const MYST_URL = process.env.REACT_APP_MYST_API;
const AUTH_URL = process.env.REACT_APP_AUTH_API;
const ESB_URL = process.env.REACT_APP_ESB_API;
const CORE_URL = process.env.REACT_APP_CORE_API
const PAYMENY_URL = process.env.REACT_APP_PAYMENT_API;
const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
const CONFIRM_MEMBERSHIP_TEXT = process.env.REACT_APP_CONFIRM_MEMBERSHIP_TEXT;
const ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE = process.env.REACT_APP_ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE; //Alumni Privacy Options pushed to QA/PROD DATE
// const NEED_HELP_EMAIL_ID = process.env.REACT_APP_NEED_HELP_EMAIL_ID;

//membership greating message;
const INDIVIDUAL_PURCHASE = JSON.parse(process.env.REACT_APP_INDIVIDUAL_PURCHASE);
const GIFTED_PURCHASE = JSON.parse(process.env.REACT_APP_GIFTED_PURCHASE);
const RENEW_PURCHASE = JSON.parse(process.env.REACT_APP_RENEW_PURCHASE);
const GIFTEE_GREATINGS = JSON.parse(process.env.REACT_APP_GIFTEE_GREATINGS);

let today = moment().format('YYYY-MM-DD')
let thisyear = moment().format('YYYY')
let receiptDate = moment().format('MM/DD/YYYY')

let QuickSearchContextToken = '';
let programname = ''
let redirectReceiptComponentTo = ''
let SAFMembership = ''
let NESAMembership = ''
let RENEW_NESAMembership = ''
let adminNESAMembership = ''
let BULK_Membership = ''
let GiftMembership = ''
let PurchasingPerson = []
let MembershipAmountPaid = ''
let Preference_value = {}
let Preference_Name = ''
let Preference_Type = ''
let Preference_column = []
let InitPaymentResponse = {}
let advacnedSearchFormData;

const ESB_PERSONS = `${ESB_URL}/persons/`
const ESB_REGISTRATIONS = `${ESB_URL}/registrations/registrations/`
const ESB_REGISTRATIONS_1 = `${ESB_URL}/registrations/`
const ESB_ORGANIZATIONS = `${ESB_URL}/organizations/`
const ESB_LOOKUP = `${ESB_URL}/lookups/`
const CORE_LOOKUP = `${CORE_URL}/api/lookups/`
const CORE_PERSON_PROFILES = `${CORE_URL}/api/v2/profiles`
//API URLS
const LOGIN_URL = `${AUTH_URL}/api/users/`;
const QUICK_SEARCH_INSTANCE_URL = `${MYST_URL}/mystrpt/WebReport/Output/proxy.aspx?Method=CreateReportInstance&ReportCode=NESAAlumniSearch&ResponseType=@json`;
const QUICK_SEARCH_URL = `${MYST_URL}/mystrpt/WebReport/Output/proxy.aspx?`;
const QUICK_SEARCH_SORT_URL = `${MYST_URL}/mystrpt/WebReport/Output/proxy.aspx?Method=RefreshReport`;
const DOWNLOAD_URL = `${MYST_URL}/mystrpt/WebReport/Output/proxy.aspx?`;
const COMPLETE_COLUMN_LIST_URL = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=GetCompleteColumnList`;
const DICTIONARY_COLUMN_LIST = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=GetColumnDictionary`;
const GET_PREFERENCE_LIST = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=GetAlumniReportPreferenceList`;
const DELETE_PREFERENCE_LIST = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=DeleteAlumniReportPreference`;
const SAVE_PREFERENCE_LIST = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=UpdateAlumniReportFilterList`;
const SAVE_COLUMN_LIST = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=UpdateAlumniReportColumnList`;
const RUN_PREFERENCE_LIST = `${MYST_URL}/mystrpt/WebReport/Output/proxy.aspx?Method=CreateReportFileOutputFromContext&`;
const GET_PREFERENCE_DATA = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteScriptSet&ScriptSetCode=NESAAPI&ScriptCode=GetPreferenceData`;

const CREATE_REPORT_INSTANCE = `${MYST_URL}/mystrpt/webscript/output11/proxy.aspx?Method=ExecuteContainerAPI&Container=NESAAlumniReport&API=CreateReportInstance`;
const GENERATE_REPORT = `${MYST_URL}/mystrpt/webscript/output11/proxy.aspx?Method=ExecuteContainerAPI&Container=NESAAlumniReport&API=GenerateReport`;
const GENERATE_REPORT_GET_COLUMNS = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteContainerAPI&Container=NESAAlumniReport&API=GetColumnNames`;


const CHASE_INIT_TRANSACTION = `${PAYMENY_URL}/api/payment/initTransaction`
const VALIDATE_TRANSACTION = `${PAYMENY_URL}/api/payment/validateTransaction`
const GET_OCCUPATION = `${ESB_URL}/lookups/person/occupations`
const GET_COUNTRIES = `${ESB_URL}/lookups/address/countries`
const GET_SOCIALMEDIAS = `${ESB_URL}/lookups/communications/socialMedia`
const GET_PHONE_COUNTRY_CODE = `${ESB_URL}/lookups/communications/phoneCountryCodes`
const GET_STATES = `${ESB_URL}/lookups/address/states`
const GET_ETHNICITIES = `${ESB_URL}/lookups/person/ethnicities`
const GET_MARITALSTATUS = `${ESB_URL}/lookups/person/maritalStatuses`
const GET_NESA_LEVELS = `${ESB_URL}/lookups/alumni/nesaMembershipLevels`
const GET_SAF_LEVELS = `${ESB_URL}/lookups/alumni/alumniMembershipLevels`
const GET_ADDRESS_TYPES = `${ESB_URL}/lookups/address/addressTypes`
const GET_GENDER = `${ESB_URL}/lookups/person/genders`
const GET_PREFIX = `${ESB_URL}/lookups/person/titlePrefixes`
const GET_SUFFIX = `${ESB_URL}/lookups/person/nameSuffixes`
const GET_COMMUNICATION_TYPES = `${ESB_URL}/lookups/communications/communicationTypes`
const GET_PRODUCT_PRICE = `${ESB_URL}/lookups/productPricing`
const MELISSA_ADDRESS = `https://expressentry.melissadata.net/web/ExpressAddress?line1=`
const NESA_BULK = `${ESB_URL}/registrations/v2/addReg/bulkNESA`
const ADD_NESA_NON_REVENUE_MEMBERSHIP = `${ESB_URL}/registrations/v2/NESA/nonRevenue`
//const GET_PENDING_MEMBERSHIPS = `${ESB_URL}/organizations/F3A77C78-EE20-474E-9219-D53400753B29/registrations?orgLevel=self&statusId=4&typeId=10%20`
const GET_PENDING_MEMBERSHIPS = `${ESB_URL}/organizations/v2/NESAregistrations?currentStatusId=4`
const GET_PROCESSED_MEMBERSHIPS = `${ESB_URL}/organizations/v2/NESAregistrations?currentStatusId=21`
const GET_DENIED_MEMBERSHIPS = `${ESB_URL}/organizations/v2/NESAregistrations?currentStatusId=20`

const ALUMNI_REGISTARTION = `${ESB_URL}/registrations/registrations/alumni`
//const ALUMNI_REGISTARTION = `https://apitest.scouting.org/registrations/registrations/alumni`
const ONLINE_REGISTRATIONS = `${ESB_URL}/registrations/`
const ONLINE_REGISTRATIONS_V2 = `${ESB_URL}/registrations/v2/`
const ADULT_ADVANCEMENTS = `${ESB_URL}/advancements/adult/`
// const GET_RANKS = `${ESB_URL}/advancements/ranks/`
const YOUTH_ADVANCEMENTS = `${ESB_URL}/advancements/v2/youth/`
const MYST_LOOKUP_URL = `${MYST_URL}/api/lookups/`;
const LOGIN_WITH_GOOGLE = `${AUTH_URL}/api/users/self_72254a8e-1440-11e9-ab14-d663bd873d93/sessions/current`;
const DOWNLOAD_NESAMEMBERSHIP = `${ESB_URL}/organizations/v2/NESAMembershipDownload`;
const SPARK_OPPORTUNITY_FORM = `${ESB_URL}/persons/v2/alumniNeedHelpDocument`;

const GET_PROMOCODES = `${ESB_URL}/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes`;

const ORDER_SOURCE_LOOKUP = `${ESB_URL}/lookups/registrations/orderSource`
const BSA_ORDER_TYPE_LOOKUP = `${ESB_URL}/lookups/registrations/bsaOrderType`

const GET_NESA_MEMBERSHIP = `${ESB_URL}/persons/v2`
const GET_POSITION_TYPE = `${ESB_URL}/organizations/v2/`
const GET_RANKS = `${ESB_URL}/lookups/advancements/ranks`
const COMMUNITY_ORG_TYPES_API = `${MYST_URL}/vim2/WebScript/Output/proxy.aspx?Method=ExecuteContainerAPI&Container=NESAAlumniReport&CommunityOrganizationCategoryCode=1&API=GetCommunityOrgTypes`
const REFRESH_SESSION = `${AUTH_URL}/api/users/auth/refresh`;
const LOGOUT_URL = `${AUTH_URL}/api/users/logout`;
const SOCIAL_LOGIN_URL = `${AUTH_URL}/api/users/auth/social`;

const NationalGUID = "F3A77C78-EE20-474E-9219-D53400753B29"
// Bumped by login() and refreshSession() at the start of each attempt. Each call
// captures its own id and checks it's still current before applying any
// localStorage/redirect side effects, so a slower, older authentication request
// (e.g. a silent /refresh) can never overwrite a newer one's result (e.g. a
// manual login that completed first).
let authAttemptId = 0;
let token, personGUID;
//PersonGUID and Token
if (localStorage.getItem('user')) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    token = loggedinUser.token;
    personGUID = loggedinUser.personGuid;
}
// The updatePrivacyOptions_And_VisibleOldPrivacySettings function updates the old privacy settings to be visible for other alumni, if it was set to hidden by default. If it is hidden, the alumniProfile API will return an Unauthorized error. Additionally, it updates the new privacy options.

export function updatePrivacyOptions_And_VisibleOldPrivacySettings(updatePrivacyOptions, alumniPrivacySettings_Date_ExtendedProfileId, oldPrivacySettings) {
    return function (dispatch) {
        if (oldPrivacySettings) {
            dispatch(updatePrivacySettings( oldPrivacySettings.extendedProfileId, '0'))
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(errorData => {
                            if (response.status == 422) {
                                Modal.error({
                                    className: "ErrorModal",
                                    title: 'Error',
                                    content: 'Please try again...',
                                });
                            }
                            return Promise.reject({
                                status: response.status,
                                statusText: response.statusText,
                                errorData: errorData
                            });
                        });
                    }
                    return response.json();
                })
                .then(status => {
                    // Check if oldPrivacySettings is an object
                    let isUpdatedOldPrivacySettingsToVisible = typeof oldPrivacySettings === 'object';
                    dispatch(getOrUpdateAlumniPrivacyOptions(updatePrivacyOptions, alumniPrivacySettings_Date_ExtendedProfileId, isUpdatedOldPrivacySettingsToVisible));
                })
                .catch(({ errorData }) => {
                    Sentry.captureException(new Error((errorData && errorData.message) || "API Error"), { extra: { api: 'updatePrivacyOptions_And_VisibleOldPrivacySettings', errorData } });
                    notification.open({
                        message: errorData.message ? `${errorData.message}` : "Error",
                        description: `${errorData.errorCode} ${errorData.errorDesc}`,
                        icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                    });
                    console.log(errorData);
                });

        }
    }

}

export function getOrUpdateAlumniPrivacyOptions(personGuid, updatePrivacyOptions, extendedProfileId, isUpdatedOldPrivacySettingsToVisible) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;

    const options = {
        method: updatePrivacyOptions ? 'POST' : 'GET',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        }
    };

    if (updatePrivacyOptions) {
        // To remove the 'confirmationBox' property from the updatePrivacyOptions object:
        delete updatePrivacyOptions.confirmationBox

        //To remove the 'null' values
        const filteredPrivacyOptions = {};
        for (const key in updatePrivacyOptions) {
            if (updatePrivacyOptions.hasOwnProperty(key) && updatePrivacyOptions[key] != null) {
                filteredPrivacyOptions[key] = updatePrivacyOptions[key];
            }
        }

        options.body = JSON.stringify(filteredPrivacyOptions);
    }
    return function (dispatch) {
        if (updatePrivacyOptions) dispatch(requestToUpdateAlumniPrivacyOptions());
        else dispatch(requestAlumniPrivacyOptions());
        fetch(`${ESB_PERSONS}${personGUID}/alumniSettings/options`, options)
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        return Promise.reject({
                            status: response.status,
                            statusText: response.statusText,
                            errorData: errorData
                        });
                    });
                }
                return response.json();
            })
            .then(alumniSettings => {
                if (updatePrivacyOptions) {
                    dispatch(getOrUpdateAlumniPrivacyOptions(personGuid));
                    // AAG-1217: only update the privacy settings date when the caller has the alum's date record
                    if (extendedProfileId) dispatch(UpdatePrivacySettingsDate(extendedProfileId))
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: "Privacy Settings Updated successfully!",
                        onOk() {
                            isUpdatedOldPrivacySettingsToVisible && dispatch(getProfileInfo(personGUID, true))
                        }
                    });
                } else dispatch(receivedAlumniPrivacyOptions(alumniSettings));
            })
            .catch(({ errorData }) => {
                Sentry.captureException(new Error(`${(errorData && (errorData.message || errorData.errorDesc)) || "API Error"} - ${`${ESB_PERSONS}${personGUID}/alumniSettings/options`}`), { extra: { api: `${ESB_PERSONS}${personGUID}/alumniSettings/options`, errorData } });
                notification.open({
                    message: errorData.message ? `${errorData.message}` : "Error",
                    description: `${errorData.errorCode} ${errorData.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(errorData);
                if (updatePrivacyOptions) dispatch(failedToUpdateAlumniPrivacyOptions());
                else dispatch(failedToGetAlumniPrivacyOptions());
            });
    }
}
const requestAlumniPrivacyOptions = () => {
    return {
        type: ACTIONTYPES.REQUESTING_ALUMNI_PRIVACY_OPTIONS,
    }
}
const receivedAlumniPrivacyOptions = (alumniSettings) => {
    return {
        type: ACTIONTYPES.RECEIVED_ALUMNI_PRIVACY_OPTIONS,
        alumniSettings
    }
}
const failedToGetAlumniPrivacyOptions = () => {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_ALUMNI_PRIVACY_OPTIONS,

    }
}

const requestToUpdateAlumniPrivacyOptions = () => {
    return {
        type: ACTIONTYPES.UPDATING_ALUMNI_PRIVACY_OPTIONS,
    }
}
const updatedAlumniPrivacyOptions = () => {
    return {
        type: ACTIONTYPES.UPDATED_ALUMNI_PRIVACY_OPTIONS,
    }
}
const failedToUpdateAlumniPrivacyOptions = () => {
    return {
        type: ACTIONTYPES.FAILED_TO_UPDATE_ALUMNI_PRIVACY_OPTIONS,

    }
}

export function sentSparkOpportunityFormToMail(values, imageUrl) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(sending_SparkOpportunityForm());
        fetch(SPARK_OPPORTUNITY_FORM, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "name": values.name,
                "date": values.date,
                "computerType": values.computerType,
                "browser": values.browser,
                "areaOfConcern": values.areaOfConcern,
                "typeOfIssue": values.typeOfIssue,
                "briefDescription": values.briefDescription,
                // "fileAttachment": imageUrl,
                "senderEmail": values.email,
                "senderTelephone": values.phone,
                "memberId": values.memberID
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(response => {
                dispatch(sentSuccessfully_SparkOpportunityForm(response.message));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${SPARK_OPPORTUNITY_FORM}`), { extra: { api: SPARK_OPPORTUNITY_FORM, error } });
                console.log(error);
                dispatch(sending_Failed_SparkOpportunityForm());
            });
    }
}
const sending_SparkOpportunityForm = () => {
    return {
        type: ACTIONTYPES.SENDING_SPARK_OPPORTUNITY_FORM,
    }
}
const sentSuccessfully_SparkOpportunityForm = (message) => {
    return {
        type: ACTIONTYPES.SUCCESSFULLY_SENT_SPARK_OPPORTUNITY_FORM,
        response: message
    }
}
const sending_Failed_SparkOpportunityForm = () => {
    return {
        type: ACTIONTYPES.FAILED_TO_SENT_SPARK_OPPORTUNITY_FORM,

    }
}

export function UpdatePrivacySettingsDate(extendedProfileId, needToRedirect, redirectTo, oldPrivacySettings) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let url = '', method = '', data = {}
    url = ESB_PERSONS + personGUID + `/alumniSettings`
    method = 'POST'
    if (extendedProfileId == '') {
        data = {
            "alumniPrivacySettingsDate": {
                "privacySettingsDate": today
            }
        }
    } else {
        data = {
            "alumniPrivacySettingsDate": {
                "extendedProfileId": Number(extendedProfileId),
                "privacySettingsDate": today
            }
        }
    }
    return function (dispatch) {
        dispatch(requestToUpdateAlumniPrivacyOptions());
        if (typeof oldPrivacySettings === 'object') {
            dispatch(updatePrivacySettings(oldPrivacySettings.extendedProfileId, '0'))
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(errorData => {
                            if (response.status == 422) {
                                Modal.error({
                                    className: "ErrorModal",
                                    title: 'Error',
                                    content: 'Please try again...',
                                });
                            }
                            return Promise.reject({
                                status: response.status,
                                statusText: response.statusText,
                                errorData: errorData
                            });
                        });
                    }
                    return response.json();
                })
                .then(status => {
                })
                .catch(({ errorData }) => {
                    Sentry.captureException(new Error((errorData && errorData.message) || "API Error"), { extra: { api: 'UpdatePrivacySettingsDate', errorData } });
                    notification.open({
                        message: errorData.message ? `${errorData.message}` : "Error",
                        description: `${errorData.errorCode} ${errorData.errorDesc}`,
                        icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                    });
                    console.log(errorData);
                });
        }
        return fetch(url, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Please try again...',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(updatedAlumniPrivacyOptions());
                if (needToRedirect) {
                    localStorage.removeItem('privacy-setting');
                    redirectTo == '/my-profile' ? history.replace(redirectTo) : dispatch(redirectDashboard())
                }
                return true;
            })
            .catch(error => {
                dispatch(failedToUpdateAlumniPrivacyOptions());
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${url}`), { extra: { api: url, error } });
                console.log(error);
                return false;
            });
    }
}
export function getOrderSourceLookups() {

    return function (dispatch) {
        // dispatch(req_Getting_OrderSource());
        fetch(ORDER_SOURCE_LOOKUP, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(data => {
                dispatch(recived_OrderSource(JSON.parse(data)));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ORDER_SOURCE_LOOKUP}`), { extra: { api: ORDER_SOURCE_LOOKUP, error } });
                console.log(error);
                Modal.error({
                    className: "ErrorModal",
                    title: 'Failed',
                    content: 'Order Source Lookup Failed',
                })
                // dispatch(failedtoGetOrderSource(error));
            });
    }
}
// const req_Getting_OrderSource = () => {
//     return {
//         type: ACTIONTYPES.GETTING_ORDER_SOURCE,
//     }
// }
const recived_OrderSource = (orderSource) => {
    return {
        type: ACTIONTYPES.GOT_ORDER_SOURCE_SUCCESSFULLY,
        orderSource
    }
}
// const failedtoGetOrderSource = (err) => {
//     return {
//         type: ACTIONTYPES.ORDER_SOURCE_FAILED,
//         response: err
//     }
// }

export function getBSAOrderTypeLookups() {

    return function (dispatch) {
        // dispatch(req_Getting_BSAOrderType());
        fetch(BSA_ORDER_TYPE_LOOKUP, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(data => {
                dispatch(recived_BSAOrderType(JSON.parse(data)));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${BSA_ORDER_TYPE_LOOKUP}`), { extra: { api: BSA_ORDER_TYPE_LOOKUP, error } });
                console.log(error);
                Modal.error({
                    className: "ErrorModal",
                    title: 'Failed',
                    content: 'Scouting America Order Type Lookup Failed',
                })
                // dispatch(failedtoGetBSAOrderType(error));
            });
    }
}
// const req_Getting_BSAOrderType = () => {
//     return {
//         type: ACTIONTYPES.GETTING_BSA_ORDER_TYPE,
//     }
// }
const recived_BSAOrderType = (BSA_OrderType) => {
    return {
        type: ACTIONTYPES.GOT_BSA_ORDER_TYPE_SUCCESSFULLY,
        BSA_OrderType
    }
}
// const failedtoGetBSAOrderType = (err) => {
//     return {
//         type: ACTIONTYPES.BSA_ORDER_TYPE_FAILED,
//         response: err
//     }
// }


export function GetPromoCodes(searchByPromoName) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let GET_PROMOCODES_URL = searchByPromoName ? GET_PROMOCODES + '?promoCode=' + encodeURI(searchByPromoName) : GET_PROMOCODES;

    return function (dispatch) {
        searchByPromoName ? dispatch(req_Searching_PromoCode()) :
            dispatch(req_Getting_PromoCodes());
        fetch(GET_PROMOCODES_URL, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(text)
                    })
                    // return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(promoCodes => {
                dispatch(recived_PromoCodes(JSON.parse(promoCodes)));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PROMOCODES_URL}`), { extra: { api: GET_PROMOCODES_URL, error } });
                console.log(error);
                let ParseErr = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    title: `${ParseErr.errorCode} ${ParseErr.message}`,
                    content: `${ParseErr.errorDesc}`,
                    onOk() {
                        dispatch(redirectDashboard());
                    }
                })
                if (!searchByPromoName) {
                    dispatch(failedtoGetPromocodes(ParseErr.errorDesc));
                }
            });
    }
}
const req_Searching_PromoCode = () => {
    return {
        type: ACTIONTYPES.SEARCH_PROMOCODE_LOADING,
    }
}
const req_Getting_PromoCodes = () => {
    return {
        type: ACTIONTYPES.GET_PROMOCODE_LOADING,
    }
}
const recived_PromoCodes = (promoCodes) => {
    return {
        type: ACTIONTYPES.GOT_PROMOCODE_SUCCESSFULLY,
        promoCodes
    }
}
const failedtoGetPromocodes = (err) => {
    return {
        type: ACTIONTYPES.GET_PROMOCODE_ERROR,
        response: err
    }
}

export function AddPromoCodes(values, promoCodeSource) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(req_Adding_PromoCodes());
        fetch(ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "promoCode": values.PromoCode,
                "description": values.promoDes,
                "promoCodeSource": promoCodeSource,
                "amountTypeId": Number(values.AmountTypeId),
                "value": values.PromoValue,
                "productTypeId": values.typeID,
                "productProgramId": 4,
                "quantityAllowed": values.quantityAllowed,
                "effectiveDt": moment(values.effectiveDate).format('YYYY-MM-DDTHH:mm:ss'),
                "expiryDt": moment(values.expiryDate).format('YYYY-MM-DDTHH:mm:ss')
            }
            )
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(text)
                    })
                    // return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(result => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Promo Code added successfully!",
                    onOk() {
                        history.push('/Promo-Code-Portal')
                    }
                });
                dispatch(added_PromoCode(JSON.stringify(result.message)));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes`}`), { extra: { api: ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes`, error } });
                console.log(error);
                let ParseErr = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    title: 'Add Promo Code action Failed',
                    content: `${ParseErr.errorCode}  ${ParseErr.errorDesc}`,
                })
                dispatch(failedtoAddPromocode(ParseErr.errorDesc));
            });
    }
}
const req_Adding_PromoCodes = () => {
    return {
        type: ACTIONTYPES.ADD_PROMOCODE_LOADING,
    }
}
const added_PromoCode = (message) => {
    return {
        type: ACTIONTYPES.ADDED_PROMOCODE_SUCCESSFULLY,
        message
    }
}
const failedtoAddPromocode = (err) => {
    return {
        type: ACTIONTYPES.ADD_PROMOCODE_ERROR,
        err
    }
}

export function updatePromoCode(values, promoCodeId, isFutureEffectiveDate) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let payload = {}
    if (isFutureEffectiveDate) {
        payload = {
            "promoCode": values.PromoCode,
            "description": values.promoDes,
            "amountTypeId": Number(values.AmountTypeId),
            "value": values.PromoValue,
            "productTypeId": values.typeID,
            "productProgramId": 4,
            "quantityAllowed": values.quantityAllowed,
            "effectiveDt": moment(values.effectiveDate).format('YYYY-MM-DDTHH:mm:ss'),
            "expiryDt": moment(values.expiryDate).format('YYYY-MM-DDTHH:mm:ss')
        }
    } else {
        payload = {
            "description": values.promoDes,
            "quantityAllowed": values.quantityAllowed,
            "expiryDt": moment(values.expiryDate).format('YYYY-MM-DDTHH:mm:ss')
        }
    }
    return function (dispatch) {
        dispatch(req_update_PromoCode());
        fetch(ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(text)
                    })
                    // return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(response => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "PromoCode updated successfully!",
                    onOk() {
                        history.push('/Promo-Code-Portal')
                    }
                });
                dispatch(updated_PromoCode(response.message));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`}`), { extra: { api: ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`, error } });
                console.log(error);
                let ParseErr = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    title: 'Update Promo Code action Failed',
                    content: `${ParseErr.errorCode}  ${ParseErr.errorDesc}`,
                })
                dispatch(failedtoUpdatePromocode(ParseErr.errorDesc));
            });
    }
}
const req_update_PromoCode = () => {
    return {
        type: ACTIONTYPES.UPDATE_PROMOCODE_LOADING,
    }
}
const updated_PromoCode = (response) => {
    return {
        type: ACTIONTYPES.UPDATED_PROMOCODE_SUCCESSFULLY,
        response
    }
}
const failedtoUpdatePromocode = (err) => {
    return {
        type: ACTIONTYPES.UPDATE_PROMOCODE_ERROR,
        err
    }
}

export function deletePromoCode(promoCodeId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(req_deleting_PromoCodes());
        fetch(ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => {
                        throw new Error(text)
                    })
                    // return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(response => {
                dispatch(deleted_PromoCode(response.message));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`}`), { extra: { api: ESB_URL + `/organizations/v2/F3A77C78-EE20-474E-9219-D53400753B29/promoCodes/${promoCodeId}`, error } });
                console.log(error);
                let ParseErr = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    title: 'Delete Promo Code action Failed',
                    content: `${ParseErr.errorCode}  ${ParseErr.errorDesc}`,
                })
                dispatch(failedtoDeletePromocode(ParseErr.errorDesc));
            });
    }
}
const req_deleting_PromoCodes = () => {
    return {
        type: ACTIONTYPES.DELETE_PROMOCODE_LOADING,
    }
}
const deleted_PromoCode = (response) => {
    return {
        type: ACTIONTYPES.DELETED_PROMOCODE_SUCCESSFULLY,
        response
    }
}
const failedtoDeletePromocode = (err) => {
    return {
        type: ACTIONTYPES.DELETE_PROMOCODE_ERROR,
        err
    }
}

export function DownloadNESAMembership(page, perpage, sort, membershipType, values) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let url = "", StatusId = ""
    let startDate = ''
    let endDate = ''

    let sortOrder = '&sortOrder=des'
    if (sort == 'ascend') sortOrder = '&sortOrder=asc'

    if (membershipType == 'pending') {
        url = GET_PENDING_MEMBERSHIPS;
        StatusId = '4'
        startDate = moment(values.pendingCSV_downloadFrom).format('YYYY-MM-DD')
        endDate = moment(values.pendingCSV_downloadTo).format('YYYY-MM-DD')
    } else if (membershipType == 'processed') {
        url = GET_PROCESSED_MEMBERSHIPS;
        StatusId = '21'
        startDate = moment(values.processedCSV_downloadFrom).format('YYYY-MM-DD')
        endDate = moment(values.processedCSV_downloadTo).format('YYYY-MM-DD')
    } else if (membershipType == 'denied') {
        url = GET_DENIED_MEMBERSHIPS;
        StatusId = '20'
        startDate = moment(values.deniedCSV_downloadFrom).format('YYYY-MM-DD')
        endDate = moment(values.deniedCSV_downloadTo).format('YYYY-MM-DD')
    }

    return function (dispatch) {
        dispatch(requestNESAmembershipDownloads());
        fetch(url + '&page=' + page + '&perPage=' + perpage + sortOrder + '&startDate=' + startDate + '&finishDate=' + endDate, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(pendingmembership => {
                if (pendingmembership.totalNumberOfRecords >= perpage) {
                    dispatch(csvMaximumDownloaded());
                }

                if (pendingmembership.totalNumberOfRecords <= perpage) {
                    fetch(`${DOWNLOAD_NESAMEMBERSHIP}?page=1&perPage=${perpage}&currentStatusId=${StatusId}&startDate=${startDate}&finishDate=${endDate}`, {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            "Content-Type": "application/json",
                            "authorization": "Bearer " + token
                        },
                        body: JSON.stringify({})
                    })
                        .then(response => {
                            if (!response.ok) {
                                return Promise.reject(response.statusText);
                            }
                            return response.text();
                        })
                        .then(response => {
                            // dispatch(receiveNESAmembershipDownloads());
                            downloadCSVFunction(response, `${membershipType}Membership`)
                            // window.open("data:text/csv;charset=utf-8," + escape(response))
                            // dispatch(receiveNESAmembershipDownloads(actions,response));
                            dispatch(receiveNESAmembershipDownloads());
                        })
                        .catch(error => {
                            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${DOWNLOAD_NESAMEMBERSHIP}?page=1&perPage=${perpage}&currentStatusId=${StatusId}&startDate=${startDate}&finishDate=${endDate}`}`), { extra: { api: `${DOWNLOAD_NESAMEMBERSHIP}?page=1&perPage=${perpage}&currentStatusId=${StatusId}&startDate=${startDate}&finishDate=${endDate}`, error } });
                            console.log(error);
                        });
                }
            })
    }
}

const requestNESAmembershipDownloads = () => {
    return {
        type: ACTIONTYPES.DOWNLOADING_NESA_MEMBERSHIP,
    }
}
const receiveNESAmembershipDownloads = () => {
    return {
        type: ACTIONTYPES.DOWNLOADED_NESA_MEMBERSHIP,

    }
}
const csvMaximumDownloaded = () => {
    return {
        type: ACTIONTYPES.MAXIMUM_CSVRECORDS_REACHED
    }
}

export const closeCsvMaximumDownloaded = () => {
    return {
        type: ACTIONTYPES.MAXIMUM_CSVRECORDS_REACHED_ClOSE
    }
}



export const changeUpdateColumnState = (value) => {
    if (value == 'updating') {
        return {
            type: ACTIONTYPES.UPDATING_COLUMN,

        }
    } else {
        return {
            type: ACTIONTYPES.UPDATED_COLUMN,

        }
    }

}

// export function DownloadNESAMembership() {
//     const loggedinUser = JSON.parse(localStorage.getItem('user'))
//     let token = loggedinUser.token;
//     let url = DOWNLOAD_NESAMEMBERSHIP;

//     return function (dispatch) {
//         dispatch(requestNESAmembershipDownloads());
//         fetch(url, {
//             method: 'POST',
//             credentials: 'include',
//             headers: {
//                 "Content-Type": "application/json",
//                 "authorization": "Bearer " + token
//             },
//             body: JSON.stringify({})
//         })
//             .then(response => {
//                 if (!response.ok) {
//                     return Promise.reject(response.statusText);
//                 }
//                 return response.text();
//             })
//             .then(response => {
//                 dispatch(receiveNESAmembershipDownloads(response));
//             })
//             .catch(error => {
//                 console.log(error);
//             });
//     }
// }
// const requestNESAmembershipDownloads = () => {
//     return {
//         type: ACTIONTYPES.DOWNLOADING_NESA_MEMBERSHIP,
//     }
// }
// const receiveNESAmembershipDownloads = (NESADownloads) => {
//     return {
//         type: ACTIONTYPES.DOWNLOADED_NESA_MEMBERSHIP,
//         NESADownloads
//     }
// }

export function refreshSession(showErrorOnFailure) {
    return function (dispatch) {
        const myAttemptId = ++authAttemptId;
        dispatch(showloading());
        fetch(REFRESH_SESSION, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Accept": "application/json; version = 1",
                "Content-Type": "application/json"
            },
            cache: "no-cache"
        })
        .then(async response => {
            const data = await response.json();

            if (!response.ok) {
                return Promise.reject(data);
            }

            return data;
        })
        .then(user => {
            if (myAttemptId !== authAttemptId) {
                // A newer login or SSO refresh attempt has started since this one
                // began - this response is stale, don't let it overwrite whatever
                // the newer attempt already established.
                return Promise.reject({ __staleAuthAttempt: true });
            }
            localStorage.setItem('user', JSON.stringify(user));
            // Marks this session as SSO-origin so Root knows to keep
            // re-validating it via /refresh on every page reload.
            localStorage.setItem('viaSso', 'true');

            let personGUID = user.personGuid;
            let token = user.token;

            return fetch(ESB_PERSONS + 'v2/' + personGUID + '/personprofile', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "authorization": "Bearer " + token
                },
                cache: "no-cache"
            });
        })
        .then(async response => {
            const data = await response.json();

            if (!response.ok) {
                return Promise.reject(data);
            }

            return data;
        })
        .then(profileinfo => {
            if (myAttemptId !== authAttemptId) {
                return Promise.reject({ __staleAuthAttempt: true });
            }
            dispatch(receiveprofileinfo(profileinfo));

            var alumnitoc = profileinfo.extendedProfile.filter(function (obj) {
                return obj.attributeId == "19";
            });

            if (alumnitoc.length == 0) {
                history.push('/terms-conditions');
            } else {
                var acceptedtoc = alumnitoc[0].attributeVal;
                var isaccepted = moment(today).diff(moment(acceptedtoc), 'years');

                if (isaccepted >= 1) {
                    history.push('/terms-conditions');
                } else if (history.location.pathname === '/') {
                    // Only force a dashboard redirect when the reload actually
                    // landed on the bare login route. Reloading an already-valid
                    // protected page (e.g. /list-and-search after being idle and
                    // returning to the tab) used to unconditionally bounce
                    // admin-capable users to redirectDashboard()'s fixed
                    // destination here, discarding whatever page/results they
                    // had open - PrivateAdminRoute/PrivateAlumniRoute already
                    // re-validate and keep the user on their current page.
                    dispatch(redirectDashboard());
                }
            }
            dispatch(hideloading());
        })
        .catch(error => {
            if (error && error.__staleAuthAttempt) {
                // Superseded by a newer attempt - its own outcome already
                // applied (or will apply); nothing to do for this one.
                return;
            }

            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/personprofile'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/personprofile', error } });
            console.log("Refresh Session Error:", error);

            dispatch(failure(error));
            dispatch(hideloading());

            if (!showErrorOnFailure) {
                // Direct, unauthenticated visit - a failed refresh is expected
                // here (no SSO session to check). Stay on the Login page
                // silently, no error UI.
                return;
            }

            var title = "Error";
            var content = "Please try again.";

            if (error.message) {
                title = error.message;
            }

            if (error.errors && error.errors.length > 0) {
                content = error.errors[0].message;
            }

            Modal.error({
                className: "ErrorModal",
                title: title,
                content: content,
                onOk() {
                    // We just confirmed the session is invalid - stop Login from
                    // immediately re-checking /refresh again on the navigation
                    // this triggers, which would otherwise just repeat this same
                    // failure right away.
                    localStorage.setItem('directoryLoggedOut', 'true');
                    // Clear the stale local session so Login's own componentDidMount
                    // doesn't see a leftover localStorage 'user' and immediately bounce
                    // back into a dashboard route instead of showing the login form.
                    dispatch(logout());
                }
            });
        });
    };
}

// Validates a Social Login (Google/Apple) with the auth server. Call this ONLY
// when the user is signing in via Social Login - never for normal username/
// password login. This is a separate, additive call alongside the existing
// social login flow (loginUserWithGoogle/loginUserWithApple below) - it does
// not replace or affect their own request/response handling.
export function validateSocialLogin(socialToken) {
    return function (dispatch) {
        fetch(SOCIAL_LOGIN_URL, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Accept": "application/json; version = 1",
                "authorization": "Bearer " + socialToken
            },
            cache: "no-cache"
        })
            .then(async response => {
                const data = await response.json().catch(() => null);

                if (!response.ok) {
                    return Promise.reject({ status: response.status, data });
                }

                return data;
            })
            .then(socialAuthResult => {
                console.log("Social login validated:", socialAuthResult);
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${SOCIAL_LOGIN_URL}`), { extra: { api: SOCIAL_LOGIN_URL, error } });
                console.log("Social Login API Error:", error);

                let title = "Error";
                let content = "Please try again.";

                switch (error && error.status) {
                    case 400:
                        title = "Invalid Request";
                        content = "The social login request was invalid.";
                        break;
                    case 401:
                        title = "Authentication Failed";
                        content = "Missing or invalid social login credentials.";
                        break;
                    case 403:
                        title = "Access Denied";
                        content = "This account is invalid or ineligible to sign in.";
                        break;
                    case 500:
                        title = "Server Error";
                        content = "A server error occurred while validating your social login. Please try again later.";
                        break;
                    case 503:
                        title = "Service Unavailable";
                        content = "Unable to validate your credentials with the identity provider. Please try again later.";
                        break;
                    default:
                        break;
                }

                Modal.error({
                    className: "ErrorModal",
                    title: title,
                    content: content
                });
            });
    };
}

//LoginWithApple
export function loginUserWithApple(response) {
    return function (dispatch) {
        dispatch(showloading());
        fetch(LOGIN_WITH_GOOGLE, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Accept": "application/json; version = 1",
                "Content-Type": "application/json",
                "authorization": "Bearer " + response
            },
            cache: "no-cache"
        })
        // /social API not needed for now - temporarily commented out.
        // fetch(SOCIAL_LOGIN_URL, {
        //     method: 'GET',
        //     credentials: 'include',
        //     headers: {
        //         "Accept": "application/json; version = 1",
        //         "authorization": "Bearer " + response
        //     },
        //     cache: "no-cache"
        // })
            .then(async response => {
                // Parse the body regardless of status so a failure (403 or
                // otherwise) carries the API's actual error message through
                // to the outer catch, instead of just the generic statusText.
                const data = await response.json().catch(() => null);

                if (!response.ok) {
                    return Promise.reject(data || response.statusText);
                }

                return data;
            })
            .then(user => {
                localStorage.setItem('user', JSON.stringify(user));
                let personGUID = user.personGuid;
                let token = user.token;
                fetch(ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": "Bearer " + token
                    },
                    cache: "no-cache"
                })
                    .then(response => {
                        if (!response.ok) {
                            return Promise.reject(response.statusText);
                        }
                        return response.json();
                    })
                    .then(profileinfo => {
                        dispatch(receiveprofileinfo(profileinfo));
                        var alumnitoc = profileinfo.extendedProfile.filter(obj => obj.attributeId == "19");
                        if (alumnitoc.length == 0) {
                            history.push('/terms-conditions')
                        } else {
                            var acceptedtoc = alumnitoc[0].attributeVal
                            var isaccepted = moment(today).diff(moment(acceptedtoc), 'years')
                            isaccepted >= 1 ? history.push('/terms-conditions') : dispatch(redirectDashboard())
                        }

                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                        dispatch(hideloading());
                        if (error == "Forbidden") {
                            dispatch(logout());
                            // dispatch(sessionTimeOut())
                        }
                        else {
                            notification.open({
                                message: error.errorCode ? error.errorCode : "Error",
                                description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                                icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                            });
                        }
                        console.log(error);
                    });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                dispatch(failure(error));
                dispatch(hideloading());

                var title = "Login Failed";
                var content = "Please try again.";

                if (error && error.message) {
                    title = error.message;
                }

                if (error && error.errors && error.errors.length > 0 && error.errors[0].message) {
                    content = error.errors[0].message;
                }

                Modal.error({
                    className: "ErrorModal",
                    title: title,
                    content: content,
                    onOk() {
                        history.push('/')
                    }
                })
            })
    }

    function request(user) {
        return {
            type: ACTIONTYPES.LOGIN_REQUEST,
            user
        }
    }
}

//LoginWithGooleUser
export function loginUserWithGoogle(response) {
    return function (dispatch) {
        // Login's render() now shows this as a blurred overlay + centered
        // spinner on top of the still-visible login page, not a full-page
        // replacement, so it's safe to signal loading here again.
        dispatch(showloading());
        fetch(LOGIN_WITH_GOOGLE, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Accept": "application/json; version = 1",
                "Content-Type": "application/json",
                "authorization": "Bearer " + response.tokenId
            },
            cache: "no-cache"
        })
        // /social API not needed for now - temporarily commented out.
        // fetch(SOCIAL_LOGIN_URL, {
        //     method: 'GET',
        //     credentials: 'include',
        //     headers: {
        //         "Accept": "application/json; version = 1",
        //         "authorization": "Bearer " + response.tokenId
        //     },
        //     cache: "no-cache"
        // })
            .then(async response => {
                // Parse the body regardless of status so a failure (403 or
                // otherwise) carries the API's actual error message through
                // to the outer catch, instead of just the generic statusText.
                const data = await response.json().catch(() => null);

                if (!response.ok) {
                    return Promise.reject(data || response.statusText);
                }

                return data;
            })
            .then(user => {
                localStorage.setItem('user', JSON.stringify(user));
                let personGUID = user.personGuid;
                let token = user.token;
                fetch(ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": "Bearer " + token
                    },
                    cache: "no-cache"
                })
                    .then(response => {
                        if (!response.ok) {
                            return Promise.reject(response.statusText);
                        }
                        return response.json();
                    })
                    .then(profileinfo => {
                        dispatch(receiveprofileinfo(profileinfo));
                        var alumnitoc = profileinfo.extendedProfile.filter(obj => obj.attributeId == "19");
                        if (alumnitoc.length == 0) {
                            history.push('/terms-conditions')
                        } else {
                            var acceptedtoc = alumnitoc[0].attributeVal
                            var isaccepted = moment(today).diff(moment(acceptedtoc), 'years')
                            isaccepted >= 1 ? history.push('/terms-conditions') : dispatch(redirectDashboard())
                        }

                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                        dispatch(hideloading());
                        if (error == "Forbidden") {
                            dispatch(logout());
                            // dispatch(sessionTimeOut())
                        }
                        else {
                            notification.open({
                                message: error.errorCode ? error.errorCode : "Error",
                                description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                                icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                            });
                        }
                        console.log(error);
                    });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                dispatch(failure(error));
                dispatch(hideloading());

                var title = "Login Failed";
                var content = "Please try again.";

                if (error && error.message) {
                    title = error.message;
                }

                if (error && error.errors && error.errors.length > 0 && error.errors[0].message) {
                    content = error.errors[0].message;
                }

                Modal.error({
                    className: "ErrorModal",
                    title: title,
                    content: content,
                    onOk() {
                        history.push('/')
                    }
                })
            })
    }

    function request(user) {
        return {
            type: ACTIONTYPES.LOGIN_REQUEST,
            user
        }
    }
}

//login 
export function login(username, password, returnurl) {
    return function (dispatch) {
        const myAttemptId = ++authAttemptId;
        dispatch(request({
            username
        }));
        fetch(LOGIN_URL + username + `/authenticate`, {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: {
                "Accept": "application/json; version=2",
                "Content-Type": "application/json;charset=UTF-8"
            },
            body: JSON.stringify({
                password: password
            })
        })
            .then(async response => {
                // if (response.status == 403) { // AAG-771 Upon entering invalid credentials, two Login Failed Modals appeared.
                //     Modal.error({
                //         className: "ErrorModal",
                //         title: 'Login Failed',
                //         content: 'Please enter valid username and password',
                //     });
                // }
                // Parse the body regardless of status so a failure carries the
                // API's actual error message through to the outer catch, instead
                // of just the generic statusText.
                const data = await response.json().catch(() => null);

                if (!response.ok) {
                    return Promise.reject(data || response.statusText);
                }

                return data;
            })
            .then(user => {
                if (myAttemptId !== authAttemptId) {
                    // A newer login or SSO refresh attempt has started since this
                    // one began - don't let this now-stale response apply its
                    // session on top of whatever the newer attempt already did.
                    return Promise.reject({ __staleAuthAttempt: true });
                }
                localStorage.setItem('user', JSON.stringify(user));
                // A fresh, successful manual login overrides any prior explicit
                // logout/failed-login flag, mirroring how a fresh SSO handoff
                // already clears this flag above.
                localStorage.removeItem('directoryLoggedOut');
                let personGUID = user.personGuid;
                let memberId = user.membership.memberId
                let token = user.token;
                if (returnurl != '') {
                    //If Return URL added
                    history.push('/' + returnurl);
                } else {
                    // memoizedFetchPositions(memberId)
                    //     .then(positionsInfo => {
                    //         dispatch(receivepositionsinfo(positionsInfo));
                    //         if (positionsInfo && positionsInfo.length == 0)
                                // memoizedFetchRoleTypes(personGUID)
                                // })
                    memoizedFetchRoleTypes(personGUID, true)
                        .then(roles => {
                            memoizedFetchProfile(personGUID)
                                .then(profileinfo => {
                                    dispatch(receiveprofileinfo(profileinfo));
                                    var alumnitoc = profileinfo.extendedProfile.filter(obj => obj.attributeId == "19");
                                    let alumniPrivacyDate = profileinfo.extendedProfile.filter(obj => obj.attributeId == "25");

                                    // While logged in show toc page first and privacy setting page next
                                    if (alumnitoc.length == 0) {
                                        history.push('/terms-conditions')
                                    } else if (alumniPrivacyDate.length == 0) {
                                        history.push('/privacy-setting');
                                        localStorage.setItem('privacy-setting', true);
                                    } else {
                                        var acceptedtoc = alumnitoc[0].attributeVal;
                                        let isaccepted = acceptedtoc ? moment(today).diff(moment(acceptedtoc), 'years') : 0
                                        let acceptedPrivacyDate = moment(alumniPrivacyDate[0].attributeVal);
                                        if (isaccepted >= 1) {
                                            history.push('/terms-conditions')
                                        } else if (acceptedPrivacyDate) {
                                            let isPrivacyAccepted = acceptedPrivacyDate.diff(today, 'years');
                                            console.log('isPrivacyAccepted', isPrivacyAccepted);
                                            if ((isPrivacyAccepted >= 1) || moment(acceptedPrivacyDate).isBefore(ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE)) {
                                                history.push('/privacy-setting')
                                                localStorage.setItem('privacy-setting', true);
                                            } else dispatch(redirectDashboard(roles))
                                        }
                                        // if (moment(acceptedPrivacyDate).isBefore(ALUMNI_PRIVACY_SETTINGS_OPTIONS_DATE)) {
                                        //     alumniPrivacyDate[0].needToShowAlumniPrivacyOptionsPopup = true;
                                        //     console.log('alumniPrivacyDate[0]', alumniPrivacyDate[0]);
                                        //     const extendedProfileJSON = alumniPrivacyDate[0]
                                        //     localStorage.setItem('extendedProfile', JSON.stringify(extendedProfileJSON));
                                        //   }                                  
                                    }

                                })
                                .catch(error => {
                                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${LOGIN_URL + username + `/authenticate`}`), { extra: { api: LOGIN_URL + username + `/authenticate`, error } });
                                    if (error == "Forbidden") {
                                        dispatch(logout());
                                        // dispatch(sessionTimeOut())
                                    }
                                    else {
                                        notification.open({
                                            message: error.errorCode ? error.errorCode : "Error",
                                            description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                                            icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                                        });
                                    }
                                    console.log(error);
                                });
                        })
                        .catch(error => {
                            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${LOGIN_URL + username + `/authenticate`}`), { extra: { api: LOGIN_URL + username + `/authenticate`, error } });
                            if (error.data) {
                                // Use the error data from the API
                                if(error.data && error.data.errorDesc && error.data.errorDesc == 'JWT Session timed out'){
                                    dispatch(logout());
                                    console.log('LOGGED OUT');
                                }
                                Modal.error({
                                    className: "ErrorModal",
                                    title: `${error.data.errorCode} ${error.data.message}`,
                                    content: error.data.errorDesc || 'You do not have access to view this record!',
                                    onOk() {
                                        // console.log('LOGGED OUT');
                                    }
                                });
                            } else {
                                // Handle generic errors (e.g., non-JSON response or network issues)
                                Modal.error({
                                    className: "ErrorModal",
                                    title: `Error: ${error.status}`,
                                    content: error.message || 'An unexpected error occurred.',
                                    onOk() {
                                        dispatch(logout());
                                        console.log('LOGGED OUT');
                                    }
                                });
                            }
                        })
                }
            })
            .catch(error => {
                if (error && error.__staleAuthAttempt) {
                    // Superseded by a newer attempt - its own outcome already
                    // applied (or will apply); nothing to do for this one.
                    return;
                }

                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${LOGIN_URL + username + `/authenticate`}`), { extra: { api: LOGIN_URL + username + `/authenticate`, error } });
                dispatch(failure(error));

                var content = "Please enter valid username and password";

                if (error && error.message) {
                    content = error.message;
                }

                if (error && error.errors && error.errors.length > 0 && error.errors[0].message) {
                    content = error.errors[0].message;
                }

                Modal.error({
                    className: "ErrorModal",
                    title: 'Login Failed',
                    content: content,
                    onOk() {
                        // A rejected manual login must not leave the app silently
                        // authenticated as whatever (possibly different) user's
                        // session was already sitting in localStorage/the SSO
                        // cookie - clear it once the user acknowledges the
                        // failure, same as refreshSession()'s failure handler.
                        localStorage.setItem('directoryLoggedOut', 'true');
                        dispatch(logout());
                    }
                })
            })
    }

    function request(user) {
        return {
            type: ACTIONTYPES.LOGIN_REQUEST,
            user
        }
    }
}


export function accepttoc(profileinfo) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let data;
    let method = 'POST'
    let url = ESB_PERSONS + personGUID + `/alumniSettings`
    var alumnitoc = profileinfo.extendedProfile.filter(obj => obj.attributeId == "19");
    let alumniPrivacyDate = profileinfo.extendedProfile.filter(obj => obj.attributeId == "25");
    var alumniPrivacySettings = profileinfo.extendedProfile.filter(obj => obj.attributeId == "17");
    if (alumnitoc.length == 0) {
        method = 'POST'
        url = ESB_PERSONS + personGUID + `/alumniSettings`
        if (alumniPrivacySettings.length == 0) {
            data = {
                "alumniTermsAndConditions": {
                    "acceptDate": today
                },
                "alumniPrivacySettings": {
                    "alumniPrivacySettings": "100"
                }
            }
        } else {
            data = {
                "alumniTermsAndConditions": {
                    "acceptDate": today
                }
            }
        }
    } else {
        data = {
            "alumniTermsAndConditions": {
                "extendedProfileId": parseInt(alumnitoc[0].extendedProfileId),
                "acceptDate": today
            }
        }
    }

    return function (dispatch) {
        dispatch(reqAcceptTOC());
        fetch(url, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Please try again...',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                if (alumniPrivacyDate.length == 0) {
                    dispatch(getProfileInfo(personGUID, true))
                    history.push('/privacy-setting')
                    localStorage.setItem('privacy-setting', true);
                } else {
                    dispatch(redirectDashboard())
                    dispatch(recAcceptTOC());
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${url}`), { extra: { api: url, error } });
                console.log(error);
            });
    }
}

function reqAcceptTOC() {
    return {
        type: ACTIONTYPES.ACCEPTING_TOC,
    }
}

function recAcceptTOC(status) {
    return {
        type: ACTIONTYPES.ACCEPTED_TOC,
        status: status
    }
}

const memoizedGetRolesPositions = memoize(
    (memberId) => GetRolesPositions(memberId),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentMID] = lastArgs;
        const [newMID] = newArgs;
        return currentMID === newMID;
    });

export function GetRolesPositions(memberId) {
    let  MID = memberId, loggedinUser, token;
    if(memberId){
    loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
    token = loggedinUser.token || "";
    MID = loggedinUser.membership ? loggedinUser.membership.memberId : '';
}

    return fetch(`${ESB_PERSONS}v2/NESAPositionsDictionary?memberId=${MID}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Accept": "application/json; version=1",
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        },
        cache: "no-cache"
    }).then(response => {
        if (response.status === 403) {
            Modal.error({
                className: "ErrorModal",
                title: 'Login Failed',
                content: "Failed to Fetching User's Positions",
                onOk() {
                    history.push('/');
                }
            });
            return [];
        }
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    });
}

const getRoleAccessType = (access) => {
    let isadmin = false,
        isspecialist = false,
        isSuperAlumniAdmin = false,
        isCSTSupport = false,
        isCouncilCommittee = false,
        isAlumniAdmin = false,
        getCSTRoleOrg = null,
        panelView = "alumniTabView",
        redirectTo = "/alumni-dashboard";

    access.forEach(element => {
        // if (AdminAccess.includes(element.role)) {
            // isadmin = true;
            // panelView = "adminTabView";
            // redirectTo = "/admin-dashboard";
            
            if (element.role === 'Super Alumni Administrator' && (element.status === 'active' || element.status === 'Active')) {
                isadmin = true;
                isSuperAlumniAdmin = true;;
                panelView = "adminTabView";
                redirectTo = "/admin-dashboard";
            }
            else if (element.role === "Alumni Admin" && element.roleId === "783" && (element.status === 'active' || element.status === 'Active')) {
                isadmin = true;
                isAlumniAdmin = true;
                panelView = "AlumniAdminTabView";
                redirectTo = "/admin-dashboard";
            } 
            else if (element.role === "Alumni CST Support" && element.roleId === "782" && (element.status === 'active' || element.status === 'Active')) {
                isadmin = true;
                isCSTSupport = true;
                getCSTRoleOrg = element.organizationGuid
                panelView = "AlumniCSTSupportTabView";
                redirectTo = "/admin-dashboard";
            }
            else if (element.role === "Alumni Council Committee" && element.roleId === "781" && (element.status === 'active' || element.status === 'Active')) {
                isadmin = true;
                isCouncilCommittee = true;
                panelView = "AlumniCouncilCommitteeTabView";
                redirectTo = "/admin-dashboard";
            }
            
        // } else if (AlumniSpecialist.includes(element.role)) {
        //     isspecialist = true;
        //     redirectTo = "/admin-dashboard";
        //     panelView = "specialistTabView";
        // }
    });
    return { isadmin, isspecialist, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, panelView, redirectTo, getCSTRoleOrg};

};

const getRole = (pos) => {
    let role;
    if (pos.personContext === "AlumniAdmin") return role = "ALUMNI ADMIN"
    else if (pos.personContext === "AlumniCSTSupport") return role = "ALUMNI CST SUPPORT"
    else if (pos.personContext === "AlumniCouncilCommittee") return role = "ALUMNI COUNCIL COMMITTEE"
}

//AAG-1370 If a logged-in user has multiple entries with the same Position Context and Organization GUID, and at least one of those entries has an expiration date that is more than 10 days in the future, the "About to Expire" popup should not be displayed when the user logs in.
const getLatestPositionsPerRole = (positions) => {
    const latestMap = new Map();
    positions.forEach(pos => {
        if (!pos.expireDate) return;
        const key = `${pos.personContext}-${pos.organizationGuid}`;
        const existing = latestMap.get(key);
        if (!existing || moment(pos.expireDate).isAfter(moment(existing.expireDate))) {
            latestMap.set(key, pos);
        }
    });
    return Array.from(latestMap.values());
}

export function redirectDashboard(roles) {
    return async function(dispatch) {
        const loggedinUser = JSON.parse(localStorage.getItem('user'));
        const { personGuid, token, membership } = loggedinUser;
        const memberId = membership? membership.memberId : '';

        dispatch(requestRoles());

        try {
            const access = Array.isArray(roles) ? roles : await memoizedFetchRoleTypes(personGuid);

            let finalAccess;
            let filteredAccess = access.filter(role =>
                ["Alumni Admin", "Alumni CST Support", "Alumni Council Committee"].includes(role.role)
            );

            let aboutToExpirePopup = {
                expireDate: undefined,
                doesShow: false,
                role: undefined
            };
            const expiredRoleNames = new Set();
            
            if (filteredAccess.length > 0) {
                const positions = await memoizedGetRolesPositions(memberId);
                const roleNames = filteredAccess.map(acc => acc.role.replaceAll(' ', ''));

                const currentDate = new Date();
                const tenDaysFromNow = new Date(currentDate);
                tenDaysFromNow.setDate(currentDate.getDate() + 10);

                //
                if (positions.length > 0) {
                    const latestPositions = getLatestPositionsPerRole(positions);
                    latestPositions.forEach(pos => {
                        if (roleNames.includes(pos.personContext.trim())) {
                            const expDate = new Date(pos.expireDate);

                            if (expDate < currentDate) { //check expired
                                expiredRoleNames.add(pos.personContext);
                            } else if (currentDate <= expDate && expDate <= tenDaysFromNow) {
                                const role = getRole(pos);
                                aboutToExpirePopup = { expireDate: expDate, doesShow: true, role };
                            }
                        }
                    });

                    finalAccess = filteredAccess.filter(
                        item => !expiredRoleNames.has(item.role.replaceAll(' ', ''))
                    );
                }
                else finalAccess = filteredAccess.filter(
                        item => !roleNames.includes(item.role.replaceAll(' ', ''))
                    );
            }
            else finalAccess = filteredAccess.length > 0 ? filteredAccess.filter(
                item => !expiredRoleNames.has(item.role.replaceAll(' ', ''))
            ) : access;

            // Dispatch final state and redirect
            dispatch(hideloading());
            const { isadmin, isspecialist, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, panelView, redirectTo, getCSTRoleOrg } = getRoleAccessType(finalAccess);
            dispatch(receiveaccess(isadmin, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, isspecialist, getCSTRoleOrg));
            dispatch(receiveRoles());
            dispatch(showAboutToExpirePopup(aboutToExpirePopup));
            localStorage.setItem("panelView", JSON.stringify(panelView));
            dispatch(success(true));
            history.replace(redirectTo);

        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - redirectDashboard (${ESB_PERSONS + personGuid + '/roleTypes?type=all'} or ${ESB_PERSONS}v2/NESAPositionsDictionary?memberId=${memberId})`), { extra: { api: 'redirectDashboard', personGuid, memberId, error } });
            console.error("Error in redirectDashboard:", error);
                if (error.data) {
                    // Use the error data from the API
                    if(error.data && error.data.errorDesc && error.data.errorDesc == 'JWT Session timed out'){
                        dispatch(logout());
                        console.log('LOGGED OUT');
                    }
                    Modal.error({
                        className: "ErrorModal",
                        title: `${error.data.errorCode} ${error.data.message}`,
                        content: error.data.errorDesc || 'You do not have access to view this record!',
                        onOk() {
                            dispatch(hideloading());
                            dispatch(failure(error));
                        }
                    });
                } else {
                    // Handle generic errors (e.g., non-JSON response or network issues)
                    Modal.error({
                        className: "ErrorModal",
                        title: `Error: ${error.status}`,
                        content: error.message || 'An unexpected error occurred.',
                        onOk() {
                            dispatch(hideloading());
                            dispatch(failure(error));
                        }
                    });
                }
            
        }
    };
}

function showloading() {
    return {
        type: ACTIONTYPES.REDIRECTING,
    }
}

function hideloading() {
    return {
        type: ACTIONTYPES.REDIRECTED,
    }
}

function requestRoles() {
    return {
        type: ACTIONTYPES.ROLES_LOADING,
    }
}

function receiveRoles() {
    return {
        type: ACTIONTYPES.ROLES_RECEIVED,
    }
}
export function showAboutToExpirePopup(aboutToExpirePopup) {
    return {
        type: ACTIONTYPES.SHOW_ABOUT_TO_EXPIRE,
        aboutToExpirePopup
    }
}
export function hideAboutToExpirePopup() {
    return {
        type: ACTIONTYPES.HIDE_ABOUT_TO_EXPIRE,
    }
}

function success(user) {
    return {
        type: ACTIONTYPES.LOGIN_SUCCESS,
        user
    }
}

function failure(error) {
    return {
        type: ACTIONTYPES.LOGIN_FAILURE,
        error
    }
}

export function createPrivacySettingsDate(privacySetting) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let url = '', method = '', data = {}
    url = ESB_PERSONS + personGUID + `/alumniSettings`
    method = 'POST'

    data = {
        "alumniPrivacySettingsDate": {
            "privacySettingsDate": today
        }
    }

    return function (dispatch) {
        dispatch(reqUpdatePrivacySettings());
        fetch(url, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Please try again...',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recUpdatePrivacySettings());
                dispatch(getProfileInfo(personGUID, true))
                // Modal.success({
                //     className: "ErrorModal",
                //     title: 'Success',
                //     content: status.message,
                //     onOk() {
                //         dispatch(redirectDashboard())
                //     }
                // });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${url}`), { extra: { api: url, error } });
                console.log(error);
            });
    }

}


export function updatePrivacySettings(extendedProfileId, settings) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let url = '', method = '', data = {}
    url = ESB_PERSONS + personGUID + `/alumniSettings`
    method = 'POST'
    if (extendedProfileId == '') {
        data = {
            "alumniPrivacySettings": {
                "alumniPrivacySettings": settings
            }
        }
    } else {
        data = {
            "alumniPrivacySettings": {
                "extendedProfileId": Number(extendedProfileId),
                "alumniPrivacySettings": settings
            }
        }
    }
    return function (dispatch) {
        // dispatch(reqUpdatePrivacySettings());
        return fetch(url, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
        //         .then(response => {
        //             if (!response.ok) {
        //                 if (response.status == 422) {
        //                     Modal.error({
        //                         className: "ErrorModal",
        //                         title: 'Error',
        //                         content: 'Please try again...',
        //                     });
        //                 }
        //                 return Promise.reject(response.statusText);
        //             }
        //             return response.json();
        //         })
        //         .then(status => {
        //             dispatch(recUpdatePrivacySettings());
        //             dispatch(getProfileInfo(personGUID, true))
        //             Modal.success({
        //                 className: "ErrorModal",
        //                 title: 'Success',
        //                 content: status.message,
        //                 onOk() {
        //                     dispatch(redirectDashboard())
        //                 }
        //             });
        //         })
        //         .catch(error => {
        //             console.log(error);
        //         });
    }
}
function reqDenyToPendingApplicationStatus() {
    return {
        type: ACTIONTYPES.DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS_LOADING,
    }
}

function recDenyToPendingApplicationStatus(status) {
    return {
        type: ACTIONTYPES.DENY_TO_PENDING_MEMBERSHIP_APPLICATION_STATUS,
        status: status
    }
}

export function denyToPendingMembership(registrationId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    // let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqDenyToPendingApplicationStatus())
        fetch(ONLINE_REGISTRATIONS + registrationId + `/status`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "registrationStatusId": 4,
                "reassignReasonId": 6,
                "ownerGuid": "F3A77C78-EE20-474E-9219-D53400753B29"
            })
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        dispatch(recDenyToPendingApplicationStatus(response))
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Invalid Member ID or Applicant is not an Eagle Scout',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recDenyToPendingApplicationStatus(status))
                dispatch(getPendingMemebrship(1, 10, ''))
                dispatch(getDeniedMembership(1, 10, ''))
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: status.message,
                    onOk() {
                        history.push('/pending-membership')
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS + registrationId + `/status`}`), { extra: { api: ONLINE_REGISTRATIONS + registrationId + `/status`, error } });
                dispatch(recDenyToPendingApplicationStatus(error))
                console.log(error);
            });
    }
}

export function denyMembership(registrationId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqDenyApplicationStatus())
        return fetch(ONLINE_REGISTRATIONS + registrationId + `/status`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "registrationStatusId": 20,
                "statusReasonId": 3
            })
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        dispatch(recDenyApplicationStatus(response))
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Invalid Member ID or Applicant is not an Eagle Scout',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recDenyApplicationStatus(status))
                dispatch(getPendingMemebrship(1, 10, ''))
                dispatch(getDeniedMembership(1, 10, ''))
                // Modal.success({
                //     className: "ErrorModal",
                //     title: 'Success',
                //     content: status.message,
                //     onOk() {
                //         history.push('/pending-membership')
                //     }
                // });
                return status;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS + registrationId + `/status`}`), { extra: { api: ONLINE_REGISTRATIONS + registrationId + `/status`, error } });
                dispatch(recDenyApplicationStatus(error))
                console.log(error);
                return error;
            });
    }
}


function reqUpdatePrivacySettings() {
    return {
        type: ACTIONTYPES.PRIVACY_SETTINGS_LOADING,
    }
}

function recUpdatePrivacySettings() {
    return {
        type: ACTIONTYPES.PRIVACY_SETTINGS_UPDATED,
    }
}

export function getalumnisummary() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqalumnisummary())
        fetch(ESB_ORGANIZATIONS + `alumniMembershipSummary`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "year": parseInt(thisyear),
                "fromDate": `${thisyear}-01-01`,
                "toDate": today
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(summary => {
                dispatch(recalumnisummary(summary))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + `alumniMembershipSummary`}`), { extra: { api: ESB_ORGANIZATIONS + `alumniMembershipSummary`, error } });
                console.log(error);
            });
    }
}

function reqalumnisummary() {
    return {
        type: ACTIONTYPES.GETTING_ALUMNI_SUMMARY,
    }
}

function recalumnisummary(summary) {
    return {
        type: ACTIONTYPES.GET_ALUMNI_SUMMARY,
        summary: summary
    }
}

export function getEagleScoutsSummary(startDate, endDate, isDateRange) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqEagleScoutSummary(isDateRange))
        fetch(ESB_ORGANIZATIONS + `alumniMembershipSummary`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "year": parseInt(thisyear),
                "fromDate": moment(startDate).format('YYYY-MM-DD'),
                "toDate": moment(endDate).format('YYYY-MM-DD')
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(summary => {
                dispatch(recEagleScoutSummary(summary, isDateRange))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + `alumniMembershipSummary`}`), { extra: { api: ESB_ORGANIZATIONS + `alumniMembershipSummary`, error } });
                console.log(error);
            });
    }
}

function reqEagleScoutSummary(isDateRange) {
    if (isDateRange) {
        return {
            type: ACTIONTYPES.GETTING_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE,
        }
    } else {
        return {
            type: ACTIONTYPES.GETTING_EAGLE_SCOUTS_SUMMARY,
        }
    }
}

function recEagleScoutSummary(summary, isDateRange) {
    if (isDateRange) {
        return {
            type: ACTIONTYPES.GET_EAGLE_SCOUTS_SUMMARY_CUSTOMDATE,
            summary: summary
        }
    } else {
        return {
            type: ACTIONTYPES.GET_EAGLE_SCOUTS_SUMMARY,
            summary: summary
        }
    }
}

export function getNESASummary(startDate, endDate, isDateRange) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqNESASummary(isDateRange))
        fetch(ESB_ORGANIZATIONS + `alumniMembershipSummary`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "year": parseInt(thisyear),
                "fromDate": moment(startDate).format('YYYY-MM-DD'),
                "toDate": moment(endDate).format('YYYY-MM-DD')
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(summary => {
                dispatch(recNESASummary(summary, isDateRange))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + `alumniMembershipSummary`}`), { extra: { api: ESB_ORGANIZATIONS + `alumniMembershipSummary`, error } });
                console.log(error);
            });
    }
}

function reqNESASummary(isDateRange) {
    if (isDateRange) {
        return {
            type: ACTIONTYPES.GETTING_NESA_SUMMARY_CUSTOMDATE,
        }
    } else {
        return {
            type: ACTIONTYPES.GETTING_NESA_SUMMARY,
        }
    }

}

function recNESASummary(summary, isDateRange) {
    if (isDateRange) {
        return {
            type: ACTIONTYPES.GET_NESA_SUMMARY_CUSTOMDATE,
            summary: summary
        }
    } else {
        return {
            type: ACTIONTYPES.GET_NESA_SUMMARY,
            summary: summary
        }
    }

}

export function getalumnisummarybtw(startdate, enddate) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqalumnisummarybtw())
        fetch(ESB_ORGANIZATIONS + `alumniMembershipSummary`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "year": parseInt(thisyear),
                "fromDate": moment(startdate).format('YYYY-MM-DD'),
                "toDate": moment(enddate).format('YYYY-MM-DD')
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(summary => {
                dispatch(recalumnisummarybtw(summary))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + `alumniMembershipSummary`}`), { extra: { api: ESB_ORGANIZATIONS + `alumniMembershipSummary`, error } });
                console.log(error);
            });
    }
}

function reqalumnisummarybtw() {
    return {
        type: ACTIONTYPES.GETTING_ALUMNI_SUMMARY_BTW,
    }
}

function recalumnisummarybtw(summary) {
    return {
        type: ACTIONTYPES.GET_ALUMNI_SUMMARY_BTW,
        summary: summary
    }
}

export function membershipNotes(values, registrationId, showSuccessModal = true) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqUpdateNotes())
        return fetch(ESB_REGISTRATIONS_1 + registrationId + `/notes`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "note": values,
                "isSystemGenerated": false
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recUpdateNotesStatus())
                dispatch(recActivateStatus(status))
                dispatch(getPendingMemebrship(1, 10, ''))
                if (showSuccessModal) {
                    Modal.success({
                        className: "ErrorModal",
                        title: "Success",
                        content: "Note Field successfully Updated!"
                    });
                }
                return status;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS_1 + registrationId + `/notes`}`), { extra: { api: ESB_REGISTRATIONS_1 + registrationId + `/notes`, error } });
                console.log(error);
                throw error;
            });
    }
}

function reqUpdateNotes() {
    return {
        type: ACTIONTYPES.MEMBERSHIP_NOTES_UPDATING,
    }
}

function recUpdateNotesStatus() {
    return {
        type: ACTIONTYPES.MEMBERSHIP_NOTES_UPDATED,
    }
}

export function getRegistrationNotes(registrationId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        fetch(ESB_REGISTRATIONS_1 + registrationId + `/notes`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(notes => {
                dispatch(recNotes(notes))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS_1 + registrationId + `/notes`}`), { extra: { api: ESB_REGISTRATIONS_1 + registrationId + `/notes`, error } });
                console.log(error);
            });
    }
}

function recNotes(notes) {
    return {
        type: ACTIONTYPES.RECEIVE_NOTES,
        notes: notes
    }
}

export function UpdateMembership(personGUID, registrationId, effDt, expDt, type) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        if (type == 'SAF') {
            dispatch(reqSAFupdate())
        }
        if (type == 'NESA') {
            dispatch(reqNESAupdate())
        }
        fetch(ESB_PERSONS + personGUID + `/membershipRegistrations/` + registrationId, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "effectiveDt": moment(effDt).format('YYYY-MM-DD'),
                "expiryDt": expDt ? moment(expDt).format('YYYY-MM-DD') : undefined,
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                if (type == 'SAF') {
                    dispatch(recSAFUpdateStatus(status))
                    dispatch(getSAFRegistrations(personGUID))
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: 'SAF Membership updated successfully!',
                        onOk() {
                        }
                    });
                }
                if (type == 'NESA') {
                    dispatch(recNESAUpdateStatus(true))
                    dispatch(getNESARegistrations(personGUID))
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: 'NESA Membership updated successfully!',
                        onOk() {
                            dispatch(recNESAUpdateStatus(false))
                        }
                    });
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/membershipRegistrations/` + registrationId}`), { extra: { api: ESB_PERSONS + personGUID + `/membershipRegistrations/` + registrationId, error } });
                console.log(error);
                if (type == 'SAF') {
                    dispatch(failedSAFUpdate(error))
                }
                if (type == 'NESA') {
                    dispatch(failedNESAUpdate(error))
                }
                Modal.error({
                    className: "ErrorModal",
                    title: error.message ? error.message : 'Error',
                    content: error.errorDesc ? error.errorDesc : 'Please try again after sometime!',
                });
            });
    }
}

function reqSAFupdate() {
    return {
        type: ACTIONTYPES.SAF_MEMBERSHIP_UPDATING,
    }
}

function recSAFUpdateStatus(status) {
    return {
        type: ACTIONTYPES.SAF_MEMBERSHIP_UPDATED,
        status: status
    }
}

function failedSAFUpdate(error) {
    return {
        type: ACTIONTYPES.SAF_MEMBERSHIP_UPDATE_FAILED,
        error: error
    }
}

function reqNESAupdate() {
    return {
        type: ACTIONTYPES.NESA_MEMBERSHIP_UPDATING,
    }
}

function recNESAUpdateStatus(status) {
    return {
        type: ACTIONTYPES.NESA_MEMBERSHIP_UPDATED,
        status: status
    }
}

function failedNESAUpdate(error) {
    return {
        type: ACTIONTYPES.NESA_MEMBERSHIP_UPDATE_FAILED,
        error: error
    }
}

// AAG-1378: Add a non-revenue NESA membership (e.g. 5-Year / Lifetime granted without a purchase).
export function addNonRevenueNESAMembership(personGUID, alumniMembershipLevelId, effectiveDate, profile, boardReviewDate) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqNESANonRevenueMembershipAdd())
        fetch(ADD_NESA_NON_REVENUE_MEMBERSHIP, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                organizationGuid: "F3A77C78-EE20-474E-9219-D53400753B29",
                applicationTypeId: 11,
                effectiveDate: moment(effectiveDate).format('YYYY-MM-DD'),
                applicationDate: moment().format('YYYY-MM-DD'),
                alumniMembershipLevelId: Number(alumniMembershipLevelId),
                memberId: profile ? Number(profile.memberId) : "",
                middleName: profile ? profile.middleName : "",
                firstName: profile ? profile.firstName : "",
                lastName: profile ? profile.lastName : "",
                gender: profile ? profile.gender : "",
                boardReviewDate: boardReviewDate ? moment(boardReviewDate).format('YYYY-MM-DD') : ""
            })
        })
            .then(async response => {
                let result = null;
                try {
                    result = await response.json();
                } catch (e) {
                    result = null;
                }

                if (!response.ok) {
                    return Promise.reject({
                        errorCode: (result && result.errorCode) ? result.errorCode : response.status,
                        message: (result && result.message) ? result.message : response.statusText || "Error",
                        errorDesc: (result && result.errorDesc) ? result.errorDesc : "Please try again after sometime!"
                    });
                }
                return result;
            })
            .then(response => {
                dispatch(recNESANonRevenueMembershipAdded(response));
                if (personGUID) {
                    dispatch(getNESARegistrations(personGUID))
                }
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: 'NESA Membership added successfully!',
                    onOk() {
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ADD_NESA_NON_REVENUE_MEMBERSHIP}`), { extra: { api: ADD_NESA_NON_REVENUE_MEMBERSHIP, error } });
                console.log(error);
                dispatch(failedNESANonRevenueMembershipAdd(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message ? error.message : 'Error',
                    content: error.errorDesc ? error.errorDesc : 'Please try again after sometime!',
                });
            });
    }
}

function reqNESANonRevenueMembershipAdd() {
    return {
        type: ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADDING,
    }
}

function recNESANonRevenueMembershipAdded(response) {
    return {
        type: ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADDED,
        response
    }
}

function failedNESANonRevenueMembershipAdd(error) {
    return {
        type: ACTIONTYPES.NESA_NON_REVENUE_MEMBERSHIP_ADD_FAILED,
        error
    }
}

export const changeMembershipStatusToProcessed = (registrationId, memberId, needToDispatchResponse) => {

    return function (dispatch) {
        return fetch(ESB_REGISTRATIONS + `processPendingRegistrations`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "registrationId": parseInt(registrationId),
                "memberId": parseInt(memberId)
            })
        })
            .then(async response => {

                // check for error response
                if (!response.ok) {
                    const isJson = response.headers.get('content-type') ? response.headers.get('content-type').includes('application/json') : "";
                    const data = isJson ? await response.json() : null;

                    // get error message from body
                    const error = data ? data : response.statusText
                    return Promise.reject(error);
                }
                return response.json();
            })
            .then(status => {
                console.log(status);
                if (needToDispatchResponse) {
                    dispatch(recActivateStatus(status))
                    // Modal.success({
                    //     className: "ErrorModal",
                    //     title: 'Success',
                    //     content: status.message,
                    //     onOk() {
                    //         history.push('/pending-membership')
                    //     }
                    // });
                }
                return status;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS + `processPendingRegistrations`}`), { extra: { api: ESB_REGISTRATIONS + `processPendingRegistrations`, error } });
                console.log(error);
                throw error;
            });
    }
}

export function activateMembership(values, registrationId, record, pendingPerPageSize) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    // let needToDispatchResponse = values.notes ? false : true
    let needToDispatchResponse = true;
    pendingPerPageSize = pendingPerPageSize ? pendingPerPageSize : 10;
    return function (dispatch) {
        dispatch(reqActivateStatus())
        return dispatch(changeMembershipStatusToProcessed(registrationId, values.member_id, needToDispatchResponse))
        // .then(status => {

        // recent remove AAG-1377
        // try {
        //     if (values.notes) {
        //         return fetch(ESB_REGISTRATIONS_1 + registrationId + `/notes`, {
        //             method: 'POST',
        //             credentials: 'include',
        //             headers: {
        //                 "Content-Type": "application/json",
        //                 "authorization": "Bearer " + token
        //             },
        //             body: JSON.stringify({
        //                 "note": values.notes,
        //                 "isSystemGenerated": false
        //             })
        //         })
        //             .then(response => {
        //                 if (!response.ok) {
        //                     return Promise.reject(response.statusText);
        //                 }
        //                 return response.json();
        //             })
                    .then(status => {
                        dispatch(recActivateStatus(status))
                        dispatch(getPendingMemebrship(1, pendingPerPageSize, ''))
                        // Modal.success({
                        //     className: "ErrorModal",
                        //     title: 'Success',
                        //     content: status.message,
                        //     onOk() {
                        //         history.push('/pending-membership')
                        //     }
                        // })
                        return status;
                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS_1 + registrationId + `/notes`}`), { extra: { api: ESB_REGISTRATIONS_1 + registrationId + `/notes`, error } });
                        dispatch(recActivateStatus(error))
                        console.log(error);
                        throw error;
                    });
        //     }
        //     else {
        //         dispatch(getPendingMemebrship(1, pendingPerPageSize, ''))
        //     }
        //     // })
        // }
        // catch (error) {

        //     console.log(error);
        //     dispatch(recActivateStatus(error))
        //     Modal.error({
        //         className: "ErrorModal",
        //         title: error.message ? error.message : 'Error',
        //         content: error.errorDesc ? error.errorDesc : 'Please try again after sometime!',
        //     });
        // };
    }
}

function reqActivateStatus() {
    return {
        type: ACTIONTYPES.ACTIVATE_MEMBERSHIP_STATUS_LOADING,
    }
}

function recActivateStatus(status) {
    return {
        type: ACTIONTYPES.ACTIVATE_MEMBERSHIP_STATUS,
        status: status
    }
}
function reqDenyApplicationStatus() {
    return {
        type: ACTIONTYPES.DENY_MEMBERSHIP_APPLICATION_STATUS_LOADING,
    }
}

function recDenyApplicationStatus(status) {
    return {
        type: ACTIONTYPES.DENY_MEMBERSHIP_APPLICATION_STATUS,
        status: status
    }
}


export function updateProfile(values) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(requestupdateprofile())
        fetch(ESB_PERSONS + 'v2/' + personGUID + `/profile`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                profile: values
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(reciveupdateprofile(status.message));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/profile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/profile`, error } });
                console.log(error);
            });
    }
}

function requestupdateprofile() {
    return {
        type: ACTIONTYPES.UPDATE_PROFILE_LOADING,
    }
}

function reciveupdateprofile(status) {
    return {
        type: ACTIONTYPES.UPDATE_PROFILE,
        status: status
    }
}


//get profile info (Dashboard)
export function personsprofile(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(personsprofileinit)
        fetch(ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(profileinfo => {
                dispatch(receivepersonsprofileinfo(profileinfo));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                console.log(error);
            });
    }
}

function personsprofileinit() {
    return {
        type: ACTIONTYPES.PERSONS_PROFILE_LOADING,
    }
}

function receivepersonsprofileinfo(profileinfo) {
    return {
        type: ACTIONTYPES.PERSONS_PROFILE,
        profileinfo: profileinfo
    }
}

function fetchRoletypes(personGUID) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));

    if (!loggedinUser || !loggedinUser.token) {
        return Promise.reject(new Error("No valid user token found."));
    }

    const token = loggedinUser.token;

    return fetch(ESB_PERSONS + personGUID + '/roleTypes?type=all', {
        method: 'GET',
        credentials: 'include',
        cache: "no-cache", // AAG-1360: prevent Edge from serving a stale/failed roleTypes response (surfaces as ESB R404 redissearch error)
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`,
        },
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(errorData => {
                // Return a more descriptive error, including the status and the data from the server.
                const error = new Error(errorData.message || 'API request failed');
                error.status = response.status;
                error.data = errorData;
                return Promise.reject(error);
            })
        }
        return response.json();
    });
}
const memoizedFetchRoleTypes = memoize(
    (personGUID) => fetchRoletypes(personGUID),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentPersonGuid] = lastArgs;
        const [newPersonGuid] = newArgs;
        return currentPersonGuid === newPersonGuid;
    });
function fetchPositions(memberId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return fetch(ESB_PERSONS + 'v2/NESAPositionsDictionary?memberId=' + memberId, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token,
        },
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })

}
const memoizedFetchPositions = memoize(
    (memberId) => fetchPositions(memberId),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentPersonGuid] = lastArgs;
        const [newPersonGuid] = newArgs;
        return currentPersonGuid === newPersonGuid;
    });

    export function isadmin() {
        const loggedinUser = JSON.parse(localStorage.getItem('user'));
        let personGUID = loggedinUser.personGuid;
        let memberId = loggedinUser.membership.memberId;
    
        return async function (dispatch) {
            dispatch(reqAdminLoading());
    
            // memoizedFetchPositions(memberId)
            //     .then(positionsInfo => {
            //         dispatch(receivepositionsinfo(positionsInfo));
    
            //         if (!positionsInfo || positionsInfo.length === 0) {
            //         // if (!positionsInfo || !positionsInfo.some(pos => ['AlumniAdmin', 'AlumniCSTSupport', 'AlumniCouncilCommittee'].includes(pos.personContext))){
            try {
                const access = await memoizedFetchRoleTypes(personGUID);

                let finalAccess;
                let filteredAccess = access.filter(role =>
                    ["Alumni Admin", "Alumni CST Support", "Alumni Council Committee"].includes(role.role)
                );

                let aboutToExpirePopup = {
                    expireDate: undefined,
                    doesShow: false,
                    role: undefined
                };
                const expiredRoleNames = new Set();

                if (filteredAccess.length > 0) {
                    const positions = await memoizedGetRolesPositions(memberId);
                    const roleNames = filteredAccess.map(acc => acc.role.replaceAll(' ', ''));
    
                    const currentDate = new Date();
                    const tenDaysFromNow = new Date(currentDate);
                    tenDaysFromNow.setDate(currentDate.getDate() + 10);
    
                    //
                    if (positions.length > 0) {
                        const latestPositions = getLatestPositionsPerRole(positions);
                        latestPositions.forEach(pos => {
                            if (roleNames.includes(pos.personContext.trim())) {
                                const expDate = new Date(pos.expireDate);

                                if (expDate < currentDate) { //check expired
                                    expiredRoleNames.add(pos.personContext);
                                } else if (currentDate <= expDate && expDate <= tenDaysFromNow) {
                                    const role = getRole(pos);
                                    aboutToExpirePopup = { expireDate: expDate, doesShow: true, role };
                                }
                            }
                        });

                        finalAccess = filteredAccess.filter(
                            item => !expiredRoleNames.has(item.role.replaceAll(' ', ''))
                        );
                    }
                    else finalAccess = filteredAccess.filter(
                            item => !roleNames.includes(item.role.replaceAll(' ', ''))
                        );
                }
                else finalAccess = filteredAccess.length > 0 ? filteredAccess.filter(
                    item => !expiredRoleNames.has(item.role.replaceAll(' ', ''))
                ) : access;

                                // let isadmin = false, isspecialist = false, isSuperAlumniAdmin = false;
    
                                // access.forEach(element => {
                                //     AdminAccess.forEach(Roles => {
                                //         if (element.role === Roles) {
                                //             isadmin = true;
                                //             if (element.role === 'Super Alumni Administrator' && element.status === 'active') {
                                //                 isSuperAlumniAdmin = true;
                                //             }
                                //         }
                                //     });
    
                                //     if (!isadmin) {
                                //         AlumniSpecialist.forEach(Roles => {
                                //             if (element.role === Roles) {
                                //                 isspecialist = true;
                                //             }
                                //         });
                                //     }
                                // });
    
                                // if (isadmin || isSuperAlumniAdmin) {
                                //     dispatch(receiveaccess(isadmin, isSuperAlumniAdmin));
                                // } else if (isspecialist) {
                                //     dispatch(receiveaccess(true, false, false, false, false, isspecialist));
                                const {isadmin, isspecialist, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, panelView , redirectTo, getCSTRoleOrg } = getRoleAccessType(finalAccess);
                                dispatch(receiveaccess(isadmin, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, isspecialist, getCSTRoleOrg));
                                dispatch(showAboutToExpirePopup(aboutToExpirePopup));

                                const updatedUser = { ...loggedinUser, isadmin };
                                localStorage.setItem('user', JSON.stringify(updatedUser));
                                // } else {
                                //     dispatch(receiveaccess(false));
                                // }
            }
            catch (error) {
                console.log(error);
                console.error("Error in isAdmin:", error);
                if (error.data) {
                    // Use the error data from the API
                    if(error.data && error.data.errorDesc && error.data.errorDesc == 'JWT Session timed out'){
                        dispatch(logout());
                        console.log('LOGGED OUT');
                    }
                    Modal.error({
                        className: "ErrorModal",
                        title: `${error.data.errorCode} ${error.data.message}`,
                        content: error.data.errorDesc || 'You do not have access to view this record!',
                        onOk() {
                            dispatch(receiveaccess(false));
                        }
                    });
                } else {
                    // Handle generic errors (e.g., non-JSON response or network issues)
                    Modal.error({
                        className: "ErrorModal",
                        title: `Error: ${error.status}`,
                        content: error.message || 'An unexpected error occurred.',
                        onOk() {
                            dispatch(receiveaccess(false));
                        }
                    });
                }
                return { isadmin: false, isspecialist: false };
            };
                //     } else {
                //         dispatch(receiveaccess(false));
                //     }
                // })
                // .catch(error => {
                //     console.log(error);
                //     dispatch(receiveaccess(false));
                // });
        }
    }    

function reqAdminLoading() {
    return {
        type: ACTIONTYPES.ISADMIN_LOADING,
    };
}

function receiveaccess(access, isSuperAlumniAdmin, isCSTSupport, isCouncilCommittee, isAlumniAdmin, isspecialist, getCSTRoleOrg) {
    if (isspecialist) {
        return {
            type: ACTIONTYPES.ISSPECIALIST,
            isspecialist: access
        }
    } else {
        return {
            type: ACTIONTYPES.ISADMIN,
            isadmin: access,
            isSuperAlumniAdmin: isSuperAlumniAdmin,
            isCSTSupport, 
            isCouncilCommittee,
            isAlumniAdmin,
            getCSTRoleOrg
        }
    }
}

// function receiveSuperAdmin(isSuperAlumniAdmin) {
//     return {
//       type: ACTIONTYPES.ISSUPERADMIN,
//       isSuperAlumniAdmin
//     }
// }

export function setPrimaryMemberid(action, memberid) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    let method, data, message;
    if (action == 'update') {
        method = 'PUT'
        data = {
            "userName": username,
            "memberId": memberid,
            "isPrimary": true
        }
        message = "You have changed your primary memberID. In order to access directory under the new ID please log out and log in again."
    }
    if (action == 'delete') {
        method = 'DELETE'
        data = {
            "userName": username,
            "memberId": memberid
        }
        message = "MemberID Deleted Successfully!"
    }
    return function (dispatch) {
        dispatch(requpdateprimememberid())
        fetch(ESB_PERSONS + personGUID + `/memberships`, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recupdateprimememberid(status.message));
                if (action == 'delete') dispatch(getmemberid(personGUID, true));
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: message,
                    onOk() {
                        if (action == 'update') {
                            dispatch(logout());
                        }
                    }
                })
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/memberships`}`), { extra: { api: ESB_PERSONS + personGUID + `/memberships`, error } });
                console.log(error);
            });
    }
}

function requpdateprimememberid() {
    return {
        type: ACTIONTYPES.MEMBERID_UPDATING,
    }
}

function recupdateprimememberid(status) {
    return {
        type: ACTIONTYPES.MEMBERID_UPDATED,
        status: status
    }
}

function fetchMemberid(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return fetch(ESB_PERSONS + personGUID + `/memberships`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        },
        body: JSON.stringify({
            "userName": username
        })
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    })
}

// const memoizedFetchMemberid = memoize(
//     (personGUID) => fetchMemberid(personGUID),
//     (newArgs, lastArgs) => {
//         if (newArgs.length !== lastArgs.length) {
//             return false;
//         }
//         const [currentPersonGuid] = lastArgs;
//         const [newPersonGuid, refresh] = newArgs;
//         return !refresh && currentPersonGuid === newPersonGuid;
//     });
//get memberid
export function getmemberid(personGuid, refresh = false, eagleSearchRecords, getCurrentMember, forSelfViewOnly) {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const token = loggedInUser.token;
    const username = loggedInUser.account.username;
    const personGUID = personGuid || loggedInUser.personGuid;

    return async function (dispatch) {
        dispatch(reqMemberid());

        try {
            const response = await fetch(ESB_PERSONS + personGUID + `/memberships`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "authorization": "Bearer " + token
                },
                body: JSON.stringify({
                    "userName": username
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw {
                    status: response.status,
                    statusText: response.statusText,
                    errorData: errorData
                };
            }

            const memberIds = await response.json();
            const allMemberIds = memberIds;
            const eagleRecords = [];
            const searchAllEagleRecords = eagleSearchRecords ? (eagleSearchRecords.length !== 0 ? eagleSearchRecords : []) : [];

            await Promise.all(allMemberIds.map(async (k, index) => {
                try {
                    const [nesaReg, eagleInfo, awards, profile] = await Promise.all(
                        // forSelfViewOnly ? [
                        //     fetch(ESB_PERSONS + k.personGuid + `/nesaRegistrations`).then(response => response.json()),
                        //     fetch(ESB_PERSONS + k.personGuid + `/eagleInformation`, { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json; version = 1', "Authorization": "Bearer " + token } }).then(response => response.json()),
                        // ] 
                        // :
                        [
                            fetch(ESB_PERSONS + k.personGuid + `/nesaRegistrations`).then(response => response.json()),
                            fetch(ESB_PERSONS + k.personGuid + `/eagleInformation`, { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json; version = 1', "Authorization": "Bearer " + token } }).then(response => response.json()),
                            fetch(ESB_PERSONS + k.personGuid + '/alumniAwards', { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', "Authorization": "Bearer " + token } }).then(response => response.json()),
                            fetch(ESB_PERSONS + 'v2/' + k.personGuid + `/personprofile`, { method: 'GET', credentials: 'include', headers: { "Content-Type": "application/json", "authorization": "Bearer " + token } }).then(response => response.json())
                        ]);

                    if (Array.isArray(nesaReg) && nesaReg.length > 0) {
                        memberIds[index].NESARegistrations = nesaReg.map(reg => {
                            const { personGuid, memberId, ...rest } = reg;
                            return { personGuid: k.personGuid, memberId: k.memberId, ...rest };
                        });
                    }
                    else memberIds[index].NESARegistrations = [];
                    // memberIds[index].NESARegistrations = nesaReg.map(reg => {reg.personGuid = k.personGuid, reg.memberId= k.memberId });
                    if (!forSelfViewOnly) memberIds[index].awards = awards;

                    if (eagleInfo) {
                        const isEagle = eagleInfo.eagleBoardReviewDate && eagleInfo.eagleBoardReviewDate !== "";
                        memberIds[index].isEagle = isEagle;
                        memberIds[index].eagleInfo = eagleInfo;
                        eagleRecords.push(eagleInfo);

                        if (profile && profile.profile && profile.profile.memberId === String(eagleInfo.memberId)) {
                            eagleInfo.dateOfBirth = profile.profile.dateOfBirth
                        }

                        if (getCurrentMember) {
                            eagleInfo.personGuid = k.personGuid;
                            eagleInfo.eagleCertificationDate = eagleInfo.eagleCertificateDate;
                            eagleInfo.eagleTroopNumber = eagleInfo.eagleUnitNumber;
                            eagleInfo.eagleCity = eagleInfo.eagleUnitCity;
                            eagleInfo.eagleState = eagleInfo.eagleUnitState;
                            eagleInfo.awardingCouncilName = eagleInfo.eagleCouncilName;
                        }

                        searchAllEagleRecords.push(eagleInfo);

                        if (eagleRecords.length === allMemberIds.length) {
                            getCurrentMember && dispatch(receaglestatus(searchAllEagleRecords));
                        }
                    }

                    if (!forSelfViewOnly) memberIds[index].extendedProfile = profile.extendedProfile;

                } catch (error) {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - getmemberid (${ESB_PERSONS + k.personGuid}/nesaRegistrations or /eagleInformation or /alumniAwards or /v2/.../personprofile)`), { extra: { api: 'getmemberid', personGuid: k.personGuid, error } });
                    handleFetchError(error && error.errorData ? error.errorData : error);
                }
            }));

            dispatch(recMemberid(memberIds));
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/memberships`}`), { extra: { api: ESB_PERSONS + personGUID + `/memberships`, error } });
            handleFetchError(error && error.errorData ? error.errorData : error);
        }
    };
}

function handleFetchError(error) {
    notification.open({
        message: error.message ? `${error.message}` : "Error",
        description: `${error.errorDesc}`,
        icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
    });
    console.log(error);
}


function reqMemberid() {
    return {
        type: ACTIONTYPES.MEMBERID_LOADING
    }
}
function recMemberid(memberids) {
    return {
        type: ACTIONTYPES.MEMBERID_LOADED,
        memberids: memberids
    }
}

export const addMemberID = (memberID, councilGuid, isPrimary) => {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqToAddMemberid())
        fetch(ESB_PERSONS + personGUID + `/memberships/add`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username,
                "memberId": Number(memberID),
                "councilGuid": councilGuid,
                "isPrimary": isPrimary
            })
        }).then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    return Promise.reject({
                        status: response.status,
                        statusText: response.statusText,
                        errorData: errorData
                    });
                });
            }
            return response.json();
        }).then(response => {
            dispatch(addedMemberid())
            dispatch(getmemberid(personGUID, true))
            Modal.success({
                className: "ErrorModal",
                title: 'Success',
                content: 'MemberID Successfully Added!',
            });
        })
            .catch(({ errorData }) => {
                const endpoint = ESB_PERSONS + personGUID + `/memberships/add`;
                const errorMessage = (errorData && (errorData.message || errorData.errorDesc)) || "API Error";
                Sentry.captureException(new Error(`${errorMessage} - ${endpoint}`), {
                    extra: {
                        api: endpoint,
                        personGUID,
                        memberID,
                        errorData
                    }
                });
                Modal.error({
                    className: "ErrorModal",
                    title: `${errorData.message}`,
                    content: ` ${errorData.errorDesc}`,
                });
                dispatch(failedToAddMemberid())
            })
    }
}

function reqToAddMemberid() {
    return {
        type: ACTIONTYPES.ADDING_MEMBERID
    }
}
function addedMemberid() {
    return {
        type: ACTIONTYPES.ADDED_MEMBERID
    }
}
function failedToAddMemberid() {
    return {
        type: ACTIONTYPES.FAILED_TO_ADD_MEMBERID,
    }
}
export const deleteMemberID = (memberID) => {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqToDeleteMemberid())
        fetch(ESB_PERSONS + personGUID + `/memberships/add`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username,
                "memberId": memberID
            })
        }).then(response => {
            if (!response.ok) {
                return response.json().then(errorData => {
                    return Promise.reject({
                        status: response.status,
                        statusText: response.statusText,
                        errorData: errorData
                    });
                });
            }
            return response.json();
        }).then(response => {
            dispatch(deletedMemberid())
            dispatch(getmemberid(personGUID, true))
            // Modal.success({
            //     className: "ErrorModal",
            //     title: 'Success',
            //     content: 'Successfully Deleted!',
            // });
        })
            .catch(({ errorData }) => {
                Sentry.captureException(new Error(`${(errorData && (errorData.message || errorData.errorDesc)) || "API Error"} - ${ESB_PERSONS + personGUID + `/memberships/add`}`), { extra: { api: ESB_PERSONS + personGUID + `/memberships/add`, errorData } });
                Modal.error({
                    className: "ErrorModal",
                    title: `${errorData.message}`,
                    content: ` ${errorData.errorDesc}`,
                });
                dispatch(failedToDeleteMemberid())
            })
    }
}

function reqToDeleteMemberid() {
    return {
        type: ACTIONTYPES.ADDING_MEMBERID
    }
}
function deletedMemberid() {
    return {
        type: ACTIONTYPES.ADDED_MEMBERID
    }
}
function failedToDeleteMemberid() {
    return {
        type: ACTIONTYPES.FAILED_TO_DELETE_MEMBERID
    }
}

function fetchProfile(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return fetch(ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, {
        method: 'GET',
        credentials: 'include',
        cache: "no-cache", // AAG-1360: avoid stale cached profile response in Edge (ESB R404 redissearch error)
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        },
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    })
}

const memoizedFetchProfile = memoize(
    (personGUID) => fetchProfile(personGUID),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentPersonGuid] = lastArgs;
        const [newPersonGuid, refresh] = newArgs;
        return !refresh && currentPersonGuid === newPersonGuid;
    });

//get profile info (Dashboard)
export function getProfileInfo(personGUID, refresh = false) {
    return function (dispatch) {
        dispatch(requestProfileInfo())
        dispatch(requestProfileInfoNull())
        memoizedFetchProfile(personGUID, refresh)
            .then(profileinfo => {
                dispatch(receiveprofileinfo(profileinfo));
                // if(profileinfo) {
                //     let alumnitoc = profileinfo && profileinfo.extendedProfile[0] ? profileinfo.extendedProfile.filter(obj => obj.attributeId == "19") : [];
                //     let alumniPrivacyDate = profileinfo && profileinfo.extendedProfile[0] ? profileinfo.extendedProfile.filter(obj => obj.attributeId == "25") : [];

                //     if (alumnitoc.length == 0) {
                //         history.push('/terms-conditions')
                //     } else if (alumniPrivacyDate.length == 0) {
                //         history.push('/privacy-setting')
                //     } else {
                //         var acceptedtoc = alumnitoc[0].attributeVal;
                //         let acceptedPrivacyDate = alumniPrivacyDate[0].attributeVal;
                //         if(acceptedtoc) {
                //             var isTocaccepted = moment(today).diff(moment(acceptedtoc), 'years')
                //             isTocaccepted >= 1 ? history.push('/terms-conditions') : history.push('/alumni-dashboard')
                //         }else if (acceptedPrivacyDate) {
                //             var isPrivacyaccepted = moment(today).diff(moment(acceptedPrivacyDate), 'years')
                //             isPrivacyaccepted >= 1 ? history.push('/privacy-setting') : history.push('/alumni-dashboard')
                //         }else {
                //             history.push('/alumni-dashboard')
                //         }
                //     }

                // }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/personprofile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/personprofile`, error } });
                if (error == "Forbidden") {
                    // dispatch(sessionTimeOut())
                }
                else {
                    notification.open({
                        message: error.errorCode ? error.errorCode : "Error",
                        description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                        icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                    });
                }
                console.log(error);
            });
    }
}

function requestProfileInfo() {
    return {
        type: ACTIONTYPES.PROFILE_INFO_LOADING
    }
}
function requestProfileInfoNull() {
    return {
        type: ACTIONTYPES.PROFILE_INFO,
        profileinfo: null
    }
}

function receiveprofileinfo(profileinfo) {
    return {
        type: ACTIONTYPES.PROFILE_INFO,
        profileinfo: profileinfo
    }
}

function receivepositionsinfo(postionsinfo) {
    return {
        type: ACTIONTYPES.GET_POSTIONS_RECEIVE,
        postionsinfo: postionsinfo
    }
}


// Get Complete Column List
export function getcompletecolumnlist(userRole) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqcompletecolumnlist());
        fetch(DICTIONARY_COLUMN_LIST, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(columnlist1 => {
                // if (columnlist.ResponseCode != 1) {
                //     dispatch(errorcompletecolumnlist(columnlist));
                // } else {
                    let columnlist = {
                        "ResponseCode": "1",
                        "ResponseMessage": "Success",
                        "DisplayColumnLists": [
                            {"PersonID": "PersonID"},
                            {"Prefix": "Prefix"},
                            {"FirstName": "FirstName"},
                            {"MiddleName": "MiddleName"},
                            {"LastName": "LastName"},
                            {"MaidenName": "MaidenName"},
                            {"CommonName": "CommonName"},
                            {"Suffix": "Suffix"},
                            {"DateOfBirth": "DateOfBirth"},
                            {"DateOfDeath": "DateOfDeath"},
                            {"Home_AddressLine1": "Home_AddressLine1"},
                            {"Home_AddressLine2": "Home_AddressLine2"},
                            {"Home_AddressLine3": "Home_AddressLine3"},
                            {"Home_Zip5": "Home_Zip5"},
                            {"Home_Zip4": "Home_Zip4"},
                            {"Home_City": "Home_City"},
                            {"Home_State": "Home_State"},
                            {"Home_Country": "Home_Country"},
                            {"Business_AddressLine1": "Business_AddressLine1"},
                            {"Business_AddressLine2": "Business_AddressLine2"},
                            {"Business_AddressLine3": "Business_AddressLine3"},
                            {"Business_Zip5": "Business_Zip5"},
                            {"Business_Zip4": "Business_Zip4"},
                            {"Business_City": "Business_City"},
                            {"Business_State": "Business_State"},
                            {"Business_Country": "Business_Country"},
                            {"Shipping_AddressLine1": "Shipping_AddressLine1"},
                            {"Shipping_AddressLine2": "Shipping_AddressLine2"},
                            {"Shipping_AddressLine3": "Shipping_AddressLine3"},
                            {"Shipping_Zip5": "Shipping_Zip5"},
                            {"Shipping_Zip4": "Shipping_Zip4"},
                            {"Shipping_City": "Shipping_City"},
                            {"Shipping_State": "Shipping_State"},
                            {"Shipping_Country": "Shipping_Country"},
                            {"Email": "Email"},
                            {"FKCampLookupID": "FKCampLookupID"},
                            {"MemberID": "MemberID"},
                            {"PersonGUID": "PersonGUID"},
                            {"Distinguished_Eagle_Scout_Award": "Distinguished_Eagle_Scout_Award"},
                            {"Venturing_Summit_Award": "Venturing_Summit_Award"},
                            {"Silver_Antelope": "Silver_Antelope"},
                            {"Silver_Buffalo": "Silver_Buffalo"},
                            {"National_Alumnus_of_the_Year_Award": "National_Alumnus_of_the_Year_Award"},
                            {"Regional_Alumnus_of_the_Year_Award": "Regional_Alumnus_of_the_Year_Award"},
                            {"NESA_Outstandng_Eagle_Scout_NOESA": "NESA_Outstandng_Eagle_Scout_NOESA"},
                            {"Council_Alumnus_of_the_Year_Award": "Council_Alumnus_of_the_Year_Award"},
                            {"Alumni_Award": "Alumni_Award"},
                            {"Silver_Award": "Silver_Award"},
                            {"Quartermaster": "Quartermaster"},
                            {"PaymentStatus": "PaymentStatus"},
                            {"RushShipping": "RushShipping"},
                            {"PositionName": "PositionName"},
                            {"PositionStartDate": "PositionStartDate"},
                            {"PositionEndDate": "PositionEndDate"},
                            {"PositionCreationDate": "PositionCreationDate"},
                            {"ProgramID": "ProgramID"},
                            {"NESA_AddressLine1": "Ship_To_AddressLine1"},
                            {"NESA_AddressLine2": "Ship_To_AddressLine2"},
                            {"NESA_AddressLine3": "Ship_To_AddressLine3"},
                            {"NESA_Zip5": "Ship_To_Zip5"},
                            {"NESA_Zip4": "Ship_To_Zip4"},
                            {"NESA_City": "Ship_To_City"},
                            {"NESA_State": "Ship_To_State"},
                            {"NESA_Country": "Ship_To_Country"},
                            {"BoardOfReviewDT": "BoardOfReviewDT"},
                            {"CertificateName": "CertificateName"},
                            {"EagleScoutUnitType": "EagleScoutUnitType"},
                            {"EagleScoutUnitNumber": "EagleScoutUnitNumber"},
                            {"EagleScoutUnitCity": "EagleScoutUnitCity"},
                            {"EagleScoutUnitState": "EagleScoutUnitState"},
                            {"EagleCouncilNameAndNumber": "EagleCouncilNameAndNumber"},
                            {"OwnerCouncilNameAndNumber": "CurrentCouncilNameAndNumber"},
                            {"FacebookName": "FacebookName"},
                            {"TwitterName": "TwitterName"},
                            {"LinkedinName": "LinkedinName"},
                            {"InstagramName": "InstagramName"},
                            {"ship_to_name": "ship_to_name"},
                            {"EagleScoutCountry": "EagleScoutCountry"},
                            {"MembershipType": "MembershipType"},
                            {"AffinityGroup": "AffinityGroup"},
                            {"ScoutingAffiliation": "ScoutingAffiliation"},
                            {"CouncilAffiliation": "CouncilAffiliation"},
                            {"MembershipStatus": "MembershipStatus"},
                            {"SocialMedia": "SocialMedia"},
                            {"NationalAward": "NationalAward"},
                        ]
                    }
                    const DisplayColumnLists = columnlist.DisplayColumnLists;
                    DisplayColumnLists.push({ "SocialMedia": "SocialMedia" })
                    let filtersArray = REMOVED_SEARCHFILTERS.map(str => str.toLowerCase());
                    
                    let filteredList = DisplayColumnLists.filter(item => {
                        if (item.EthnicityID == "EthnicityID") { // To show it on the search-dropdown list as "ethnicity" not "EthnicityID"
                            item = { "ethnicity": "ethnicity" };
                        }
                        for (const key in item) {
                            if (!filtersArray.includes(item[key].toLowerCase())) {
                                return true;
                            }
                        }
                        return false;
                    });
                    columnlist.DisplayColumnLists = [...filteredList];
                    // Check if an object with the key "CouncilAffiliation" exists in the array
                    const exists = columnlist.DisplayColumnLists.some(item => item["CouncilAffiliation"]);
                    const ethinicityId = { EthnicityID: "EthnicityID" };
                    const ethinicity = { ethnicity: "ethnicity" };

                    const MemberID = { MemberID: "MemberID" }; //AAG-1246 added back SKPersonID

                    const existsEthinicityId = columnlist.DisplayColumnLists.findIndex(obj => obj.EthnicityID === ethinicityId.EthnicityID);

                    const existsSKPersonID = columnlist.DisplayColumnLists.findIndex(obj => obj.SKPersonID === 'MemberID'); //AAG-1246 added back SKPersonID

                    if (existsEthinicityId !== -1) {
                        columnlist.DisplayColumnLists.splice(existsEthinicityId, 1, ethinicity); // Remove 1 element and add newObject
                    }

                    if (existsSKPersonID !== -1) {
                        columnlist.DisplayColumnLists.splice(existsSKPersonID, 1, MemberID);  //AAG-1246 added back SKPersonID
                    }

                    if (!exists) {
                        columnlist.DisplayColumnLists.push({ "CouncilAffiliation": "CouncilAffiliation" });
                    }
                    if(userRole != "COUNCIL COMMITTE") {
                        columnlist.DisplayColumnLists.push({ "CouncilNumber": "CouncilNumber" });
                }
                    dispatch(receivecompletecolumnlist(columnlist));
                // }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${DICTIONARY_COLUMN_LIST}`), { extra: { api: DICTIONARY_COLUMN_LIST, error } });
                console.log(error);
            });
    }
}

function reqcompletecolumnlist() {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST_LOADING,
    }
}

function errorcompletecolumnlist(columnlist) {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST_ERROR,
        error: columnlist
    }
}

function receivecompletecolumnlist(columnlist) {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST,
        columnlist: columnlist
    }
}


//SessionTimeOut
export function sessionTimeOut() {
    return (dispatch) => {
        dispatch(logout());
        dispatch({
            type: ACTIONTYPES.SESSIONTIMEOUT,
            timeout: true
        });
    }
}

export function getlist(preferencename, listtype) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    if (listtype == 2) personGUID = "00000000-0000-0000-0000-000000000000"
    return function (dispatch) {
        dispatch(requestpreferencedata())
        fetch(GET_PREFERENCE_DATA + '&personGUID=' + personGUID + '&preferencename=' + preferencename + '&listtype=' + listtype, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                let preferencedata = response
                let ExpressionsArray = preferencedata.Filters.Expressions
                let columnlist = preferencedata.Columns.filter(column => column)
                // ExpressionsArray.map((k, index) => {
                //     columnlist.push( k.ColumnName) 
                // });
                if (preferencename != 'quicksearch') {
                    let recordsPerPage = 40, pageNumber = 1, maxRecords = 10000;
                    dispatch(RunPreference(preferencename, listtype, columnlist, recordsPerPage, pageNumber, maxRecords))
                    dispatch(getpreferencedata(response));
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_DATA + '&personGUID=' + personGUID + '&preferencename=' + preferencename + '&listtype=' + listtype}`), { extra: { api: GET_PREFERENCE_DATA + '&personGUID=' + personGUID + '&preferencename=' + preferencename + '&listtype=' + listtype, error } });
                console.log(error);
                // dispatch({
                //     type: ACTIONTYPES.GET_PREFERENCE_DATA_FAILURE,
                //     error: error
                // });

                // dispatch({ type: ACTIONTYPES.RECORDS_LOADING_STOP });

                if (window.location.pathname.includes('/alumni-search')) {
                    dispatch({ type: ACTIONTYPES.ALUMNI_RECORDS_LOADING_STOP });
                } else if (window.location.pathname.includes('/quick-search')) {
                    dispatch({ type: ACTIONTYPES.QUICK_RECORDS_LOADING_STOP });
                } else {
                    dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });
                }
            });
    }
}

function getpreferencedata(preferencedata) {
    return {
        type: ACTIONTYPES.GET_PREFERENCE_DATA,
        preferencedata: preferencedata
    }
}


export function logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('QuickSearchExp')
    localStorage.removeItem('ContextToken')
    localStorage.removeItem('LastActivity')
    localStorage.removeItem('privacy-setting')
    localStorage.removeItem('panelView')
    history.push('/')
    return {
        type: ACTIONTYPES.LOGOUT
    }
}

// Calls the new /logout API. Use this ONLY for an explicit user click on the
// "Logout" button - every other logout path (session timeout, expired-token
// error handlers, etc.) must keep dispatching the existing logout() above
// unchanged, with no API call.
export function manualLogout() {
    return function (dispatch) {
        fetch(LOGOUT_URL, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        }).catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${LOGOUT_URL}`), { extra: { api: LOGOUT_URL, error } });
            console.log("Logout API Error:", error);
        });

        // Marks that the user explicitly signed out of Directory. This is
        // checked by Login before it silently re-authenticates via /refresh -
        // otherwise a still-active SSO session on the other site logs the
        // user right back in, undoing the logout. Cleared when the user
        // explicitly authenticates again (manual login or a fresh SSO handoff).
        localStorage.setItem('directoryLoggedOut', 'true');

        dispatch(logout());
    };
}

//InstagramName name added
export function QuickSearch(start, end, columns, type) {
    if (!columns.includes("AlumniPrivacy")) {
        columns.push('AlumniPrivacy')
    }
    let ContextToken = localStorage.getItem('ContextToken')
    let columnlist = columns.toString();
    return function (dispatch) {
        if (type == 'advancedsearch') {
            dispatch(reqAdvancedSearch())
        } else {
            columnlist = 'personGUID,firstname,lastname,home_city,home_state,home_zip5,eaglecouncilnameandnumber,EagleScoutUnitNumber,EagleScoutUnitCity,EagleScoutUnitState,FacebookName,InstagramName,TwitterName,LinkedinName,CouncilNameAndNumber,currentcouncilnameandnumber,OwnerCouncilNameAndNumber,MembershipType,MembershipStatus,AlumniPrivacy'
            dispatch(requestpreference())
        }
        fetch(QUICK_SEARCH_URL + `Method=CreateReportFileOutputFromContext&ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=` + start + `&FinishPageNumber=` + end + `&columnlist=` + columnlist, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(AlumniRecords => {
                if (type == 'advancedsearch') {
                    dispatch(recAdvancedSearch(AlumniRecords))
                } else {
                    dispatch(receiveprefrencelist(AlumniRecords));
                }
            })
            .catch(error => {
                console.log(error);
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${QUICK_SEARCH_URL + `Method=CreateReportFileOutputFromContext&ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=` + start + `&FinishPageNumber=` + end + `&columnlist=` + columnlist}`), { extra: { api: QUICK_SEARCH_URL + `Method=CreateReportFileOutputFromContext&ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=` + start + `&FinishPageNumber=` + end + `&columnlist=` + columnlist, error } });
            });
    }
}



export const downloadAdvanceSearchResultsAsCSV = (fileName) => async (dispatch) => {
  try {
    dispatch({
      type: ACTIONTYPES.DOWNLOADING_CSV
    });
    // Fetch report to download
    advacnedSearchFormData.append('output', '@CSV');

    const reportResponse = await fetch(GENERATE_REPORT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": 'application/x-www-form-urlencoded',
      },
      body: advacnedSearchFormData.toString()
    });

    const finalData = await reportResponse.blob();

    downloadCSVFunction(finalData, fileName);

    dispatch({
      type: ACTIONTYPES.DOWNLOADED_CSV
    });

  } catch (error) {
    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GENERATE_REPORT}`), { extra: { api: GENERATE_REPORT, error } });
    dispatch({
      type: ACTIONTYPES.DOWNLOAD_CSV_ERROR,
      payload: error.message
    });

    throw error;
  }
};

const generateSecret = (title, docID) => new Promise((resolve) => {
    const ID = `4qp0o55x8sur0ypr7e6h2y54tdurswhxaccesspublicactionissuu.document_embeds.listapiKeyoxkxdg801puy0y55z7gkejxtw8ntln3mdocumentId${docID}formatjson`;
    const Secret = md5(ID);
    fetch(`https://api.issuu.com/1_0?action=issuu.document_embeds.list&apiKey=oxkxdg801puy0y55z7gkejxtw8ntln3m&access=public&documentId=${docID}&format=json&signature=${Secret}`, {
        method: 'GET',
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then((response) => {
            return resolve({ title, response })
        })
});

const fetchPublications = () => {
    return fetch('https://api.issuu.com/1_0?action=issuu.bookmarks.list&apiKey=oxkxdg801puy0y55z7gkejxtw8ntln3m&access=public&folderId=042dba6b-dddb-440e-9dcd-c0810788928d&format=json&signature=f171d2b77ec6384d6601ad6df7dd8d5a', {
        method: 'GET',
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(publications => {
            const file = publications.rsp._content.result._content;
            return Promise.all([...file.map((data) => generateSecret(data.bookmark.title, data.bookmark.documentId))]);
        })
}

// const memoizedFetchPublications = memoize(
//     (personGUID) => fetchPublications(personGUID),
//     (newArgs, lastArgs) => {
//         if (newArgs.length !== lastArgs.length) {
//             return false;
//         }
//         const [currentPersonGuid] = lastArgs;
//         const [newPersonGuid] = newArgs;
//         return currentPersonGuid === newPersonGuid;
//     });

// export function loadpublications() {
//     const loggedinUser = JSON.parse(localStorage.getItem('user'))
//     let personGUID = loggedinUser.personGuid;
//     return function (dispatch) {
//         dispatch(requestpublications())
//         // memoizedFetchPublications(personGUID)
//             .then((publications) => {
//                 dispatch(receivepublication(publications));
//             })
//             .catch(error => {
//                 console.log(error);
//             });
//     }
// }

function requestpublications() {
    return {
        type: ACTIONTYPES.PUBLICATIONS_LOADING,
    }
}

function receivepublication(publications) {
    return {
        type: ACTIONTYPES.PUBLICATIONS,
        publications: publications
    }
}

export function getmypreferencelist() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestmypreferencelist())
        fetch(GET_PREFERENCE_LIST + '&ListTYpe=1&PersonGUID=' + personGUID, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivemypreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&ListTYpe=1&PersonGUID=' + personGUID}`), { extra: { api: GET_PREFERENCE_LIST + '&ListTYpe=1&PersonGUID=' + personGUID, error } });
                console.log(error);
            });

    }
}

function requestmypreferencelist() {
    return {
        type: ACTIONTYPES.MY_PREFERENCE_LIST_LOADING,
    }
}


function receivemypreferencelist(preferencelist) {
    return {
        type: ACTIONTYPES.MY_PREFERENCE_LIST,
        preferencelist: preferencelist
    }
}


export function searchmylist(searchtxt) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestmypreferencelist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=1&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivemypreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=1&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=1&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, error } });
                console.log(error);
            });

    }
}


export function deletemylist(preferencename) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestpublicpreferencelist())
        fetch(DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(deletedstatus => {
                dispatch(getmypreferencelist());
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename}`), { extra: { api: DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename, error } });
                console.log(error);
            });

    }
}


export function getpublicpreferencelist() {
    return function (dispatch) {
        dispatch(requestpublicpreferencelist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2', {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivepublicpreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2'}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2', error } });
                console.log(error);
            });

    }
}

function requestpublicpreferencelist() {
    return {
        type: ACTIONTYPES.PUBLIC_PREFERENCE_LIST_LOADING,
    }
}


function receivepublicpreferencelist(preferencelist) {
    return {
        type: ACTIONTYPES.PUBLIC_PREFERENCE_LIST,
        preferencelist: preferencelist
    }
}

export function deletepubliclist(preferencename) {
    return function (dispatch) {
        dispatch(requestpublicpreferencelist())
        fetch(DELETE_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&PreferenceName=' + preferencename, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(deletedstatus => {
                dispatch(getpublicpreferencelist());
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${DELETE_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&PreferenceName=' + preferencename}`), { extra: { api: DELETE_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&PreferenceName=' + preferencename, error } });
                console.log(error);
            });

    }
}

export function searchpubliclist(searchtxt) {
    return function (dispatch) {
        dispatch(requestpublicpreferencelist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivepublicpreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=00000000-0000-0000-0000-000000000000&ListType=2&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, error } });
                console.log(error);
            });

    }
}

export function getquickpreferencelist() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestquickpreferencelist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3', {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivequickpreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3'}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3', error } });
                console.log(error);
            });

    }
}

function requestquickpreferencelist() {
    return {
        type: ACTIONTYPES.QUICK_PREFERENCE_LIST_LOADING,
    }
}


function receivequickpreferencelist(preferencelist) {
    return {
        type: ACTIONTYPES.QUICK_PREFERENCE_LIST,
        preferencelist: preferencelist
    }
}

export function deletequicklist(preferencename) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestquickpreferencelist())
        fetch(DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(deletedstatus => {
                dispatch(getquickpreferencelist());
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename}`), { extra: { api: DELETE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + preferencename, error } });
                console.log(error);
            });

    }
}

export function searchquicklist(searchtxt) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestpublicpreferencelist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivequickpreferencelist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&ListType=3&PreferenceNameStartWith=' + searchtxt + '&PreferenceNameIncludes=' + searchtxt, error } });
                console.log(error);
            });

    }
}


export function getdashboardmylist() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestdashboardmylist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=1', {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivedashboardmylist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=1'}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=1', error } });
                console.log(error);
            });

    }
}

function requestdashboardmylist() {
    return {
        type: ACTIONTYPES.DASHBOARD_MY_PREFERENCE_LIST_LOADING,
    }
}


function receivedashboardmylist(preferencelist) {
    return {
        type: ACTIONTYPES.DASHBOARD_MY_PREFERENCE_LIST,
        preferencelist: preferencelist
    }
}

export function getdashboardquicklist() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(requestdashboardquicklist())
        fetch(GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=3', {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(preferencelist => {
                dispatch(receivedashboardquicklist(preferencelist));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=3'}`), { extra: { api: GET_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&RecordCount=10&ListType=3', error } });
                console.log(error);
            });

    }
}

function requestdashboardquicklist() {
    return {
        type: ACTIONTYPES.DASHBOARD_QUICK_PREFERENCE_LIST_LOADING,
    }
}

function receivedashboardquicklist(preferencelist) {
    return {
        type: ACTIONTYPES.DASHBOARD_QUICK_PREFERENCE_LIST,
        preferencelist: preferencelist
    }
}

const parseError = (error) => {
    // API error response (Axios or custom)
    if (error && error.response && error.response.data) {
      return {
        code: error.response.data.response_code || "Error",
        message: error.response.data.response_message || "Something went wrong"
      };
    }
  
    // Fetch manual throw (you throw JSON)
    if (error && error.errorCode || error && error.errorDesc) {
      return {
        code: error.errorCode,
        message: error.errorDesc
      };
    }
  
    // Native JS / network error
    if (error instanceof Error) {
      return {
        code: "Error",
        message: error.message
      };
    }
  
    return {
      code: "Error",
      message: "Something unexpected happened"
    };
  };

// const advanceSearchdata = {
//     "response_code": "1",
//     "response_message": "Success",
//     "total_record_count": 10,
//     "persons": [
//       {
//         "memberid": 10231,
//         "firstname": "James",
//         "lastname": "Walker",
//         "home_state": "Texas",
//         "personguid": "9f1c8b2d-7a4a-4f6a-9e88-12c0e5c1d111",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Dallas",
//         "eaglescoutunitstate": "TX",
//         "eaglescoutunitnumber": 412,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Circle Ten Council 571",
//         "councilaffiliation": "Circle Ten"
//       },
//       {
//         "memberid": 10232,
//         "firstname": "Michael",
//         "lastname": "Garcia",
//         "home_state": "California",
//         "personguid": "c27f2a5d-3d7c-4bde-ae92-44a32a881234",
//         "alumniprivacy": "Private",
//         "eaglescoutunitcity": "San Diego",
//         "eaglescoutunitstate": "CA",
//         "eaglescoutunitnumber": 110,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "San Diego-Imperial Council 049",
//         "councilaffiliation": "San Diego"
//       },
//       {
//         "memberid": 10233,
//         "firstname": "Daniel",
//         "lastname": "Smith",
//         "home_state": "Florida",
//         "personguid": "b8c6c2f0-1a9e-4c2b-92c1-9933d22a9876",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Orlando",
//         "eaglescoutunitstate": "FL",
//         "eaglescoutunitnumber": 208,
//         "eaglescoutunittype": "Crew",
//         "eaglecouncilnameandnumber": "Central Florida Council 083",
//         "councilaffiliation": "Central Florida"
//       },
//       {
//         "memberid": 10234,
//         "firstname": "David",
//         "lastname": "Johnson",
//         "home_state": "Arizona",
//         "personguid": "71a4e0b3-5f3e-4a22-bc41-0a8cfa0b7b55",
//         "alumniprivacy": "FriendsOnly",
//         "eaglescoutunitcity": "Phoenix",
//         "eaglescoutunitstate": "AZ",
//         "eaglescoutunitnumber": 322,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Grand Canyon Council 010",
//         "councilaffiliation": "Grand Canyon"
//       },
//       {
//         "memberid": 10235,
//         "firstname": "Matthew",
//         "lastname": "Brown",
//         "home_state": "Colorado",
//         "personguid": "2e4d6f77-2e2b-4e9d-8f35-3a9d4b8f9988",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Denver",
//         "eaglescoutunitstate": "CO",
//         "eaglescoutunitnumber": 87,
//         "eaglescoutunittype": "Ship",
//         "eaglecouncilnameandnumber": "Denver Area Council 061",
//         "councilaffiliation": "Denver Area"
//       },
//       {
//         "memberid": 10236,
//         "firstname": "Andrew",
//         "lastname": "Taylor",
//         "home_state": "Georgia",
//         "personguid": "aa12c8f3-14f3-4c4a-9f99-73e9b5baf111",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Atlanta",
//         "eaglescoutunitstate": "GA",
//         "eaglescoutunitnumber": 150,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Atlanta Area Council 092",
//         "councilaffiliation": "Atlanta Area"
//       },
//       {
//         "memberid": 10237,
//         "firstname": "Joseph",
//         "lastname": "Martinez",
//         "home_state": "Nevada",
//         "personguid": "34a7c8b1-90f2-4a74-bc6b-8cbb7f777321",
//         "alumniprivacy": "Private",
//         "eaglescoutunitcity": "Las Vegas",
//         "eaglescoutunitstate": "NV",
//         "eaglescoutunitnumber": 199,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Las Vegas Area Council 329",
//         "councilaffiliation": "Las Vegas"
//       },
//       {
//         "memberid": 10238,
//         "firstname": "Christopher",
//         "lastname": "Lee",
//         "home_state": "Washington",
//         "personguid": "d3e90a8e-3a8b-4b23-b7f0-1122f5c0abcd",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Seattle",
//         "eaglescoutunitstate": "WA",
//         "eaglescoutunitnumber": 305,
//         "eaglescoutunittype": "Crew",
//         "eaglecouncilnameandnumber": "Chief Seattle Council 609",
//         "councilaffiliation": "Chief Seattle"
//       },
//       {
//         "memberid": 10239,
//         "firstname": "Ryan",
//         "lastname": "Harris",
//         "home_state": "Illinois",
//         "personguid": "e98fa5a2-1f4b-47f0-a0f1-98dabcdd3456",
//         "alumniprivacy": "FriendsOnly",
//         "eaglescoutunitcity": "Chicago",
//         "eaglescoutunitstate": "IL",
//         "eaglescoutunitnumber": 44,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Pathway to Adventure Council 127",
//         "councilaffiliation": "Pathway to Adventure"
//       },
//       {
//         "memberid": 10240,
//         "firstname": "Kevin",
//         "lastname": "Clark",
//         "home_state": "Virginia",
//         "personguid": "6dbe9c7a-0b8e-45aa-91d0-77f4c1c99876",
//         "alumniprivacy": "Public",
//         "eaglescoutunitcity": "Richmond",
//         "eaglescoutunitstate": "VA",
//         "eaglescoutunitnumber": 260,
//         "eaglescoutunittype": "Troop",
//         "eaglecouncilnameandnumber": "Heart of Virginia Council 602",
//         "councilaffiliation": "Heart of Virginia"
//       }
//     ]
//   }

export const getAdvancedSearchResults = (filters, columnList, maxRecords = 5000, pageNumber, recordsPerPage, totalRecordCount = 0) => {
    const AlumniRecordsRoot = {
        root: {
            RecordCount: 0
        }
    }

    const necessaryColumns = ['personguid','alumniprivacy'];

    const apiColumnList = [...columnList];

    necessaryColumns.forEach(col => {
        if (!apiColumnList.includes(col)) apiColumnList.push(col)
    });

    return async function (dispatch) {
        // if (advanceSearchdata) {
        //     const total_record_count = advanceSearchdata.total_record_count;

        //     AlumniRecordsRoot.root.RecordCount = advanceSearchdata.persons.length ? advanceSearchdata.record_count : '0'
        //     dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });
        //     dispatch(quickSearchRoot(AlumniRecordsRoot.root))
        //     return dispatch(recAdvancedSearch(advanceSearchdata.persons, 100, 2));
        // }
        if (maxRecords) {
            const getMaxCount = getMaxRecordCount(maxRecords, pageNumber, recordsPerPage, totalRecordCount, 5000);
            maxRecords = getMaxCount >= maxRecords ? getMaxCount : maxRecords;
        }
        try {
            // if (filters.length > 10) { // AAG-1264 only needed if OR/ AND NOT/ OR NOT, or Group filters are enabled
            //     throw new Error("Too many filter combinations. Please simplify your search.");
            // }
            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_START });

            const responses = await Promise.all(
                filters.map(filter =>
                    callAdvacnedSearchAPI(filter, apiColumnList, maxRecords, pageNumber, recordsPerPage, )
                )
            );
            const allPersons = responses.flatMap(r => r.persons || []);

            // const responses = await callAdvacnedSearchAPI(filters, maxRecords, pageNumber, recordsPerPage, )
            // const allPersons = responses.persons ? responses.persons : [];
            
            // const uniquePersons = dedupeResults(allPersons);
            const uniquePersons = allPersons;
            
            const total_record_count = responses[0].total_record_count;

            AlumniRecordsRoot.root.RecordCount = uniquePersons.length ? responses[0].record_count : '0'

            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });
            dispatch(quickSearchRoot(AlumniRecordsRoot.root))
            return dispatch(recAdvancedSearch(allPersons, maxRecords, total_record_count));

        } catch (error) {

            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${CREATE_REPORT_INSTANCE}`), { extra: { api: CREATE_REPORT_INSTANCE, error } });
            console.error("Search failed:", error);

            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });

            const parsed = parseError(error);

            Modal.error({
              className: "ErrorModal",
              title: "Search Failed",
              content: parsed.message || "Something went wrong while searching. Please try again.",
            });
          }

    };

};

function dedupeResults(results) {
    const map = new Map();

    results.forEach(item => {
        const key = item.personGuid || item.personguid; // handle both
        if (key) {
            map.set(key, item);
        }
    });

    return [...map.values()];
}

const fetchWithRetry = async (url, retries = 2) => {
    try {
        const res = await fetch(url);
        const data = await res.json();

        if (!data || data.length === 0) throw new Error("Empty");

        return data;
    } catch (err) {
        if (retries > 0) {
            return fetchWithRetry(url, retries - 1);
        }
        throw err;
    }
};

const callAdvacnedSearchAPI = async (filter, columnList, maxRecords, pageNumber, recordsPerPage) => {
    return await advacnedSearch(filter,columnList, maxRecords, pageNumber, recordsPerPage);
  };
  
  const advacnedSearch = async (filter, columnList, maxRecords, pageNumber, recordsPerPage) => {
  
    //request body
    const data = new URLSearchParams(filter || "");
  
    const url = new URL(CREATE_REPORT_INSTANCE);
  
    if (maxRecords) {
        data.append('maxRecords', maxRecords);
    }
  
    //Create context
    const createInstance = await fetch(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": 'application/x-www-form-urlencoded',
      },
      body: data.toString()
    });
  
    const instanceData = await createInstance.json().catch(() => ({}));
  
    if (!createInstance.ok) {
      throw new Error(
        instanceData.response_message || `Create instance failed (${createInstance.status})`
      );
    }
  
    if (instanceData.response_code !== "1") {
      throw new Error(instanceData.response_message || "Failed to create context");
    }
    
    
    //Fetch report
    const reportData = new URLSearchParams();
    reportData.append('context_token', instanceData.context_token);
    reportData.append('page_number', pageNumber);
    reportData.append('records_per_page', recordsPerPage);
    if (columnList.length) {
        reportData.append('column_list', columnList);
    }
    
    advacnedSearchFormData = reportData; //To use it later for exporting the response as a file

    const reportResponse = await fetch(GENERATE_REPORT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        "Content-Type": 'application/x-www-form-urlencoded',
      },
      body: reportData.toString()
    });
  
    const finalData = await reportResponse.json().catch(() => ({}));
  
    if (!reportResponse.ok) {
      throw new Error(
        finalData.response_message || `Report fetch failed (${reportResponse.status})`
      );
    }
  
    if (finalData.response_code !== "1") {
      throw new Error(finalData.response_message || "Failed to fetch report");
    }
  
    return finalData;
  };

// function getMaxRecordCount(maxRecords, pageNumber, perPage) {
//     let getVal = pageNumber * perPage;
//     console.log('getVal', getVal);
//     getVal = maxRecords == getVal ? getVal++ : getVal;
//     return Math.ceil(getVal / 10000) * 10000;
// }

function getMaxRecordCount(maxRecords, pageNumber, perPage, totalRecordCount = 0, blockSize = 10000) {
    const requiredRecords = pageNumber * perPage;

    // Requested page is already within the cached records
    if (requiredRecords <= maxRecords) {
        return maxRecords;
    }

    // Cache the next block of records
    const newMaxRecords =
        Math.ceil(requiredRecords / blockSize) * blockSize + blockSize;

    // If total count is known, don't exceed it
    if (totalRecordCount > 0) {
        return Math.min(newMaxRecords, totalRecordCount);
    }

    return newMaxRecords;
}

export function savelist(filters, listname, listtype, columnList, showmsg, recordsPerPage, pageNumber, maxRecords, getCouncilNumber, isEaglesOnly) {
    // if(!(filters.Expressions.some(exp => exp.ColumnName === "membershipstatus" && exp.Value === 'active')) ) 
    let columnlist = columnList;

    if (columnlist.includes("councilnumber")) {
        columnlist = columnlist.filter(col => col !== 'councilnumber')
    }

    const getMaxCount = getMaxRecordCount(maxRecords, pageNumber, recordsPerPage);
    maxRecords = getMaxCount >= maxRecords ? getMaxCount : maxRecords
    if (!columnlist.includes('TotalRecordCount')) columnlist.push('TotalRecordCount')

    let personGUID = ''
    if (!columnlist.includes("personguid")) {
        columnlist.push('personguid')
    }
    if (!columnlist.includes("AlumniPrivacy")) {
        columnlist.push('AlumniPrivacy')
    }
    if (columnlist.includes("ethnicity")) {
        columnlist[columnlist.indexOf('ethnicity')] = 'EthnicityID'
    }

    //AAG-1252 There’s no need to convert MID to SKpersonID in the columnList array, as it won’t work within the table columns. The conversion to SKpersonID is only required within the expressions.
    
    // if (columnlist.includes("memberid")) {
    //     columnlist[columnlist.indexOf('memberid')] = 'SKPersonID' //AAG-1246 added back SKPersonID
    // }

    // if (columnlist.includes("scoutingaffiliation")) {
    //     columnlist = columnlist.filter(e => e !== 'scoutingaffiliation')
    // }
    if (listtype == 1 || listtype == 3 || listtype == 4) {
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        personGUID = loggedinUser.personGuid;
    }
    if (listtype == 2) {
        personGUID = '00000000-0000-0000-0000-000000000000';
    }
    console.log('******* Filters Before Update', filters);

    let modifiedFilters = { ...filters };
    
    if (filters && Array.isArray(filters.Expressions) && filters.Expressions.length > 0) {
        // let getCouncilNumber;
        modifiedFilters.Expressions = filters.Expressions.map((eachExpression, i) => {
            // if (eachExpression.ColumnName.toLowerCase() === "councilnumber") {
            //     getCouncilNumber = eachExpression.Value.match(/\d+/)[0];
            // }
            if (eachExpression.ColumnName.toLowerCase() == "ethnicity") {
                return {
                    "ExpressionName": `exp${i}`,
                    "ColumnName": "EthnicityID",
                    "Operator": eachExpression.Operator,
                    "Value": eachExpression.Value
                }
            }
            if (eachExpression.ColumnName === "memberid") { //AAG-1246 added back SKPersonID
                return {
                    "ExpressionName": `exp${i}`,
                    "ColumnName": "SKPersonID",
                    "Operator": "EQ",
                    "Value": eachExpression.Value
                };
            }
            if (eachExpression.ColumnName === "socialmedia") {
                return {
                    "ExpressionName": `exp${i}`,
                    "ColumnName": eachExpression.Value,
                    "Operator": "EQ",
                    "Value": ""
                };
            }
            else if (eachExpression.ColumnName.toLowerCase() === "nationalaward" || eachExpression.ColumnName.toLowerCase() === "scoutingaffiliation" || eachExpression.ColumnName.toLowerCase() === "councilaffiliation" || eachExpression.ColumnName.toLowerCase() === "hobbiesandinterests" || eachExpression.ColumnName.toLowerCase() === 'businessandcareer' || eachExpression.ColumnName.toLowerCase() === 'eaglecouncilnameandnumber') {
                const hasNegativeOperator = ["NULL", "NOTNULL", "NE"].includes(eachExpression.Operator);
                return {
                    "ExpressionName": `exp${i}`,
                    "ColumnName": eachExpression.ColumnName,
                    "Operator": hasNegativeOperator ? eachExpression.Operator : "INCLUDE",
                    "Value": eachExpression.Value
                };
            } else {
                // let index = getIndex.length > 0 ? i - getIndex.length : i;
                return {
                    "ExpressionName": `exp${i}`,
                    "ColumnName": eachExpression.ColumnName,
                    "Operator": eachExpression.Operator,
                    "Value": eachExpression.Value
                };
            }
        }
        )
    } else {
        modifiedFilters = {
            Formula: "()",
            Expressions: []
        }
    }
   
    // const formula = filters.Formula;
    // const formulaArray = formula.match(/\( |@exp\d+ (?:AND NOT|AND|OR NOT|OR) |@exp\d+ |\) |AND|OR/g)
    // .map(match => match.trim())
    // .filter(match => match !== "");

    // let getIndex = [];
    // let modifiedFilters = [];

    // const modifyFormula = (expressionIndex) => {
    //     let removeExp = [];
    //     formulaArray.splice(expressionIndex, 1);
    //     formulaArray.forEach((eachFor, i) => {
    //         if (expressionIndex <= i) {
    //             removeExp.push(eachFor.replace(`@exp${i + 1}`, `@exp${i}`));
    //         } else {
    //             removeExp.push(eachFor);
    //         }
    //     });
    //     return removeExp.join(' '); // Join the array to form a string
    // };

    // filters.Expressions.forEach((eachExpression, i) => {
    //     if (eachExpression.ColumnName === "socialmedia") {
    //         getIndex.push(eachExpression.ExpressionName);
    //         let expressionIndex = Number(eachExpression.ExpressionName.replace('exp', ''));
    //         filters.Formula = modifyFormula(expressionIndex);
    //     } else {
    //         let index = getIndex.length > 0 ? i - getIndex.length : i;
    //         modifiedFilters.push({
    //             "ExpressionName": `exp${index}`,
    //             "ColumnName": eachExpression.ColumnName,
    //             "Operator": eachExpression.Operator,
    //             "Value": eachExpression.Value
    //         });
    //     }
    // });

    // filters.Expressions = modifiedFilters;


    // console.log('******* Filters After Update', filters);

    return function (dispatch) {
        if (window.location.pathname.includes('/alumni-search')) {
            dispatch({ type: ACTIONTYPES.ALUMNI_RECORDS_LOADING_START });
            dispatch(RunPreference(listname, listtype, columnlist, recordsPerPage, pageNumber, maxRecords, getCouncilNumber, isEaglesOnly, filters));
            return; 
        } 
        else if (window.location.pathname.includes('/quick-search')) {
            dispatch({ type: ACTIONTYPES.QUICK_RECORDS_LOADING_START });
        } else {
            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_START });
        }

        dispatch(requestpreferencedata())
        dispatch(requestdashboardmylist())

        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        const isAlumni = loggedinUser && !loggedinUser.isadmin
        const isAdmin = loggedinUser && loggedinUser.isadmin

        let columnListURL = '';
        let preferenceURL = '';

        const isSearchList = listname === 'quicksearch' || listname === 'advancedsearch';
        const isSearchPath = window.location.pathname.includes('/quick-search') || window.location.pathname.includes('/advanced-search');

        // if ( isAlumni || isAdmin && (listname === 'quicksearch' || listname === 'advancedsearch') && ( window.location.pathname.includes('/alumni-search') || window.location.pathname.includes('/quick-search'))) {
        if ((isAlumni || isAdmin) && isSearchList && isSearchPath) {
            columnListURL = SAVE_COLUMN_LIST +
                '&PersonGUID=' + personGUID +
                '&PreferenceName=' + listname +
                '&IsQuickSearch=1' +
                '&ListType=' + listtype;

            preferenceURL = SAVE_PREFERENCE_LIST +
                '&PersonGUID=' + personGUID +
                '&PreferenceName=' + listname +
                '&IsQuickSearch=1' +
                '&ListType=' + listtype;
        } else {
            columnListURL = SAVE_COLUMN_LIST +
                '&PersonGUID=' + personGUID +
                '&PreferenceName=' + listname +
                '&ListType=' + listtype;

            preferenceURL = SAVE_PREFERENCE_LIST +
                '&PersonGUID=' + personGUID +
                '&PreferenceName=' + listname +
                '&ListType=' + listtype;
        }

        //Save Column Names
        // fetch(SAVE_COLUMN_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + listname + '&ListType=' + listtype, {
        fetch(columnListURL, {
            method: 'POST',
            credentials: 'include',
            headers: {

                "Content-Type": "application/json",
            },
            body: JSON.stringify(
                columnlist
            ),
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(response => {

        // fetch(SAVE_PREFERENCE_LIST + '&PersonGUID=' + personGUID + '&PreferenceName=' + listname + '&ListType=' + listtype, {
        fetch(preferenceURL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(
                modifiedFilters
            ),
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                if (response.ResponseCode != "1") {
                    Modal.error({
                        className: "ErrorModal",
                        title: 'Error',
                        content: response.ResponseMessage,
                    });
                }
                if (listname == 'quicksearch') {
                    dispatch(RunPreference('quicksearch', 4, columnlist, recordsPerPage, pageNumber, maxRecords, getCouncilNumber, isEaglesOnly))
                    Preference_Name = 'quicksearch'
                    Preference_Type = 4
                    Preference_column = columnlist
                }
                if ((listname == "advancedsearch" || listtype == '1' || listtype == '2' || listtype == '3' || listtype == '4') && !showmsg) {
                    dispatch(RunPreference('advancedsearch', 4, columnlist, recordsPerPage, pageNumber, maxRecords, getCouncilNumber, isEaglesOnly))
                }
                if (listname != 'quicksearch' && listname != 'advancedsearch' && showmsg) {
                    if (response.ResponseCode == 1) {
                        let redirectTo;
                        if (window.location.pathname.includes('list-and-search')) {
                            redirectTo = `/list-and-search/${encodeURIComponent(listname)}/${listtype}/e`;
                        }

                        Modal.success({
                            className: "ErrorModal",
                            title: 'Success',
                            content: 'List created successfully!',
                            onOk() {
                                if (redirectTo != '') {
                                    history.push(redirectTo);
                                    window.location.reload();
                                } else {
                                    window.location.reload()
                                }
                            }
                        });
                    } else {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'List is not created!',
                        });
                    }
                }
            })
         })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${preferenceURL}`), { extra: { api: preferenceURL, error } });
                console.log(error);
                dispatch({
                    type: ACTIONTYPES.GET_PREFERENCE_DATA_FAILURE,
                    error: error
                });
            });
    }
}

export function RunPreference(preferencename, listtype, columnlist, recordsPerPage, pageNumber, maxRecords, getCouncilNumber, isEaglesOnly, filters) {
    const additionalColumns = ['AlumniPrivacy', 'EagleScoutUnitCity', 'EagleScoutUnitState', 'EagleScoutUnitNumber', 'EagleScoutUnitType', 'EagleCouncilNameAndNumber', 'councilAffiliation']

    additionalColumns.forEach(column => {
        if (!columnlist.includes(column)) {
            columnlist.push(column);
        }
    });

    return function (dispatch) {
        if (preferencename == 'quicksearch') {
            dispatch(requestpreference())
        } else {
            dispatch(reqAdvancedSearch())
        }
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        const isAlumni = loggedinUser && !loggedinUser.isadmin
        const isAdmin = loggedinUser && loggedinUser.isadmin
        let personGUID = loggedinUser.personGuid;
        if (listtype == 2) personGUID = "00000000-0000-0000-0000-000000000000"
        // passing isdeceased and nesa affiliation as URL encoded params
        let formBody = [];

        let encodedKey1 = encodeURIComponent('isDeceasedIncluded');
        let encodedValue1 = encodeURIComponent(1);
        formBody.push(encodedKey1 + '=' + encodedValue1);

        if (window.location.pathname.includes('/alumni-search')) {
            let firstNameExp = null;
            let lastNameExp = null;

            if (filters && filters.Expressions && Array.isArray(filters.Expressions)) {
                firstNameExp = filters.Expressions.find(
                    exp => exp.ColumnName && exp.ColumnName.toLowerCase() === "firstname" && exp.Value
                );
                lastNameExp = filters.Expressions.find(
                    exp => exp.ColumnName && exp.ColumnName.toLowerCase() === "lastname" && exp.Value
                );
            }

            if (firstNameExp) {
                formBody.push("FirstName=" + encodeURIComponent(firstNameExp.Value));
            }
            if (lastNameExp) {
                formBody.push("LastName=" + encodeURIComponent(lastNameExp.Value));
            }
        }

        if (getCouncilNumber) {
            let encodedKey2 = encodeURIComponent('councilNumber');
            let encodedValue2 = encodeURIComponent(getCouncilNumber);
            formBody.push(encodedKey2 + '=' + encodedValue2);
        }
        if (isEaglesOnly) {
            let encodedKey3 = encodeURIComponent('isEaglesOnly');
            let encodedValue3 = encodeURIComponent(Number(isEaglesOnly));
            formBody.push(encodedKey3 + '=' + encodedValue3);
        }
        
        formBody = formBody.join("&");
        
        let quickSearchURL = '';

        if ((isAlumni || isAdmin) && (preferencename === 'quicksearch' || preferencename === 'advancedsearch') && (window.location.pathname.includes('/alumni-search') || window.location.pathname.includes('/quick-search') || window.location.pathname.includes('/advanced-search'))) {
            quickSearchURL = `${QUICK_SEARCH_INSTANCE_URL}&personGUID=${personGUID}&preferencename=${preferencename}&IsQuickSearch=1&listtype=${listtype}&PageRecordCount=${recordsPerPage}${maxRecords != null ? `&MaxRecords=${maxRecords}` : ''}&IsAllRecords=0`;
        } else {
            quickSearchURL = `${QUICK_SEARCH_INSTANCE_URL}&personGUID=${personGUID}&preferencename=${preferencename}&listtype=${listtype}&PageRecordCount=${recordsPerPage}${maxRecords != null ? `&MaxRecords=${maxRecords}` : ''}&IsAllRecords=0`;
        }

        // fetch(`${QUICK_SEARCH_INSTANCE_URL}&personGUID=${personGUID}&preferencename=${preferencename}&IsQuickSearch=1&listtype=${listtype}&PageRecordCount=${recordsPerPage}${maxRecords != null ? `&MaxRecords=${maxRecords}` : ''}&IsAllRecords=0`, {
        fetch(quickSearchURL, {
            method: 'POST',
            credentials: 'include',
            cache: "no-cache",
            body: formBody
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(AlumniRecordsRoot => {
                let ContextToken = AlumniRecordsRoot.root.ContextToken
                QuickSearchContextToken = ContextToken
                dispatch(quickSearchRoot(AlumniRecordsRoot.root))
                localStorage.setItem('ContextToken', ContextToken)
                if (AlumniRecordsRoot.root.RecordCount === 0) {
                    // Handle no records found
                    if (preferencename === 'quicksearch') {
                        dispatch(receiveprefrencelist([], maxRecords, 0, filters));
                    } else {
                        dispatch(recAdvancedSearch([], maxRecords, 0));
                    }
                }
                fetch(RUN_PREFERENCE_LIST + `ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=${pageNumber}&FinishPageNumber=${pageNumber}&columnlist=` + columnlist, {
                    method: 'GET',
                    credentials: 'include',
                    cache: "no-cache"
                })
                    .then(response => {
                        if (!response.ok) {
                            return Promise.reject(response.statusText);
                        }
                        return response.json();
                    })
                    .then(response => {
                        for (const value of response) {
                            const keys = Object.keys(value)
                            for (const key of keys) {
                                //console.log(value['rushshipping'])
                                if (value['rushshipping'] === true || value['rushshipping'] === 'YES') {
                                    value['rushshipping'] = 'YES';
                                } else {
                                    value['rushshipping'] = 'NO';
                                }
                                if (typeof value[key] === 'boolean') {
                                    value[key] = JSON.stringify(value[key]);
                                }
                            }
                        }
                        let TotalRecordCount;
                        if (Array.isArray(response) && response[0].hasOwnProperty('totalrecordcount')) {
                            TotalRecordCount = response[0].totalrecordcount;
                        }
                        
                        // dispatch({ type: ACTIONTYPES.RECORDS_LOADING_STOP });

                        if (window.location.pathname.includes('/alumni-search')) {
                            dispatch({ type: ACTIONTYPES.ALUMNI_RECORDS_LOADING_STOP });
                        } else if (window.location.pathname.includes('/quick-search')) {
                            dispatch({ type: ACTIONTYPES.QUICK_RECORDS_LOADING_STOP });
                        } else {
                            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });
                        }


                        if (preferencename == 'quicksearch') {
                            dispatch(receiveprefrencelist(response, maxRecords, TotalRecordCount, filters))
                        } else {
                            dispatch(recAdvancedSearch(response, maxRecords, TotalRecordCount))
                        }
                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${RUN_PREFERENCE_LIST + `ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=${pageNumber}&FinishPageNumber=${pageNumber}&columnlist=` + columnlist}`), { extra: { api: RUN_PREFERENCE_LIST + `ContextToken=` + ContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=${pageNumber}&FinishPageNumber=${pageNumber}&columnlist=` + columnlist, error } });
                        console.log(error);
                        
                        // dispatch({ type: ACTIONTYPES.RECORDS_LOADING_STOP });

                        if (window.location.pathname.includes('/alumni-search')) {
                            dispatch({ type: ACTIONTYPES.ALUMNI_RECORDS_LOADING_STOP });
                        } else if (window.location.pathname.includes('/quick-search')) {
                            dispatch({ type: ACTIONTYPES.QUICK_RECORDS_LOADING_STOP });
                        } else {
                            dispatch({ type: ACTIONTYPES.ADVANCED_RECORDS_LOADING_STOP });
                        }
                    });

            })
            .catch(error => {
                console.log(error);
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${RUN_PREFERENCE_LIST}`), { extra: { api: RUN_PREFERENCE_LIST, error } });
            });
    }
}

export function SortTable(sortValues) {
    if (!Preference_column.includes("AlumniPrivacy")) {
        Preference_column.push('AlumniPrivacy')
    }
    let order = sortValues.order == "ascend" ? "ASC" : "DESC"
    return function (dispatch) {
        if (Preference_Name == 'advancedsearch') {
            dispatch(reqAdvancedSearch())
        } else {
            dispatch(requestpreference())
        }
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        fetch(QUICK_SEARCH_SORT_URL + `&ContextToken=` + QuickSearchContextToken + `&SortOrder=` + sortValues.columnKey
            + `@Column@` + order, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache"
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.text();
            })
            .then(SORT_RESPONSE => {
                let SORT_HTML = SORT_RESPONSE
                fetch(RUN_PREFERENCE_LIST + `&ContextToken=` + QuickSearchContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=1&FinishPageNumber=1&columnlist=` + Preference_column, {
                    method: 'GET',
                    cache: "no-cache"
                })
                    .then(response => {
                        if (!response.ok) {
                            return Promise.reject(response.statusText);
                        }
                        return response.json();
                    })
                    .then(response => {
                        if (Preference_Name == 'advancedsearch') {
                            dispatch(recAdvancedSearch(response))
                        } else {
                            dispatch(receiveprefrencelist(response))
                        }
                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${RUN_PREFERENCE_LIST + `&ContextToken=` + QuickSearchContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=1&FinishPageNumber=1&columnlist=` + Preference_column}`), { extra: { api: RUN_PREFERENCE_LIST + `&ContextToken=` + QuickSearchContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=1&FinishPageNumber=1&columnlist=` + Preference_column, error } });
                        console.log(error);
                    });

            })
            .catch(error => {
                console.log(error);
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${RUN_PREFERENCE_LIST + `&ContextToken=` + QuickSearchContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=1&FinishPageNumber=1&columnlist=` + Preference_column}`), { extra: { api: RUN_PREFERENCE_LIST + `&ContextToken=` + QuickSearchContextToken + `&OutputFormat=@Inline@json&SelectionType=Range&StartPageNumber=1&FinishPageNumber=1&columnlist=` + Preference_column, error } });
            });
    }
}


function quickSearchRoot(alumnirecordsroot) {
    return {
        type: ACTIONTYPES.QUICK_SEARCH_RECORDS_ROOT,
        alumnirecordsroot: alumnirecordsroot
    }
}

function reqAdvancedSearch() {
    return {
        type: ACTIONTYPES.ADVANCED_SEARCH_LIST_LOADING,
    }
}

function recAdvancedSearch(preferencelist, maxRecords, TotalRecordCount) {
    return {
        type: ACTIONTYPES.ADVANCED_SEARCH_LIST,
        preferencelist: preferencelist,
        maxRecords,
        TotalRecordCount
    }
}
export function removeAdvanceSearchResult() {
    return {
        type: ACTIONTYPES.REMOVE_ADVANCED_SEARCH_LIST
    }
}

export function removeQuickSearchResult() {
    return {
        type: ACTIONTYPES.REMOVE_QUICK_PREFERENCE_LIST
    }
}
function requestpreference() {
    return {
        type: ACTIONTYPES.RUN_PREFERENCE_LIST_LOADING,
    }
}


function receiveprefrencelist(preferencelist, maxRecords, TotalRecordCount, filters) {
    return {
        type: ACTIONTYPES.RUN_PREFERENCE_LIST,
        preferencelist: preferencelist,
        maxRecords,
        TotalRecordCount,
        filters
    }
}



function requestpreferencedata() {
    return {
        type: ACTIONTYPES.GET_PREFERENCE_DATA_LOADING,
    }
}

function sessionGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

function orderid() {
    return Math.round(new Date().getTime() + (Math.random() * 100));
}


export function generateUID(amount, programname, MerchantID, registration, email, phone, nesaType) {
    return function (dispatch) {
        dispatch(reqCreatePayments())

        const payload = {
            paymentTypeId: 1765,
            totalAmountDue: amount,
            nesaType: nesaType ? nesaType : undefined
        };

        Sentry.captureMessage(`payments Payload: RegistrationID ${registration.registrationId}`, {
            level: "info",
            extra: { payload }
        });

        fetch(ESB_REGISTRATIONS_1 + registration.registrationId + '/payments', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(payload)
            // body: JSON.stringify({ "paymentTypeId": 1765, "totalAmountDue": amount, "nesaType": nesaType ? nesaType : undefined })
        })
            .then(response => {
                if (!response.ok) {
                    Sentry.captureException(new Error(`payments API HTTP Error: ${response.status} ${response.statusText}`), {
                        extra: { registrationId: registration.registrationId, status: response.status }
                    });

                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                Sentry.captureEvent({
                    message: `payments Response: RegistrationID ${registration.registrationId}`,
                    level: "info",
                    extra: { response: response }
                });

                dispatch(getCreatePayments(response))
            })
            .catch(error => {
                Sentry.captureException(error, {
                    extra: {
                        context: "Payments API Error",
                        registrationId: registration.registrationId,
                        payload
                    }
                });

                console.log(error);
            });
    }
}

function extractChaseFailureDetail(response) {
    let detail = response && response.Message;
    if (typeof detail === 'string') {
        try {
            const parsed = JSON.parse(detail);
            if (parsed && typeof parsed === 'object') {
                detail = parsed.code || parsed.message || null;
            }
        } catch (e) {
            
        }
    } else if (detail && typeof detail === 'object') {
        detail = detail.code || detail.message || null;
    }
    return (typeof detail === 'string' && detail.trim()) ? detail.trim() : null;
}

export function InitOrbitalPayments(amount, programname, MerchantID, registration, email, response, donotUpdateHomeAddress, isNesaManualFee) { //AAG-971 Remove 'Scout's Phone Number from NESA application process
    return function (dispatch) {
        dispatch(requestinittransaction())
        InitPaymentResponse = response
        MembershipAmountPaid = amount
        let PurchasingPersonAddress = {}
        let Address_value = ''
        let Customer_Name = ''
        const lowerCaseProgramName = programname.toLowerCase();

        if (lowerCaseProgramName.includes('upgrade')) {
            redirectReceiptComponentTo = "RENEW";
        } else if (lowerCaseProgramName.includes('admin')) {
            redirectReceiptComponentTo = programname; //It'll be "ADMIN NESA" 
            programname = "NESA"; // Reassign programname if it includes 'admin', Cuz we don't have "ADMIN NESA" productName/Type
        } else {
            redirectReceiptComponentTo = programname;
        }

        if (programname == 'GIFT NESA') {
            PurchasingPersonAddress = PurchasingPerson
            Address_value = PurchasingPersonAddress ? PurchasingPerson.g_address_line_1 + ', ' + PurchasingPerson.g_city + ', ' + PurchasingPerson.stateName + ', ' + PurchasingPerson.g_zip_code : ""
            Customer_Name = PurchasingPersonAddress ? PurchasingPersonAddress.g_first_name + " " + PurchasingPersonAddress.g_last_name : ""
        } else {
            // PurchasingPersonAddress = PurchasingPerson.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
            PurchasingPersonAddress = PurchasingPerson
            Address_value = PurchasingPersonAddress ? PurchasingPerson.addressline1 + ', ' + PurchasingPerson.addressline2 + ', ' + PurchasingPerson.city + ', ' + PurchasingPerson.stateName + ', ' + PurchasingPerson.zipcode : ''
            Customer_Name = PurchasingPersonAddress ? PurchasingPersonAddress.firstname + " " + PurchasingPersonAddress.lastname : ""
            // Customer_Name = PurchasingPerson.profile ? PurchasingPerson.profile.firstName : "" + ' ' + PurchasingPerson.profile ? PurchasingPerson.profile.lastName : ""
        }
        if (response.message === "Successfully created" || programname == 'BULK NESA') {
            let postdata = {}
            let orderId = Array.from({ length: 10 }, () => Math.floor(Math.random() * 10)).join('')
            if (programname == 'BULK NESA') {
                postdata = {
                    "sessionID": "sessionId:" + sessionGUID() + "::merchantid:" + MerchantID + `::programname:${programname}` + "::email:" + email + "::applicantMemberId:" + registration.importid + "::registrationId:" + registration.importid,
                    "amount": amount,
                    "order_desc": "NESA BULK UPLOAD - OrderID=" + orderId,
                    "orderId": orderId,
                    "MerchantID": MerchantID,
                    "payment_type": "Credit_Card",
                    "council_guid": "F3A77C78-EE20-474E-9219-D53400753B29",
                    //"customer_email": email,
                    //"postTrans_registrationId": registration.registrationId.toString(),
                    // "postTrans_paymentId": response.id.toString(),
                    "postTrans_mode": programname.toLowerCase(),
                    "name": '',
                    // "postTrans_customer_address": Address_value,
                    "postTrans_paymentTypeLookupId": 1765
                }
            }
            else {
                postdata = { //AAG-971 Remove 'Scout's Phone Number from NESA application process
                    "sessionID": "sessionId:" + sessionGUID() + "::merchantid:" + MerchantID + `::programname:${programname}` + "::email:" + email + "::applicantMemberId:" + registration.applicantMemberId + "::registrationId:" + registration.registrationId,
                    "amount": amount,
                    "order_desc": response.orderDescription,
                    "orderId": response.orderId.toString(),
                    "MerchantID": MerchantID,
                    "payment_type": "Credit_Card",
                    "council_guid": "F3A77C78-EE20-474E-9219-D53400753B29",
                    "customer_email": email,
                    "postTrans_registrationId": registration.registrationId.toString(),
                    "postTrans_paymentId": response.id.toString(),
                    "postTrans_mode": programname.toLowerCase(),
                    "name": '',
                    "postTrans_customer_address": Address_value,
                    "postTrans_paymentTypeLookupId": 1765,
                    "isNesaManualFee": typeof isNesaManualFee === "boolean" ? isNesaManualFee : undefined,
                    "donotUpdateHomeAddress": typeof donotUpdateHomeAddress === "boolean" ? donotUpdateHomeAddress : true
                }
            }

            fetch(CHASE_INIT_TRANSACTION, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(
                    postdata
                )
            })
                .then(response => {
                    if (!response.ok) {
                        return Promise.reject(response.statusText);
                    }
                    return response.json();
                })
                .then(response => {
                    if (!response || !response.uID) {
                        const detail = extractChaseFailureDetail(response);
                        Sentry.captureException(new Error(`${detail || "Chase init transaction failed"} - ${CHASE_INIT_TRANSACTION}`), { extra: { api: CHASE_INIT_TRANSACTION, response } });
                        console.log(response);
                        Modal.error({
                            className: "ErrorModal",
                            title: "Payment Could Not Be Started",
                            content: detail
                                ? `We were unable to start the payment process (${detail}). Please try again, or contact support if the issue continues.`
                                : "We were unable to start the payment process. Please try again, or contact support if the issue continues.",
                        });
                        dispatch(getinittransaction(null))
                        return;
                    }
                    dispatch(getinittransaction(response))
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${CHASE_INIT_TRANSACTION}`), { extra: { api: CHASE_INIT_TRANSACTION, error } });
                    console.log(error);
                    Modal.error({
                        className: "ErrorModal",
                        title: "Payment Could Not Be Started",
                        content: "We were unable to start the payment process. Please try again, or contact support if the issue continues.",
                    });
                    dispatch(getinittransaction(null))
                });
        }
    }
}

function reqCreatePayments() {
    return {
        type: ACTIONTYPES.PAYMENTS_CREATING,
    }
}

function getCreatePayments(response) {
    return {
        type: ACTIONTYPES.PAYMENTS_CREATED,
        response: response
    }
}

function requestinittransaction() {
    return {
        type: ACTIONTYPES.CHASE_PAYMENT_LOADING,
    }
}

function getinittransaction(initTransaction) {
    return {
        type: ACTIONTYPES.CHASE_PAYMENT_INIT,
        initTransaction: initTransaction
    }
}

export function getevents() {
    return function (dispatch) {
        dispatch(requestevents())
        fetch('https://nesa.org/wp-json/tribe/events/v1/events', {
            cache: "no-cache",
            method: 'GET',
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(events => {
                dispatch(receiveevents(events));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${'https://nesa.org/wp-json/tribe/events/v1/events'}`), { extra: { api: 'https://nesa.org/wp-json/tribe/events/v1/events', error } });
                console.log(error);
            });

    }
}

function requestevents() {
    return {
        type: ACTIONTYPES.GET_EVENTS_LOADING,
    }
}

function receiveevents(events) {
    return {
        type: ACTIONTYPES.GET_EVENTS,
        events: events
    }
}

export function getProcessedMembership(page, perpage, search, sort) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let searchkeyword = ''

    let sortOrder = '&sortOrder=des'
    if (sort == 'ascend') sortOrder = '&sortOrder=asc'

    if (search != '') searchkeyword = '&lastNameSearch=' + search //'&nameSearch=' + search
    return function (dispatch) {
        dispatch(reqProcessedMembership())
        fetch(GET_PROCESSED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(processedmemberships => {
                dispatch(recProcessedMembership(processedmemberships));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PROCESSED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder}`), { extra: { api: GET_PROCESSED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, error } });
                console.log(error);
            });

    }
}

function reqProcessedMembership() {
    return {
        type: ACTIONTYPES.PROCESSED_MEMBERSHIP_LOADING,
    }
}

function recProcessedMembership(processedmemberships) {
    return {
        type: ACTIONTYPES.PROCESSED_MEMBERSHIP_RECEIVED,
        processedmemberships: processedmemberships
    }
}


export function getDeniedMembership(page, perpage, search, sort) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let searchkeyword = ''
    let sortOrder = '&sortOrder=des'
    if (sort == 'ascend') sortOrder = '&sortOrder=asc'
    if (search != '') searchkeyword = '&lastNameSearch=' + search //'&nameSearch=' + search
    return function (dispatch) {
        dispatch(reqDeniedMembership())
        fetch(GET_DENIED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(deniedmemberships => {
                dispatch(recDeniedMembership(deniedmemberships));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_DENIED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder}`), { extra: { api: GET_DENIED_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, error } });
                console.log(error);
            });

    }
}

function reqDeniedMembership() {
    return {
        type: ACTIONTYPES.DENIED_MEMBERSHIP_LOADING,
    }
}

function recDeniedMembership(deniedmemberships) {
    return {
        type: ACTIONTYPES.DENIED_MEMBERSHIP_RECEIVED,
        deniedmemberships: deniedmemberships
    }
}

export function getPendingMemebrship(page, perpage, search, sort) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let searchkeyword = ''
    let sortOrder = '&sortOrder=des'
    if (search != '') searchkeyword = '&lastNameSearch=' + search //'&nameSearch=' + search
    if (sort == 'ascend') sortOrder = '&sortOrder=asc'
    return function (dispatch) {
        dispatch(reqPendingMembership())
        fetch(GET_PENDING_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(pendingmembership => {
                dispatch(recPendingMembership(pendingmembership));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PENDING_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder}`), { extra: { api: GET_PENDING_MEMBERSHIPS + '&page=' + page + '&perPage=' + perpage + searchkeyword + sortOrder, error } });
                console.log(error);
                Modal.error({
                    className: "ErrorModal",
                    title: `Unauthorized`,
                    content: `Only National Admin have access to view this membership section`,
                    onOk() {
                        dispatch(redirectDashboard());
                    }
                })
            });

    }
}

function reqPendingMembership() {
    return {
        type: ACTIONTYPES.PENDING_MEMBERSHIP_LOADING,
    }
}

function recPendingMembership(pendingmembership) {
    return {
        type: ACTIONTYPES.PENDING_MEMBERSHIP_RECEIVED,
        pendingmembership: pendingmembership
    }
}

export function searchEagle(values, personGUID, getCurrentMember) {

    return function (dispatch) {
        dispatch(reqsearcheagle())

        const payload = {};
        if (values.scout_first_name) payload.firstName = values.scout_first_name.trim();
        if (values.scout_last_name) payload.lastName = values.scout_last_name.trim();
        if (values.scout_dob) payload.dateOfBirth = moment(values.scout_dob).isValid() ? moment(values.scout_dob).format("YYYY-MM-DD") : undefined;
        if (values.scout_eagle_unit) payload.eagleUnit = values.scout_eagle_unit;
        if (values.scout_eagle_council) payload.eagleCouncil = values.scout_eagle_council;
        if (values.BOR) payload.boardOfReviewDate = moment(values.BOR).format("YYYY-MM-DD");

        Sentry.captureMessage(`eaglePublicSearch Payload: ${payload.firstName} ${payload.lastName} ${payload.dateOfBirth}`, {
            level: "info",
            extra: payload
        });

        fetch(ESB_PERSONS + 'v2/eaglePublicSearch', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 2',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify(payload),
            // body: JSON.stringify({
            //     "firstName": firstName,
            //     "lastName": lastName,
            //     // "middleName": values.scout_middle_Initial,
            //     "dateOfBirth": values.scout_dob ? moment(values.scout_dob).format('YYYY-MM-DD') : undefined,
            //     "eagleUnit": values.scout_eagle_unit ? values.scout_eagle_unit : undefined,
            //     "eagleCouncil": values.scout_eagle_council ? values.scout_eagle_council : undefined,
            //     "boardOfReviewDate": values.BOR ? moment(values.BOR).format('YYYY-MM-DD') : undefined,
            //     // "memberId": values.scout_member_id ? parseInt(values.scout_member_id) : undefined
            // })
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 404 || response.status == 400 || response.status == 422 || response.status == 500) {
                        return response.json().then((error) => {
                            Modal.error({
                                className: "ErrorModal",
                                title: error.message || 'Invalid Request',
                                content: error.errorDesc || '',
                            });
                            dispatch(receaglestatus(null))
                            return Promise.reject(response.statusText);
                        });
                    } else {
                        return Promise.reject(response.statusText);
                    }
                }
                return response.json();
            })
            .then(eagle => {
                Sentry.captureEvent({
                    message: `eaglePublicSearch Response: ${payload.firstName} ${payload.lastName} ${payload.dateOfBirth}`,
                    level: "info",
                    extra: { response: eagle }
                });

                getCurrentMember ? dispatch(getmemberid(personGUID, true, eagle, true)) : dispatch(receaglestatus(eagle));
            })
            .catch((error) => {
                Sentry.captureException(error, {
                    extra: { context: "eaglePublicSearch Error" },
                });

                console.log(error);
                dispatch(receaglestatus(null))
            });
    }
}

function reqsearcheagle() {
    return {
        type: ACTIONTYPES.SEARCHING_EAGLE,
    }
}

function receaglestatus(eagle) {
    return {
        type: ACTIONTYPES.SEARCHED_EAGLE,
        eagle: eagle
    }
}

export function getEagleInfo() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqeagleinfo())
        fetch(ESB_PERSONS + personGUID + `/eagleInformation`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(eagleinfo => {
                dispatch(receagleinfo(eagleinfo));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/eagleInformation`}`), { extra: { api: ESB_PERSONS + personGUID + `/eagleInformation`, error } });
                console.log(error);
            });

    }
}

function reqeagleinfo() {
    return {
        type: ACTIONTYPES.MY_EAGLE_INFO_LOADING,
    }
}

function receagleinfo(eagleinfo) {
    return {
        type: ACTIONTYPES.MY_EAGLE_INFO_RECEIVED,
        eagleinfo: eagleinfo
    }
}

const splitPhoneNumber = (phoneNumber) => {
    let areaCode, prefix, lineNumber;
    // Check if the number is valid (10 digits for US)
    if (phoneNumber && phoneNumber.length !== 10) {
        return null;
    }
    if (phoneNumber && phoneNumber.length == 4) {
        areaCode = '';
        prefix = '';
        lineNumber = phoneNumber ? phoneNumber : '';
    } else if (phoneNumber && phoneNumber.length == 10) {
    // Split the number into components
        areaCode = phoneNumber.substring(0, 3);
        prefix = phoneNumber.substring(3, 6);
        lineNumber = phoneNumber.substring(6);
    }

    return {
        areaCode,
        prefix,
        lineNumber
    };
}

function removeCommas(address) {
    return address ? address.replace(/,/g, '') : '';
}

export function GiftMembership(levelid, values, isRush, TotalAmount, programname, MerchantID, profile, email, nesaType, isApplicableForNewEagle) {

    let reviewdate = profile.eagleBoardReviewDate ? moment(profile.eagleBoardReviewDate).format('YYYY-MM-DD') : ''

    // let newEagle = false;
    // if (reviewdate) {
    //     let reviewDate = new Date(reviewdate);
    //     let today = new Date();
    //     let differenceInTime = Math.abs(reviewDate.getTime() - today.getTime());
    //     let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

    //     if (differenceInDays <= 210) { //AAG-1162 - A NEW EAGLE STATUS IS NOW APPLICABLE IF THE BOR DATE IS WITHIN THE PAST 210 DAYS.
    //         newEagle = true;
    //     }
    // }

    let dob = moment(profile.dob).format('YYYY-MM-DD')
    // let areaCode = values.phone.slice(0, 3)
    // let prefix = values.phone.slice(3, 6) //AAG-971 Remove 'Scout's Phone Number from NESA application process
    // let lineNumber = values.phone.slice(6, 10)

    let g_areaCode;
    let g_prefix;
    let g_lineNumber;
    if (values.g_phone && values.g_phone.length == 4) {
        g_areaCode = '';
        g_prefix = '';
        g_lineNumber = values.g_phone ? values.g_phone : '';
    } else if (values.g_phone && values.g_phone.length == 10) {
        g_areaCode = values.g_phone ? values.g_phone.slice(0, 3) : undefined;
        g_prefix = values.g_phone ? values.g_phone.slice(3, 6) : undefined;
        g_lineNumber = values.g_phone ? values.g_phone.slice(6, 10) : undefined;
    }

    PurchasingPerson = values;
    PurchasingPerson.firstname = profile.firstName
    PurchasingPerson.lastname = profile.lastName
    PurchasingPerson.ScoutsEmail = values.ScoutsEmail;
    PurchasingPerson.ScoutsEmail = (email && email != '') ? email : values.ScoutsEmail;
    // PurchasingPerson.addressline1 = profile.address1
    // PurchasingPerson.addressline2 = profile.address2
    // PurchasingPerson.city = profile.city
    // PurchasingPerson.stateName = profile.state
    // PurchasingPerson.zipcode = profile.zipCode,

    // Changes related to comma being not valid as address input
    const ScoutsAddress1 = removeCommas(PurchasingPerson.ScoutsAddressline1);
    const ScoutsAddress2 = removeCommas(PurchasingPerson.ScoutsAddressline2);
    const ScoutsAddress3 = removeCommas(PurchasingPerson.ScoutsAddressline3);
    const guardianAddress1 = removeCommas(values.g_address_line_1);
    const guardianAddress2 = removeCommas(values.g_address_line_2);
    const guardianAddress3 = removeCommas(values.g_address_line_3);

    const { areaCode = undefined, prefix = undefined, lineNumber = undefined } = values.ScoutsPhone && values.ScoutsPhone.length == 10 ? splitPhoneNumber(values.ScoutsPhone) : {}; 

    const payload = {
        "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
        "applicationTypeId": 11,
        "applicationDate": moment().format('YYYY-MM-DD'),
        "alumniMembershipLevelId": parseInt(levelid),
        "memberId": profile.memberId.toString(),
        "firstName": profile.firstName,
        "middleName": profile.middleName ? removeCommas(profile.middleName) : "",
        "lastName": profile.lastName,
        "nickname": null,
        "dateOfBirth": dob,
        "gender": profile.gender,
        "countryId": parseInt(PurchasingPerson.ScoutsCountryId),
        "addressLine1": ScoutsAddress1,
        "addressLine2": ScoutsAddress2,
        "addressLine3": ScoutsAddress3 ? ScoutsAddress3 : '',
        "city": PurchasingPerson.ScoutsCity ? removeCommas(PurchasingPerson.ScoutsCity) : undefined,
        "stateId": PurchasingPerson.ScoutsState ? parseInt(PurchasingPerson.ScoutsState) : undefined,
        "zip": PurchasingPerson.ScoutsZipcode ? PurchasingPerson.ScoutsZipcode : undefined,
        "email": PurchasingPerson.ScoutsEmail ? PurchasingPerson.ScoutsEmail : undefined,
        "phoneCountryId": (values.ScoutsPhonecountryID && areaCode && prefix && lineNumber) ? parseInt(values.ScoutsPhonecountryID) : undefined,
        ...areaCode && { "areaCode": areaCode },
        ...prefix && { "prefix": prefix },
        "lineNumber": lineNumber,
        "extension": "",
        "notes": "",
        "isRush": isRush,
        "boardReviewDate": reviewdate,
        "eagleUnitNumber": profile.unitNumber ? profile.unitNumber : profile.troopnumber ? profile.troopnumber : undefined,
        "eagleUnitCity": profile.eagleCity ? profile.eagleCity : undefined,
        "eagleUnitState": profile.eagleState ? profile.eagleState : undefined,
        "isAdminFee": values.isPayTransactionFees,
        "newEagle": isApplicableForNewEagle,
        "parentGuardianInfo": {
            "isAdultPartner": true,
            "firstName": values.g_first_name,
            "lastName": values.g_last_name,
            "gender": "F",
            "ethnicBackgroundId": 1746,
            "countryId": parseInt(values.g_countryId),
            "addressLine1": guardianAddress1,
            "addressLine2": guardianAddress2,
            "addressLine3": guardianAddress3,
            "city": values.g_city ? removeCommas(values.g_city): undefined,
            "stateId": values.g_state ? parseInt(values.g_state): undefined,
            "zip": values.g_zip_code ? values.g_zip_code : undefined,
            "phoneCountryId": values.g_phonecountryID ? parseInt(values.g_phonecountryID) : undefined,
            ...g_areaCode && { "areaCode": g_areaCode },
            ...g_prefix && { "prefix": g_prefix },
            "lineNumber": g_lineNumber,
            "email": values.g_email,
            "shipToSelf": values.shipping == 1 ? true : false
        }
    }
            
    return function (dispatch) {

        dispatch(requestGiftMembership())

        Sentry.captureMessage(`alumni Payload: ${values.firstname} ${values.lastname} ${dob}`, {
            level: "info",
            extra: payload
        });

        Refetch(ALUMNI_REGISTARTION, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [500, 503],
            cache: "no-cache",
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload)
            // body: JSON.stringify({
            //     "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
            //     "applicationTypeId": 11,
            //     "applicationDate": today,
            //     "alumniMembershipLevelId": parseInt(levelid),
            //     "memberId": profile.memberId.toString(),
            //     "firstName": profile.firstName,
            //     "middleName": profile.middleName ? profile.middleName : "",
            //     "lastName": profile.lastName,
            //     "nickname": null,
            //     "dateOfBirth": dob,
            //     "gender": profile.gender,
            //     // "ethnicBackgroundId": values.ethnic ?  parseInt(values.ethnic) : undefined,
            //     "countryId": parseInt(PurchasingPerson.ScoutsCountryId),
            //     "addressLine1": ScoutsAddress1,
            //     "addressLine2": ScoutsAddress2,
            //     "addressLine3": ScoutsAddress3 ? ScoutsAddress3 : '',
            //     "city": PurchasingPerson.ScoutsCity ? PurchasingPerson.ScoutsCity : undefined,
            //     "stateId": PurchasingPerson.ScoutsState ? parseInt(PurchasingPerson.ScoutsState) : undefined,
            //     "zip": PurchasingPerson.ScoutsZipcode ? PurchasingPerson.ScoutsZipcode : undefined,
            //     "email": PurchasingPerson.ScoutsEmail ? PurchasingPerson.ScoutsEmail : undefined,
            //     "phoneCountryId": (values.ScoutsPhonecountryID && areaCode && prefix && lineNumber) ? parseInt(values.ScoutsPhonecountryID) : undefined,
            //     ...areaCode && { "areaCode": areaCode },
            //     ...prefix && { "prefix": prefix },
            //     // "prefix": prefix, //AAG-1026 ADDED BACK - 'Scout's Phone Number in the NESA application process
            //     "lineNumber": lineNumber,
            //     // "isUpdatePrimaryAddress": values.isUpdatePrimaryAddress, default value => False
            //     "extension": "",
            //     "notes": "",
            //     "isRush": isRush,
            //     "boardReviewDate": reviewdate,
            //     "eagleUnitNumber": profile.unitNumber ? profile.unitNumber
            //         : profile.troopnumber ? profile.troopnumber : undefined,
            //     "eagleUnitCity": profile.eagleCity ? profile.eagleCity : undefined,
            //     "eagleUnitState": profile.eagleState ? profile.eagleState : undefined,
            //     // "NESAAdminFee": values.isPayTransactionFees ? parseFloat(values.transactionFee) : undefined,
            //     "isAdminFee": values.isPayTransactionFees,
            //     "newEagle": isApplicableForNewEagle,
            //     "parentGuardianInfo": {
            //         "isAdultPartner": true,
            //         "firstName": values.g_first_name,
            //         "lastName": values.g_last_name,
            //         "gender": "F",
            //         "ethnicBackgroundId": 1746,
            //         "countryId": parseInt(values.g_countryId),
            //         "addressLine1": guardianAddress1,
            //         "addressLine2": guardianAddress2,
            //         "addressLine3": guardianAddress3,
            //         "city": values.g_city,
            //         "stateId": parseInt(values.g_state),
            //         "zip": values.g_zip_code ? values.g_zip_code : undefined,
            //         "phoneCountryId": values.g_phonecountryID ? parseInt(values.g_phonecountryID) : undefined,
            //         ...g_areaCode && { "areaCode": g_areaCode },
            //         ...g_prefix && { "prefix": g_prefix },
            //         "lineNumber": g_lineNumber,
            //         "email": values.g_email,
            //         "shipToSelf": values.shipping == 1 ? true : false
            //     }
            // })
        })
            .then(response => {
                if (!response.ok) {
                    dispatch(ErrorGiftMembershipRes());
                    return response.text().then(result => Promise.reject(new Error(result)));
                }
                return response.json();
            })
            .then(response => {
                Sentry.captureEvent({
                    message: `alumni Response: ${values.firstname} ${values.lastname} ${dob}`,
                    level: "info",
                    extra: { response }
                });

                if (programname == "RENEW NESA") {
                    RENEW_NESAMembership = response
                } else {
                    GiftMembership = response
                }
                dispatch(gettingShoppingCartList())
                shoppingCart(response.registrationId)
                    .then(result => {
                        if (!result.ok) throw result;
                        return result.json();
                    })
                    .then(result => {
                        Sentry.captureEvent({
                            message: `shoppingCartNESA Response: ${values.firstname} ${values.lastname} ${dob}`,
                            level: "info",
                            extra: { result: JSON.stringify(result, null, 2) }
                        });
                        
                        dispatch(recivedShoppingCartList(result))
                        dispatch(receiveGiftMembershipRes(response));
                        dispatch(generateUID(TotalAmount, programname, MerchantID, response, email, values.phone, nesaType))
                    })
            })
            .catch((error) => {
                // Sentry.captureException(error);
                Sentry.captureException(error, {
                    extra: {
                        context: "GiftMembership Flow Error",
                        payload: payload
                    }
                });

                console.log(error);
                dispatch(ErrorGiftMembershipRes());

                let err = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    style: { width: "500px" },
                    title: 'Error',
                    content: <div>
                        {err.errorCode == "M422" ? 'Whoops! It appears important information is missing from your Eagle Scout profile. Please contact your Eagle Scout council updating the following information.'
                            : ''
                        }
                        <div style={{ backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033' }}>
                            {err.errorDesc}
                        </div>
                    </div>,
                });
            });

    }
}


function ErrorGiftMembershipRes() {
    return {
        type: ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION_ERROR,
    }
}

function requestGiftMembership() {
    return {
        type: ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION_LOADING,
    }
}

function receiveGiftMembershipRes(response) {
    return {
        type: ACTIONTYPES.GIFT_MEMBERSHIP_RESGISTRATION,
        response: response
    }
}

export function ApplyPromocode(membershipRecord, value, nesaType) {
    return function (dispatch) {
        dispatch(reqApplyingPromoCode())
        try {
            if (value.promocode) {
                fetch(ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/applyPromoCode`, {
                    cache: "no-cache",
                    method: 'POST',
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "promoCode": value.promocode
                    })
                })
                    .then(result => {
                        if (!result.ok) throw result;
                        return result.json();
                    })
                    .then(result => {
                        dispatch(gettingShoppingCartList())
                        shoppingCart(membershipRecord.registrationId)
                            .then(result => {
                                if (!result.ok) throw result;
                                return result.json();
                            })
                            .then(result => {
                                result.shoppingCart.forEach(function (data) {
                                    if (data.feeStructureCode) {
                                        if (data.feeStructureCode.includes("PROMO")) {
                                            dispatch(recivedShoppingCartList(result))
                                            dispatch(recPromocode(data.amount, data.promoCode))
                                            dispatch(generateUID(result.totalAmountDue, null, null, membershipRecord, null, null, nesaType))
                                        }
                                    }
                                })
                            })

                    }).catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/applyPromoCode`}`), { extra: { api: ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/applyPromoCode`, error } });
                        console.log(error);
                        error.json().then((body) => {
                            dispatch(recPromocodeError(body))
                        });
                        // dispatch(recPromocodeError(error))
                    })
            }
            else {
                throw "\"Promotion code\" is not allowed to be empty"
            }
        } catch (error) {
            dispatch(recPromocodeError(error))
        }
    }
}

function reqApplyingPromoCode() {
    return {
        type: ACTIONTYPES.PROMOCODE_LOADING,
    }
}

function recPromocodeError(error) {
    return {
        type: ACTIONTYPES.PROMOCODE_ERROR,
        error: error
    }
}

function recPromocode(amount, promocode) {
    return {
        type: ACTIONTYPES.PROMOCODE_APPLIED,
        response: { amount, promocode }
    }
}
export function RemovePromocode(membershipRecord, value, nesaType) {
    return function (dispatch) {
        dispatch(reqRemovingPromoCode())
        fetch(ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/removePromoCode`, {
            cache: "no-cache",
            method: 'POST',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "promoCode": value.promocode
            })
        })
            .then(result => {
                if (!result.ok) throw result;
                return result.json();
            })
            .then(result => {
                dispatch(gettingShoppingCartList())
                shoppingCart(membershipRecord.registrationId)
                    .then(result => {
                        if (!result.ok) throw result;
                        return result.json();
                    })
                    .then(result => {
                        dispatch(recivedShoppingCartList(result))
                        dispatch(generateUID(result.totalAmountDue, null, null, membershipRecord, null, null, nesaType))
                        dispatch(removedPromocode(result.totalAmountDue))
                    })

            }).catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/removePromoCode`}`), { extra: { api: ONLINE_REGISTRATIONS_V2 + membershipRecord.registrationId + `/removePromoCode`, error } });
                console.log(error);
                // error.json().then((body) => {
                //     dispatch(removedPromocodeError(body))
                // });
                dispatch(removedPromocodeError(error))
            })
    }
}

function reqRemovingPromoCode() {
    return {
        type: ACTIONTYPES.REMOVE_PROMOCODE_LOADING,
    }
}
function removedPromocode(response) {
    return {
        type: ACTIONTYPES.PROMOCODE_REMOVED,
        response: response
    }
}

function removedPromocodeError(error) {
    return {
        type: ACTIONTYPES.REMOVE_PROMOCODE_ERROR,
        error: error
    }
}

function gettingShoppingCartList() {
    return {
        type: ACTIONTYPES.GETTING_SHOPPINGCART,
    }
}
function recivedShoppingCartList(response) {
    return {
        type: ACTIONTYPES.RECIVED_SHOPPINGCART,
        response: response
    }
}


export const shoppingCart = (registrationId) => {
    return fetch(ONLINE_REGISTRATIONS + 'v2/' + registrationId + `/shoppingCartNESA`, {
        cache: "no-cache",
        method: 'GET',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
}

export function RegisterMembership(values, profile, levelid, eagleinfo, isRush, TotalAmount, programname, MerchantID, nesaType, isApplicableForNewEagle) {
    // debugger
    // let reviewdate = profile.eagleBoardReviewDate ? moment(profile.eagleBoardReviewDate).format('YYYY-MM-DD') : ''
    // let dob = moment(profile.dob).format('YYYY-MM-DD')    // let certificateDate = values.certificate_date ? moment(values.certificate_date).format('YYYY-MM-DD') : ''
    let reviewdate = values.review_date ? moment(values.review_date).format('YYYY-MM-DD') : ''

    // let newEagle = false;
    // if (reviewdate) {
    //     let reviewDate = new Date(reviewdate);
    //     let today = new Date();
    //     let differenceInTime = Math.abs(reviewDate.getTime() - today.getTime());
    //     let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

    //     if (differenceInDays <= 210) { //AAG-1162 - A NEW EAGLE STATUS IS NOW APPLICABLE IF THE BOR DATE IS WITHIN THE PAST 210 DAYS.
    //         newEagle = true;
    //     }
    // }

    let dob = moment(profile.dob).format('YYYY-MM-DD')
    // let certificateDate = values.certificate_date ? moment(values.certificate_date).format('YYYY-MM-DD') : ''

    let areaCode;
    let prefix;
    let lineNumber;
    if (values.phone && values.phone.length == 4) {
        areaCode = '';
        prefix = '';
        lineNumber = values.phone ? values.phone : '';
    } else if (values.phone && values.phone.length == 10) {
        areaCode = values.phone ? values.phone.slice(0, 3) : undefined;
        prefix = values.phone ? values.phone.slice(3, 6) : undefined; //AAG-971 Remove 'Scout's Phone Number from NESA application process
        lineNumber = values.phone ? values.phone.slice(6, 10) : undefined;
    }

    let addressline3 = values.addressline3 ? removeCommas(values.addressline3) : '';
    // let g_areaCode = values.g_phone.slice(0, 3)
    // let g_prefix = values.g_phone.slice(3, 6)
    // let g_lineNumber = values.g_phone.slice(6, 10)
    PurchasingPerson = values
    PurchasingPerson.firstname = profile.firstName
    PurchasingPerson.lastname = profile.lastName    // const loggedinUser = JSON.parse(localStorage.getItem('user'))    // let personemail = profile.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    // const loggedinUser = JSON.parse(localStorage.getItem('user'))
    // let personemail = profile.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    // let address = profile.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    // let phone = profile.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    // let token = loggedinUser.token;
    // PurchasingPerson = profile
    // let reviewdate = moment(eagleinfo.review_date).format('YYYY-MM-DD')

    const payload = {
        "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
        "applicationTypeId": 11,
        "applicationDate": moment().format('YYYY-MM-DD'),
        "alumniMembershipLevelId": parseInt(levelid),
        "memberId": values.memberid.toString(),
        "firstName": values.firstname,
        "middleName": removeCommas(values.middlename),
        "lastName": values.lastname,
        "nickname": null,
        "isUpdatePrimaryEmail": true,
        "dateOfBirth": dob,
        "gender": profile.gender,
        "countryId": parseInt(values.countryId),
        "addressLine1": values.addressline1 ? removeCommas(values.addressline1) : '',
        "addressLine2": values.addressline2 ? removeCommas(values.addressline2) : '',
        "addressLine3": addressline3,
        "city": values.city ? removeCommas(values.city) : undefined,
        "stateId": values.state ? parseInt(values.state) : undefined,
        "zip": values.zipcode ? values.zipcode : undefined,
        "zipExtension": "",
        "email": values.email ? values.email : undefined,
        "phonecountryId": (values.phonecountryID && areaCode && prefix && lineNumber) ? parseInt(values.phonecountryID) : undefined,
        ...areaCode && { "areaCode": areaCode },
        ...prefix && { "prefix": prefix },
        "lineNumber": lineNumber,
        "extension": "",
        "notes": "",
        "isRush": isRush,
        "boardReviewDate": reviewdate,
        "eagleUnitNumber": values.scout_unit ? values.scout_unit : undefined,
        "eagleUnitCity": values.scout_city ? values.scout_city : undefined,
        "eagleUnitState": values.scout_state ? values.scout_state : undefined,
        "isAdminFee": values.isPayTransactionFees,
        "newEagle": isApplicableForNewEagle,
        "parentGuardianInfo": { "isAdultPartner": false }
    };

    return function (dispatch) {
        dispatch(requestPurchaseMembership())

        Sentry.captureMessage(`alumni API Payload: ${values.firstname} ${values.lastname} ${dob}`, {
            level: "info",
            extra: payload
        });
        
        Refetch(ALUMNI_REGISTARTION, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [500, 503],
            cache: "no-cache",
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                // "Authorization": "Bearer " + token,
            },
            body: JSON.stringify(payload)
            // body: JSON.stringify({
            //     "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
            //     "applicationTypeId": 11,
            //     "applicationDate": today,
            //     "alumniMembershipLevelId": parseInt(levelid),
            //     // 'certificationDate': certificateDate,
            //     //"member": profile.profile.memberId,
            //     "memberId": values.memberid.toString(),
            //     "firstName": values.firstname,
            //     "middleName": values.middlename,
            //     "lastName": values.lastname,
            //     "nickname": null,
            //     "isUpdatePrimaryEmail": true,
            //     "dateOfBirth": dob,
            //     "gender": profile.gender,
            //     // "ethnicBackgroundId": values.ethnic ? parseInt(values.ethnic) : undefined,
            //     "countryId": parseInt(values.countryId),
            //     "addressLine1": values.addressline1 ? removeCommas(values.addressline1) : '',
            //     "addressLine2": values.addressline2 ? removeCommas(values.addressline2) : '',
            //     "addressLine3": addressline3,
            //     "city": values.city ? removeCommas(values.city) : undefined,
            //     "stateId": values.state ? parseInt(values.state) : undefined,
            //     "zip": values.zipcode ? values.zipcode : undefined,
            //     "zipExtension": "",
            //     "email": values.email ? values.email : undefined,
            //     "phonecountryId": (values.phonecountryID && areaCode && prefix && lineNumber) ? parseInt(values.phonecountryID) : undefined,
            //     ...areaCode && { "areaCode": areaCode }, //AAG-971 Remove 'Scout's Phone Number from NESA application process
            //     ...prefix && { "prefix": prefix },
            //     "lineNumber": lineNumber,
            //     // "isUpdatePrimaryAddress": values.isUpdatePrimaryAddress,
            //     "extension": "",
            //     "notes": "",
            //     "isRush": isRush,
            //     "boardReviewDate": reviewdate,
            //     "eagleUnitNumber": values.scout_unit ? values.scout_unit : undefined,
            //     "eagleUnitCity": values.scout_city ? values.scout_city : undefined,
            //     "eagleUnitState": values.scout_state ? values.scout_state : undefined,
            //     // "NESAAdminFee": values.isPayTransactionFees ? parseFloat(values.transactionFee) : undefined,
            //     "isAdminFee": values.isPayTransactionFees,
            //     "newEagle": isApplicableForNewEagle,
            //     "parentGuardianInfo": {
            //         "isAdultPartner": false
            //     }
            // })
        })
            .then(response => {
                if (!response.ok) {
                    dispatch(receivePurchaseMembershipError())
                    return response.text().then(result => Promise.reject(new Error(result)));
                }
                return response.json();
            })
            .then(response => {
                Sentry.captureEvent({
                    message: `alumni API Response: ${values.firstname} ${values.lastname} ${dob}`,
                    level: "info",
                    extra: { response }
                });

                if (programname == "RENEW NESA") {
                    RENEW_NESAMembership = response
                } else {
                    NESAMembership = response
                }
                dispatch(receivePurchaseMembership(response));
                dispatch(gettingShoppingCartList())
                shoppingCart(response.registrationId)
                    .then(result => {
                        if (!result.ok) throw result;
                        return result.json();
                    })
                    .then(result => {
                        Sentry.captureEvent({
                            message: `shoppingCartNESA Response: ${values.firstname} ${values.lastname} ${dob}`,
                            level: "info",
                            extra: { result: JSON.stringify(result, null, 2) }
                        });

                        //AAG-971 Remove 'Scout's Phone Number from NESA application process
                        dispatch(generateUID(result.totalAmountDue, programname, MerchantID, response, values.email,
                            // areaCode + prefix + lineNumber, 
                            nesaType))
                        dispatch(recivedShoppingCartList(result))
                    })
                    .catch(error => {
                        Sentry.captureException(error, { extra: { context: "shoppingCart Error" } });
                        console.log(error);
                        // error.json().then((body) => {
                        // dispatch(removedPromocodeError(body))
                        // });
                    })
            })
            .catch(error => {
                dispatch(receivePurchaseMembershipError())
                // Sentry.captureException(error);
                try{
                    if (JSON.parse(error.message).errorDesc == 'Member has NESA lifetime registration') {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Our records indicate you already have a Lifetime NESA membership. If you believe this is in error, please contact NESA at 972-580-2000.',
                        });
                    } else {
                        let err = JSON.parse(error.message)
                        Modal.error({
                            className: "ErrorModal",
                            style: { width: "500px" },
                            title: 'Error',
                            content: <div>
                                {err.errorCode == "M422" ? 'Whoops! It appears important information is missing from your Eagle Scout profile. Please contact your Eagle Scout council updating the following information.'
                                    : ''
                                }
                                <div style={{ backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033' }}>
                                    {err.errorDesc}
                                </div>
                            </div>,
                        });
                        // Modal.error({
                        //     className: "ErrorModal",
                        //     title: 'Error',
                        //     content: 'Error occurred while processing request. Please try again in 24 hours',
                        // });
                    }
                }
                catch (parseError) {
                    console.error(parseError);
                    Sentry.captureException(parseError, { extra: { context: "alumni API Error Parsing" } });
                }

                Sentry.captureException(error, { extra: { context: "alumni API Final Error" } });
            });
    }
}

function requestPurchaseMembership() {
    return {
        type: ACTIONTYPES.PURCHASE_RESGISTRATION_LOADING,
    }
}

function receivePurchaseMembership(response) {
    return {
        type: ACTIONTYPES.PURCHASE_RESGISTRATION,
        response: response
    }
}

function receivePurchaseMembershipError() {
    return {
        type: ACTIONTYPES.PURCHASE_RESGISTRATION_ERROR
    }
}

export function SAFRegistration(profile, levelid, price, eagleinfo, TotalAmount, programname, MerchantID) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personemail = profile.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    let address = profile.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    let phone = profile.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
    let token = loggedinUser.token;
    PurchasingPerson = profile

    return function (dispatch) {
        dispatch(requestSAFMembership())

        Refetch(ALUMNI_REGISTARTION, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [500, 503],
            cache: "no-cache",
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
                "applicationTypeId": 10,
                "applicationDate": moment().format('YYYY-MM-DD'),
                "alumniMembershipLevelId": parseInt(levelid),
                //"member": profile.profile.memberId,
                "memberId": profile.profile.memberId,
                "firstName": profile.profile.firstName,
                "middleName": profile.profile.middleName ? profile.profile.middleName : "",
                "lastName": profile.profile.lastName,
                "nickname": profile.profile.nickName,
                "dateOfBirth": loggedinUser.profile.dateOfBirth,
                "gender": profile.profile.gender,
                "ethnicBackgroundId": parseInt(eagleinfo.ethnic_background),
                "countryId": address.countryId ? parseInt(address.countryId) : 0,
                "addressLine1": address.address1,
                "addressLine2": address.address2 ? address.address2 : "",
                "addressLine3": address.address3 ? address.address3 : "",
                "city": address.city,
                "county": address.county ? address.county : "temp",
                "stateId": address.stateId ? parseInt(address.stateId) : 0,
                "zip": address.zipCode ? address.zipCode : undefined,
                "zipExtension": "",
                "email": personemail.email,
                "phoneCountryId": phone.countryId ? parseInt(phone.countryId) : 0,
                "areaCode": phone.areaCode,
                "prefix": phone.prefix,
                "lineNumber": phone.lineNumber,
                "extension": "",
                "notes": "",
                "isRush": false,
                "parentGuardianInfo": {
                    "isAdultPartner": false
                }
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                SAFMembership = response
                if (price == 0) {
                    window.showReceiptComponent.showReceipt()
                } else {
                    dispatch(receiveSAFResponse(response));
                    dispatch(generateUID(TotalAmount, programname, MerchantID, response, personemail.email, phone.areaCode + phone.prefix + phone.lineNumber))
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ALUMNI_REGISTARTION}`), { extra: { api: ALUMNI_REGISTARTION, error } });
                console.log(error);
                dispatch(receiveSAFError())

                Modal.error({
                    className: "ErrorModal",
                    title: 'Error',
                    content: 'Error occurred while processing request. Please try again in 24 hours',
                });
            });

    }
}

function requestSAFMembership(response) {
    return {
        type: ACTIONTYPES.SAF_RESGISTRATION_LOADING,
    }
}

function receiveSAFError(response) {
    return {
        type: ACTIONTYPES.SAF_RESGISTRATION_ERROR,
    }
}

function receiveSAFResponse(response) {
    return {
        type: ACTIONTYPES.SAF_RESGISTRATION,
        response: response
    }
}

export function SearchPendingMembership(value) {
    return {
        type: ACTIONTYPES.SEARCH_PENDING_MEMBERSHIP,
        value: value
    }
}

export function getEthnicities() {
    return function (dispatch) {
        dispatch(requestEthnicities())
        fetch(GET_ETHNICITIES, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(ethnicites => {
                dispatch(receiveEthnicities(ethnicites));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_ETHNICITIES}`), { extra: { api: GET_ETHNICITIES, error } });
                console.log(error);
            });
    }
}

function requestEthnicities() {
    return {
        type: ACTIONTYPES.ETHNICITIES_LOADING
    }
}

function receiveEthnicities(ethnicities) {
    return {
        type: ACTIONTYPES.ETHNICITIES_RECEIVED,
        ethnicities: ethnicities
    }
}

export function getPendingMembershipRecordPayment(RegistrationID) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqMembershipRecordPayment())
        fetch(ESB_REGISTRATIONS_1 + RegistrationID + '/payments', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(record => {
                dispatch(recMembershipRecordPayment(record));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS_1 + RegistrationID + '/payments'}`), { extra: { api: ESB_REGISTRATIONS_1 + RegistrationID + '/payments', error } });
                console.log(error);
            });
    }
}

function reqMembershipRecordPayment() {
    return {
        type: ACTIONTYPES.MEMBERSHIP_RECORD_PAYMENT_LOADING
    }
}

function recMembershipRecordPayment(record) {
    return {
        type: ACTIONTYPES.MEMBERSHIP_RECORD_PAYMENT_RECEIVED,
        record: record
    }
}

export function getPendingMembershipRecord(RegistrationID) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqMembershipRecord())
        fetch(ONLINE_REGISTRATIONS + 'v2/registrations/' + RegistrationID, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "authorization": "Bearer " + token
            }
        })
            .then(async response => {
                const data = await response.json();

                if (!response.ok) {
                    throw data;
                }

                return data;
            })
            .then(record => {
                dispatch(recMembershipRecord(record));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS + 'v2/registrations/' + RegistrationID}`), { extra: { api: ONLINE_REGISTRATIONS + 'v2/registrations/' + RegistrationID, error } });
                console.log(error);
                dispatch(membershipRecordFailure(error));
                Modal.error({
                    className: "ErrorModal",
                    title: `${error.errorCode} - ${error.message}`,
                    content: error.errorDesc || 'Server Error!',
                    onOk() { }
                });
            });
    }
}

function reqMembershipRecord() {
    return {
        type: ACTIONTYPES.MEMBERSHIP_RECORD_LOADING
    }
}

function recMembershipRecord(record) {
    return {
        type: ACTIONTYPES.MEMBERSHIP_RECORD_RECEIVED,
        record: record
    }
}

function membershipRecordFailure(error) {
    return {
        type: ACTIONTYPES.MEMBERSHIP_RECORD_FAILURE,
        error
    }
}

export function getStates() {
    return function (dispatch) {
        dispatch(reqStates())
        fetch(GET_STATES, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(states => {
                dispatch(recStates(states));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_STATES}`), { extra: { api: GET_STATES, error } });
                console.log(error);
                dispatch(failedStates(error))
            });

    }
}

function reqStates() {
    return {
        type: ACTIONTYPES.STATES_LOADING
    }
}
function failedStates(error) {
    return {
        type: ACTIONTYPES.STATES_FAILED,
        error
    }
}

function recStates(states) {
    return {
        type: ACTIONTYPES.STATES_RECEIVED,
        states: states
    }
}

const retryFetchCall = (response, error) => {
    if (error) {
        return true; // Retry for network errors
    }
    if (response.status === 200) {
        return response.json().then(data => {
            // Retry if response is an empty array
            return Array.isArray(data) && data.length === 0;
        });
    }
    return true; // Do not retry for other errors
};

export function getProductPrice() {
    
    return function (dispatch) {
        dispatch(reqProductPrice())
        Refetch(GET_PRODUCT_PRICE, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [retryFetchCall],
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(productprice => {
                console.log('action productprice', productprice)
                dispatch(recProductPrice(productprice));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PRODUCT_PRICE}`), { extra: { api: GET_PRODUCT_PRICE, error } });
                console.log(error);
                dispatch(failedProductPrice(error))
            });
    }
}

function reqProductPrice() {
    return {
        type: ACTIONTYPES.PRODUCT_PRICING_LOADING
    }
}
function failedProductPrice(error) {
    return {
        type: ACTIONTYPES.PRODUCT_PRICING_FAILED,
        error
    }
}

function recProductPrice(productprice) {
    return {
        type: ACTIONTYPES.PRODUCT_PRICING_RECEIVED,
        productprice: productprice
    }
}


export function updateAddress(addressid, values, typeId, personGuid) {
    let personGUID = personGuid;
    if (personGUID == undefined || personGUID == '' || personGUID == null) {
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        let token = loggedinUser.token;
        personGUID = loggedinUser.personGuid;
    }

    let URL = '', method = '';
    let addresses = ''
    if (addressid == 1) {
        URL = ESB_PERSONS + "v2/" + personGUID + `/profile`
        method = 'PUT'
        addresses = {
            "typeId": 65,
            "addressLine1": values.address_line_1 ? values.address_line_1 : "",
            "addressLine2": values.address_line_2 ? values.address_line_2 : "",
            "addressLine3": values.address_line_3 ? values.address_line_3 : "",
            "city": (values.country == '616') ? (values.city ? values.city : "") : "",
            "zip": (values.country == '616') ? (values.zip_code ? values.zip_code : "") : "",
            "stateId": (values.country == '616') ? (values.state ? Number(values.state) : "") : "",
            "countryId": values.country ? values.country : "",
            "isPrimary": true
        }
    } else {
        URL = ESB_PERSONS + "v2/" + personGUID + `/profile`
        method = 'PUT'
        addresses = {
            'id': Number(addressid),
            "typeId": Number(typeId),
            "addressLine1": values.address_line_1 ? values.address_line_1 : "",
            "addressLine2": values.address_line_2 ? values.address_line_2 : "",
            "addressLine3": values.address_line_3 ? values.address_line_3 : "",
            "city": (values.country == '616') ? (values.city ? values.city : "") : "",
            "zip": (values.country == '616') ? (values.zip_code ? values.zip_code : "") : "",
            "stateId": (values.country == '616') ? (values.state ? Number(values.state) : "") : "",
            "countryId": values.country ? values.country : "",
            "isPrimary": true
        }
    }
    return function (dispatch) {
        dispatch(reqUpdateAdd())
        fetch(URL, {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({

            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recUpdatedAdd(status));
                const loggedinUser = JSON.parse(localStorage.getItem('user'))
                let personGUID = loggedinUser.personGuid;
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Address Updated successfully!",
                    onOk() {
                        dispatch(getProfileInfo(personGUID, true))
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                console.log(error);
            });

    }
}

function reqUpdateAdd() {
    return {
        type: ACTIONTYPES.UPDATING_ADDRESS
    }
}

function recUpdatedAdd(status) {
    return {
        type: ACTIONTYPES.ADDRESS_UPDATED,
        status: status
    }
}


export function getNESAmembershiplevels() {
    const retryFetchCall = (response, error) => {
        if (error) {
            return true; // Retry for network errors
        }
        if (response.status === 200) {
            return response.json().then(data => {
                // Retry if response is an empty array
                return Array.isArray(data) && data.length === 0;
            });
        }
        return true; // Do not retry for other errors
    };
    return function (dispatch) {
        dispatch(reqNESAlevels())
        Refetch(GET_NESA_LEVELS, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [retryFetchCall],
            credentials: 'include',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(levels => {
                dispatch(recNESAlevels(levels));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_NESA_LEVELS}`), { extra: { api: GET_NESA_LEVELS, error } });
                console.log(error);
                dispatch(failedNESAlevels(error))
            });
    }
}

function reqNESAlevels() {
    return {
        type: ACTIONTYPES.NESA_LEVELS_LOADING
    }
}
function failedNESAlevels(error) {
    return {
        type: ACTIONTYPES.NESA_LEVELS_FAILED,
        error
    }
}

function recNESAlevels(levels) {
    return {
        type: ACTIONTYPES.NESA_LEVELS_RECEIVED,
        levels: levels
    }
}


export function getSAFmembershiplevels() {
    return function (dispatch) {
        dispatch(reqSAFlevels())
        fetch(GET_SAF_LEVELS, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(levels => {
                dispatch(recSAFlevels(levels));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_SAF_LEVELS}`), { extra: { api: GET_SAF_LEVELS, error } });
                console.log(error);
            });

    }
}

function reqSAFlevels() {
    return {
        type: ACTIONTYPES.SAF_LEVELS_LOADING
    }
}

function recSAFlevels(levels) {
    return {
        type: ACTIONTYPES.SAF_LEVELS_RECEIVED,
        levels: levels
    }
}

export function getPhoneCountries() {
    return function (dispatch) {
        dispatch(reqPhoneCountries())
        fetch(GET_PHONE_COUNTRY_CODE, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [retryFetchCall],
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(code => {
                dispatch(recPhoneCountries(code));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PHONE_COUNTRY_CODE}`), { extra: { api: GET_PHONE_COUNTRY_CODE, error } });
                console.log(error);
                dispatch(failedPhoneCountries(error))
            });

    }
}

function reqPhoneCountries() {
    return {
        type: ACTIONTYPES.PHONE_COUNTRY_CODE_LOADING
    }
}
function failedPhoneCountries(error) {
    return {
        type: ACTIONTYPES.PHONE_COUNTRY_CODE_FAILED,
        error
    }
}

function recPhoneCountries(code) {
    return {
        type: ACTIONTYPES.PHONE_COUNTRY_CODE,
        code: code
    }
}

export function getSocialMediasLookups() {
    return function (dispatch) {
        dispatch(reqlookupSocialMedias())
        fetch(GET_SOCIALMEDIAS, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(socialmedialookup => {
                dispatch(reclookupSocialMedias(socialmedialookup));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_SOCIALMEDIAS}`), { extra: { api: GET_SOCIALMEDIAS, error } });
                console.log(error);
            });
    }
}

function reqlookupSocialMedias() {
    return {
        type: ACTIONTYPES.LOOKUP_SOCIALMEDIA_LOADING
    }
}

function reclookupSocialMedias(socialmedialookup) {
    return {
        type: ACTIONTYPES.LOOKUP_SOCIALMEDIA_RECEIVED,
        socialmedialookup: socialmedialookup
    }
}

export function getCountries() {
    return function (dispatch) {
        dispatch(reqCountries())
        fetch(GET_COUNTRIES, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [retryFetchCall],
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(countries => {
                dispatch(recCountries(countries));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_COUNTRIES}`), { extra: { api: GET_COUNTRIES, error } });
                console.log(error);
                dispatch(failedCountries(error));
            });

    }
}

function reqCountries() {
    return {
        type: ACTIONTYPES.COUNTRIES_LOADING
    }
}
function failedCountries(error) {
    return {
        type: ACTIONTYPES.COUNTRIES_FAILED,
        error
    }
}

function recCountries(countries) {
    return {
        type: ACTIONTYPES.COUNTRIES_RECEIVED,
        countries: countries
    }
}

export function getOccupations() {
    return function (dispatch) {
        dispatch(reqOccupations())
        fetch(GET_OCCUPATION, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(occupations => {
                dispatch(recOccupations(occupations));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_OCCUPATION}`), { extra: { api: GET_OCCUPATION, error } });
                console.log(error);
            });

    }
}

function reqOccupations() {
    return {
        type: ACTIONTYPES.OCCUPATIONS_LOADING
    }
}

function recOccupations(occupations) {
    return {
        type: ACTIONTYPES.OCCUPATIONS_RECEIVED,
        occupations: occupations
    }
}

export function PaymentRegistration(registrationID) {
    return function (dispatch) {
        fetch(ONLINE_REGISTRATIONS + SAFMembership.registrationId + '/payments', {
            retries: 5,
            retryDelay: 1000,
            retryOn: [retryFetchCall],
            method: 'POST',
            credentials: 'include',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                "paymentTypeId": 1765,
                "totalAmountDue": 0.01
            })
                .then(response => {
                    if (!response.ok) {
                        return Promise.reject(response.statusText);
                    }
                    return response.json();
                })
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS + SAFMembership.registrationId + '/payments'}`), { extra: { api: ONLINE_REGISTRATIONS + SAFMembership.registrationId + '/payments', error } });
                    console.log(error);
                })
        })
    }
}
injectChasePaymentCallbacks();

function injectChasePaymentCallbacks() {
    var getPaymentDetailedErrors = function (codes) {
        var ecodes = codes.split('|');
        var msg = ''
        if (ecodes[0]) {
            switch (ecodes[0]) {
                case '100':
                    msg = 'Merchant Identifier left blank or not valid. The transaction was not processed..';
                    break;
                case '110':
                    msg = 'Session Identifier left blank. The transaction was not processed..';
                    break;
                case '200':
                    msg = 'Name not present.';
                    break;
                case '300':
                    msg = 'Amount is invalid or Credit Card is invalid.';
                    break;
                case '310':
                    msg = 'Credit Card field was left blank.';
                    break;
                case '315':
                    msg = 'Credit card number is invalid..';
                    break;
                case '320':
                    msg = 'Credit card type left blank or invalid..';
                    break;
                case '330':
                    msg = 'Expiration month is required.';
                    break;
                case '340':
                    msg = 'Expiration year is required..';
                    break;
                case '350':
                    msg = 'CVC does not match the card..';
                    break;
                case '355':
                    msg = 'CVC is required but not present..';
                    break;
                case '357':
                    msg = 'An invalid character was entered, such as a letter in a numeric field..';
                    break;
                case '360':
                    msg = 'Payment declined by financial institution, Please contact your bank.';
                    break;
                case '370':
                    msg = 'Expiration date is invalid..';
                    break;
                case '400':
                    msg = 'The Address is invalid or missing.';
                    break;
                case '500':
                    msg = 'Billing Address is missing.';
                    break;
                case '510':
                    msg = 'City field is required..';
                    break;
                case '520':
                    msg = 'State field is required.';
                    break;
                case '530':
                    msg = 'ZIP/postal is required.';
                    break;
                case '531':
                    msg = 'The ZIP/postal is invalid.';
                    break;
                case '550':
                    msg = 'Country field is required.';
                    break;
                case '600':
                    msg = 'The Bank name was blank.';
                    break;
                case '610':
                    msg = 'The Routing Number is blank.';
                    break;
                case '620':
                    msg = 'The Checking Account number was blank.';
                    break;
                case '630':
                    msg = 'The Routing Number is invalid.';
                    break;
                case '640':
                    msg = 'The Routing Number is invalid.';
                    break;
                default:
                    msg = 'An unhandled error has occurred. There were no deductions from your account.';
                    break;
            }
        }
        return msg;
    };

    window.top.whatsThis = function (item) {
        console.log('CVV2 is the 3 digits numbers which appear in the back of your card');
    };

    window.top.hostedHandleDetailErrors = function hostedHandleDetailErrors(errorCode, gatewayCode, gatewayMessage) {
        var errorMsg = getPaymentDetailedErrors(errorCode);
        console.log('Payment Error: ' + errorMsg);
        Modal.error({
            className: "ErrorModal",
            title: 'Payment Error',
            content: errorMsg,
        });
    };

    window.top.startHostedPayment = function startHostedPayment() {
        console.log('Processing your payment, please do not close this window!');
    };

    window.top.cancelHostedPayment = function cancelHostedPayment() {
        console.log('Processing your payment, please do not close this window!');
    };
}
window.top.completeHostedPayment = function completeHostedPayment(res) {
    console.log('completeHostedPayment');
    if (window.showReceiptComponent) window.showReceiptComponent.showLoadingReceipt()
    if (window.showAdminReceiptComponent) window.showAdminReceiptComponent.showLoadingReceipt()
    if (window.showPurchaseReceiptComponent) window.showPurchaseReceiptComponent.showLoadingReceipt()
    if (window.showGiftReceiptComponent) window.showGiftReceiptComponent.showLoadingReceipt()
    if (window.showRenewReceiptComponent) window.showRenewReceiptComponent.showLoadingReceipt()
    if (window.showBulkReceiptComponent) window.showBulkReceiptComponent.showLoadingReceipt()
    var programname = '';
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open("POST", VALIDATE_TRANSACTION);
    xmlhttp.setRequestHeader("Content-Type", "application/json");
    xmlhttp.send(JSON.stringify({ "uID": res.uID }));
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4) {
            var response = JSON.parse(xmlhttp.responseText);
            if (response.Status === true && response.Message === "Success") {
                console.log('successful');
                let registrationid = SAFMembership.registrationId;
                // if (response.item && response.item.programname) {
                //     programname = response.item.programname;
                // }
                if (redirectReceiptComponentTo == "NESA") {
                    registrationid = NESAMembership.registrationId;
                    window.showPurchaseReceiptComponent.showReceipt(registrationid, response)
                }
                else if (redirectReceiptComponentTo == "GIFT NESA") {
                    registrationid = GiftMembership.registrationId;
                    window.showGiftReceiptComponent.showReceipt(registrationid, response)
                }
                else if (redirectReceiptComponentTo == "RENEW NESA") {
                    registrationid = RENEW_NESAMembership.registrationId;
                    window.showRenewReceiptComponent.showReceipt(registrationid, response)
                }
                else if (redirectReceiptComponentTo == "BULK NESA") {
                    window.showBulkReceiptComponent.showReceipt(BULK_Membership.importid, response)
                } else {
                    registrationid = adminNESAMembership.registrationId;
                    window.showAdminReceiptComponent.showReceipt(registrationid, response)
                }
            } else {
                console.log('failed');
            }
        }
    }
    xmlhttp.onerror = function () {
        alert("An error occurred during the transaction!");
    }
}

export function getRegStatusandSendReceipt(registrationID, PurchasingPerson, MembershipType, ReceiptEmail, response, redirectedFromGiftWorkflow, MID, isUpdatePrimaryAddress) {
    const { addressline1, addressline2, addressline3, city, stateName, zipcode, ScoutsAddressline1, ScoutsAddressline2, ScoutsAddressline3, ScoutsCity, ScoutsState, ScoutsZipcode } = PurchasingPerson;

    return function (dispatch) {
        dispatch(reqRegStatus())
        fetch(ESB_REGISTRATIONS_1 + registrationID + `/status/public`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            }
        })
            // .then(response => {
            //     if (!response.ok) {
            //         return Promise.reject(response.statusText);
            //     }
            //     return response.json();
            // })
            .then(async response => {
                if (!response.ok) {
                    let errorData = {};
                    try {
                        errorData = await response.json();
                    } catch (e) {
                        errorData = {
                            errorCode: response.status,
                            message: response.statusText,
                            errorDesc: ""
                        };
                    }
                    return Promise.reject(errorData);
                }
                return response.json();
            })
            .then(status => {
                // if (status[0].applicationStatusId == "4") {
                //     dispatch(changeMembershipStatusToProcessed(registrationID, MID, false))
                // }
                if (MembershipType == "ADMIN NESA") {
                    dispatch(getNESARegistrations(PurchasingPerson.personGuid))
                }
                dispatch(recRegStatus(status));
                let receiptText = ''
                if (status[0].applicationStatusId == "4") {
                    receiptText = PENDING_MEMBERSHIP_TEXT
                }
                if (status[0].applicationStatusId == "21") {
                    receiptText = CONFIRM_MEMBERSHIP_TEXT
                }
                let mailData = {};
                let gifterMailData = {};
                let gifteeMailData = {};
                const gifterGreetingMessage = `On behalf of the Scouting America and the National Eagle Scout Association, I want to personally thank you for your generous gift purchasing a NESA membership for a qualified Eagle. Thank you for helping continue an Eagle's Scouting experience as a NESA member.`
                let gifteeGreetingMessage = `Welcome NESA member! We have successfully verified your Eagle Scout Award status. Thank you for continuing your Scouting experience as a NESA member. Please expect your packet to arrive within 6 weeks.`
                if (MembershipType == "NESA" || MembershipType == "ADMIN NESA" || (MembershipType == "RENEW-NESA" && !redirectedFromGiftWorkflow)) {

                    MembershipType = MembershipType == "ADMIN NESA" ? "NESA" : MembershipType;
                    const fullAddress = [addressline1, addressline2, addressline3, city, stateName, zipcode]
                        .map(removeCommas)
                        .filter(Boolean)
                        .join(' ');

                    let transId = undefined, customerName = undefined;
                    if (response && response.item && response.item.transId) {
                        transId = response.item.transId;
                        customerName = response.item.customer_firstname + " " + response.item.customer_lastname;
                        customerName = customerName.includes('undefined ') ? customerName.replace('undefined ', '') : customerName;
                    }

                    mailData = { //These below changes are made in AAG-1106
                        // "email": PurchasingPerson.email, //ReceiptEmail,
                        // "amount": Number(MembershipAmountPaid),
                        // "date": receiptDate,
                        // "billingAddress": `${response.item.customer_address ? response.item.customer_address : ''} , ${response.item.customer_address2 ? response.item.customer_address2 : ''} , ${response.item.customer_city ? response.item.customer_city : ''} , ${response.item.customer_state ? response.item.customer_state : ''} , ${response.item.customer_country ? response.item.customer_country : ''}  `,
                        // "creditCardNumber": response.item.mPAN ? response.item.mPAN : '',
                        // "name": PurchasingPerson.firstname + ' ' + PurchasingPerson.lastname,

                        "address": isUpdatePrimaryAddress ? fullAddress : undefined,  // If the user chooses to update their primary address while purchasing, that address will appear in the email template.
                        "transactionId": transId, //WE DO NOT GET TRANSACTION ID IN ADMIN PURCHASE IF THEY SELECT CASH PAYMENT OPTION, SO WE OMIT THIS KEY
                        "purchasedBy": customerName,
                        "memberId": Number(MID), //The email ID and scout name gets by the ESB through the MID. (In addition, if we fail to pass the address, they also gets address details.)
                        "toGifter": false,
                        "paragraph1": MembershipType == "NESA" ? INDIVIDUAL_PURCHASE.PARAGRAPH1 : RENEW_PURCHASE.PARAGRAPH1,
                        "paragraph2": MembershipType == "NESA" ? INDIVIDUAL_PURCHASE.PARAGRAPH2 : RENEW_PURCHASE.PARAGRAPH2,
                        "paragraph3": MembershipType == "NESA" ? INDIVIDUAL_PURCHASE.PARAGRAPH3 : RENEW_PURCHASE.PARAGRAPH3,
                        "paragraph4": MembershipType == "NESA" ? INDIVIDUAL_PURCHASE.PARAGRAPH4 : RENEW_PURCHASE.PARAGRAPH4,
                        "paragraph5": MembershipType == "NESA" ? INDIVIDUAL_PURCHASE.PARAGRAPH5 : RENEW_PURCHASE.PARAGRAPH5,
                        "MembershipType": PurchasingPerson.MembershipType ? (PurchasingPerson.MembershipType == "30" ? "NESA 5Year" : "NESA Lifetime") : ''
                    }
                    dispatch(sendNesaMail(mailData))
                }
                // Gifter
                if (MembershipType == "GIFT-NESA" || (redirectedFromGiftWorkflow && MembershipType == "RENEW-NESA")) {
                    const fullAddress = [ScoutsAddressline1, ScoutsAddressline2, ScoutsAddressline3, ScoutsCity, ScoutsState, ScoutsZipcode]
                        .map(removeCommas)
                        .filter(Boolean)
                        .join(' ');
                    gifterMailData = {//These below changes are made in AAG-1106
                        // "date": receiptDate,
                        // "name": `${PurchasingPerson.firstname ? PurchasingPerson.firstname : ''} ${PurchasingPerson.lastname ? PurchasingPerson.lastname : ''} `,
                        // "address": fullAddress,
                        // "email": `${PurchasingPerson.g_email ? PurchasingPerson.g_email : ''}`,
                        // "purchasedBy": `${response.item.name ? response.item.name : ''}`,
                        // "billingAddress": `${response.item.customer_address ? response.item.customer_address : ''} , ${response.item.customer_address2 ? response.item.customer_address2 : ''} , ${response.item.customer_city ? response.item.customer_city : ''} , ${response.item.customer_state ? response.item.customer_state : ''} , ${response.item.customer_country ? response.item.customer_country : ''}  `,
                        // "creditCardNumber": response.item.mPAN ? response.item.mPAN : '',
                        // "amount": Number(MembershipAmountPaid),

                        "MembershipType": PurchasingPerson.MembershipType ? (PurchasingPerson.MembershipType == "30" ? "NESA 5Year" : "NESA Lifetime") : '',
                        "transactionId": response.item.transId ? response.item.transId : '',
                        "memberId": Number(MID), //The email ID and scout name gets by the ESB through the MID. (In addition, if we fail to pass the address, they also gets address details.)
                        "toGifter": true, // if its true, send email to gifter
                        "paragraph1": GIFTED_PURCHASE.PARAGRAPH1,
                        "paragraph2": GIFTED_PURCHASE.PARAGRAPH2,
                        "paragraph3": GIFTED_PURCHASE.PARAGRAPH3,
                        "paragraph4": GIFTED_PURCHASE.PARAGRAPH4,
                        "paragraph5": GIFTED_PURCHASE.PARAGRAPH5,
                    }
                    dispatch(sendNesaMail(gifterMailData))
                    // Giftee
                    gifteeMailData = {//These below changes are made in AAG-1106
                        //     "name": `${PurchasingPerson.firstname ? PurchasingPerson.firstname : ''} ${PurchasingPerson.lastname ? PurchasingPerson.lastname : ''} `,
                        //     "address": fullAddress,
                        //     "email": PurchasingPerson.ScoutsEmail,

                        "MembershipType": PurchasingPerson.MembershipType ? (PurchasingPerson.MembershipType == "30" ? "NESA 5Year" : "NESA Lifetime") : '',
                        "memberId": Number(MID), //The email ID and scout name gets by the ESB through the MID. (In addition, if we fail to pass the address, they also gets address details.)
                        //Other than the gifter's name, no CC information needs to be shown in giftee emails. To accomplish this, we remove the transactionId from the giftee mail so that only the gifter's name is displayed (we pass it in "purchasedBy").
                        // "transactionId": response.item.transId ? response.item.transId : '',
                        "purchasedBy": `${PurchasingPerson.g_first_name ? PurchasingPerson.g_first_name : ''} ${PurchasingPerson.g_last_name ? PurchasingPerson.g_last_name : ''}`,
                        "toGifter": false,
                        "paragraph1": GIFTEE_GREATINGS.PARAGRAPH1,
                        "paragraph2": GIFTEE_GREATINGS.PARAGRAPH2,
                        "paragraph3": GIFTEE_GREATINGS.PARAGRAPH3,
                        "paragraph5": GIFTEE_GREATINGS.PARAGRAPH5,
                    }
                    dispatch(sendNesaMail(gifteeMailData))
                }

            })
            .catch(error => {
                console.log(error);
                dispatch(regStatusFailed(error));
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_REGISTRATIONS_1 + registrationID + `/status/public`}`), { extra: { api: ESB_REGISTRATIONS_1 + registrationID + `/status/public`, error } });
            });
    }
}

export function sendNesaMail(maildata) {
  return function (dispatch) {
    dispatch(reqRegStatus());

    return fetch(ESB_PERSONS + "sendNesaReceiptEmail", {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json;version=1",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(maildata),
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorData = {};
          try {
            errorData = await response.json();
          } catch (err) {
            errorData = {
              errorCode: response.status || "Error",
              message: response.statusText || "Request failed",
              errorDesc: "",
            };
          }
          return Promise.reject(errorData);
        }

        return response.json();
      })
      .then((status) => {
        dispatch(recRegStatus(status));
        return status;
      })
      .catch((error) => {
        console.error("NESA mail API error:", error);
        dispatch(regStatusFailed(error));
        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + "sendNesaReceiptEmail"}`), { extra: { api: ESB_PERSONS + "sendNesaReceiptEmail", error } });
        throw error;
      });
  };
}

function reqRegStatus() {
    return {
        type: ACTIONTYPES.REQUESTING_REG_STATUS
    }
}

function recRegStatus(status) {
    return {
        type: ACTIONTYPES.RECEIVING_REG_STATUS,
        status: status
    }
}

function regStatusFailed(error) {
  return {
    type: ACTIONTYPES.REG_STATUS_FAILED,
    error
  }
}

export function CashPayment(personGuid, PaymentAmount, Reginfo, paymentinfo, cash_bill_number, startdate, enddate, MID, MembershipType, isNesaManualFee) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let adminName;
    if (loggedinUser && loggedinUser.profile) adminName = `${loggedinUser.profile.firstName ? loggedinUser.profile.firstName : ''} ${loggedinUser.profile.lastName ? loggedinUser.profile.lastName : ''}`;

    return function (dispatch) {
        dispatch(requestCashPayment())
        if ( !Reginfo || !Reginfo.registrationId || !paymentinfo || !paymentinfo.id ) {
            Modal.error({
                title: "Error",
                content: "Invalid registration or payment details. Please retry."
            });

            dispatch(receiveCashPaymentError("Invalid payment context"));
            return;
        }
        fetch(ONLINE_REGISTRATIONS + Reginfo.registrationId + '/payments/' + paymentinfo.id, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                "paymentTypeLookupId": 1766,
                'isNesaManualFee': isNesaManualFee,
                "paymentTransactionId": cash_bill_number,
                "paymentDate": moment().format('YYYY-MM-DDTHH:mm:ss'),
                "paymentAmount": parseFloat(PaymentAmount),
                "effectiveDate": moment(startdate).format('YYYY-MM-DD'),
                "expiryDate": enddate ? moment(enddate).format('YYYY-MM-DD') : undefined
            })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json()
                        .then(errorResponse => Promise.reject(errorResponse))
                        .catch(() =>
                            Promise.reject({
                                message: response.statusText,
                                errorDesc: response.statusText
                            })
                        );
                }
                if (response.status === 500) {
                    return response.json()
                        .then((json) => {
                            const { message, stackTrace } = json;
                            console.log(message, stackTrace);
                        });
                }
                return response.json();
            })
            .then(paymentresponse => {
                let mailData = {
                    // "transactionId": undefined, //WE DO NOT GET TRANSACTION ID IN ADMIN PURCHASE IF THEY SELECT CASH PAYMENT OPTION, SO WE OMIT THIS KEY
                    "purchasedBy": adminName,
                    "memberId": Number(MID), //The email ID and scout name gets by the ESB through the MID. (In addition, if we fail to pass the address, they also gets address details.)
                    "toGifter": false,
                    "paragraph1": INDIVIDUAL_PURCHASE.PARAGRAPH1,
                    "paragraph2": INDIVIDUAL_PURCHASE.PARAGRAPH2,
                    "paragraph3": INDIVIDUAL_PURCHASE.PARAGRAPH3,
                    "paragraph4": INDIVIDUAL_PURCHASE.PARAGRAPH4,
                    "paragraph5": INDIVIDUAL_PURCHASE.PARAGRAPH5,
                    "MembershipType": MembershipType ? (MembershipType == "30" ? "NESA 5Year" : "NESA Lifetime") : undefined
                }
                dispatch(sendNesaMail(mailData))
                dispatch(receiveCashPayment(paymentresponse))
                dispatch(getNESARegistrations(personGuid))
            })
            .catch(error => {
                Modal.error({
                    title: error.message || "Error",
                    content:
                        error.errorDesc ||
                        error.Message ||
                        error.message ||
                        "Internal Server Error!"
                });

                dispatch(receiveCashPaymentError(error));
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ONLINE_REGISTRATIONS + Reginfo.registrationId + '/payments/' + paymentinfo.id}`), { extra: { api: ONLINE_REGISTRATIONS + Reginfo.registrationId + '/payments/' + paymentinfo.id, error } });
            });
    }
}

export function AddMembership(profile, applicationID, levelid, eagleinfo, paymentinfo, startdate, enddate) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        let personemail = profile.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        if (!personemail) {
            return dispatch(receiveAddMembershipError({
                title: "Error",
                content: "There is no Primary Email for this Person"
            }))
        }
        let address = profile.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        if (!address) {
            return dispatch(receiveAddMembershipError({
                title: "Error",
                content: 'There is no Primary Address for this Person'
            }))
        }
        let phone = profile.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        if (!phone) {
            return dispatch(receiveAddMembershipError({
                title: "Error",
                content: 'There is no Primary Phone Number for this Person'
            }))
        }
        dispatch(requestAddMembership())

        let areaCode;
        let prefix;
        let lineNumber;

        if (profile.phone && profile.phone.length == 4) {
            areaCode = '';
            prefix = '';
            lineNumber = profile.phone ? profile.phone : '';
        } else if (profile.phone && profile.phone.length == 10) {
            areaCode = profile.phone ? profile.phone.slice(0, 3) : undefined;
            prefix = profile.phone ? profile.phone.slice(3, 6) : undefined; 
            lineNumber = profile.phone ? profile.phone.slice(6, 10) : undefined;
        }

        const payload = {
            "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
                "applicationTypeId": parseInt(applicationID),
                // "applicationDate": startdate ? moment(startdate).format('YYYY-MM-DD') : undefined, //AAG-1323 The application date should be the date the user entered.
                "applicationDate": moment().format('YYYY-MM-DD'),
                "alumniMembershipLevelId": parseInt(levelid),
                "memberId": profile.profile.memberId,
                "firstName": profile.profile.firstName,
                "middleName": profile.profile.middleName ? profile.profile.middleName : "",
                "lastName": profile.profile.lastName,
                "nickname": profile.profile.nickName ? profile.profile.nickName : "",
                "dateOfBirth": profile.profile.dateOfBirth ? profile.profile.dateOfBirth : "",
                "gender": profile.profile.gender,
                "ethnicBackgroundId": parseInt(paymentinfo.ethnic_background),
                "countryId": address ? parseInt(address.countryId) : undefined,
                "addressLine1": address ? removeCommas(address.address1) : "",
                "addressLine2": address ? removeCommas(address.address2) : "",
                "addressLine3": address ? removeCommas(address.address3) : "",
                "city": address ? address.city : undefined,
                "stateId": address ? parseInt(address.stateId) : undefined,
                "zip": address ? address.zipCode : undefined,
                "zipExtension": "",
                "email": personemail ? personemail.email : undefined,
                "phoneCountryId": (phone.countryId && areaCode && prefix && lineNumber) ? parseInt(phone.countryId) : undefined,
                ...areaCode && { "areaCode": areaCode },
                ...prefix && { "prefix": prefix },
                "lineNumber": lineNumber,
                "extension": "",
                "notes": paymentinfo.notes ? paymentinfo.notes : "",
                "isRush": false,
                "boardReviewDate": (eagleinfo.eagleBoardReviewDate) ? eagleinfo.eagleBoardReviewDate : '',
                "eagleUnitNumber": (eagleinfo.eagleUnitNumber) ? eagleinfo.eagleUnitNumber : undefined,
                "eagleUnitCity": (eagleinfo.eagleUnitCity) ? eagleinfo.eagleUnitCity : undefined,
                "eagleUnitState": (eagleinfo.eagleUnitState) ? eagleinfo.eagleUnitState : undefined,
                "parentGuardianInfo": {
                    "isAdultPartner": false
                }
        }

        Sentry.captureMessage(
            `Admin AddMembership Payload: ${profile.profile.firstName} ${profile.profile.lastName}`,
            {
                level: "info",
                extra: {
                    payload: JSON.stringify(payload, null, 2)
                }
            }
        );

        Refetch(ALUMNI_REGISTARTION, {
            retries: 5,
            retryDelay: 1000,
            retryOn: [500, 503],
            cache: "no-cache",
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify(payload)
            // body: JSON.stringify({
            //     "organizationGuid": "F3A77C78-EE20-474E-9219-D53400753B29",
            //     "applicationTypeId": parseInt(applicationID),
            //     "applicationDate": today,
            //     "alumniMembershipLevelId": parseInt(levelid),
            //     "memberId": profile.profile.memberId,
            //     "firstName": profile.profile.firstName,
            //     "middleName": profile.profile.middleName ? profile.profile.middleName : "",
            //     "lastName": profile.profile.lastName,
            //     "nickname": profile.profile.nickName ? profile.profile.nickName : "",
            //     "dateOfBirth": profile.profile.dateOfBirth ? profile.profile.dateOfBirth : "",
            //     "gender": profile.profile.gender,
            //     "ethnicBackgroundId": parseInt(paymentinfo.ethnic_background),
            //     "countryId": address ? parseInt(address.countryId) : parseInt("616"),
            //     "addressLine1": address ? address.address1 : "address1",
            //     "addressLine2": address ? address.address2 : "",
            //     "addressLine3": address ? address.address3 : "",
            //     "city": address ? address.city : "Anytown",
            //     "stateId": address ? parseInt(address.stateId) : 1,
            //     "zip": address ? address.zipCode : "00000",
            //     "zipExtension": "",
            //     "email": personemail ? personemail.email : 'email@email.com',
            //     "phoneCountryId": phone ? phone.countryId ? parseInt(phone.countryId) : 636 : 636,
            //     "areaCode": phone ? phone.areaCode : "111",
            //     "prefix": phone ? phone.prefix : "111",
            //     "lineNumber": phone ? phone.lineNumber : "1111",
            //     "extension": "",
            //     "notes": paymentinfo.notes ? paymentinfo.notes : "",
            //     "isRush": false,
            //     "boardReviewDate": (eagleinfo.eagleBoardReviewDate) ? eagleinfo.eagleBoardReviewDate : '',
            //     "eagleUnitNumber": (eagleinfo.eagleUnitNumber) ? eagleinfo.eagleUnitNumber : "0000",
            //     "eagleUnitCity": (eagleinfo.eagleUnitCity) ? eagleinfo.eagleUnitCity : "Anytown",
            //     "eagleUnitState": (eagleinfo.eagleUnitState) ? eagleinfo.eagleUnitState : "TX",
            //     "parentGuardianInfo": {
            //         "isAdultPartner": false
            //     }
            // })
        })
            .then(response => {
                if (!response.ok) {
                    // return response.text().then(result => Promise.reject(new Error(result)));
                    // return response.json().then(err => Promise.reject(err));
                    return response.json().then(err => {
                        const apiError = new Error(err.message || "API Error");
                        apiError.errorCode = err.errorCode;
                        apiError.errorDesc = err.errorDesc;
                        throw apiError;
                    })
                }
                return response.json();
            })
            .then(Registrationresponse => {

                Sentry.captureEvent({
                    message: `Admin AddMembership Registration Response: ${profile.profile.firstName} ${profile.profile.lastName}`,
                    level: "info",
                    extra: { Registrationresponse }
                });

                adminNESAMembership = Registrationresponse;
                dispatch(gettingShoppingCartList())
                shoppingCart(Registrationresponse.registrationId)
                    .then(result => {
                        if (!result.ok) throw result;
                        return result.json();
                    })
                    .then(result => {
                        Sentry.captureEvent({
                            message: `Admin AddMembership ShoppingCart Response: ${profile.profile.firstName} ${profile.profile.lastName}`,
                            level: "info",
                            extra: { shoppingCart: JSON.stringify(result, null, 2) }
                        });

                        dispatch(recivedShoppingCartList(result))
                        fetch(ONLINE_REGISTRATIONS + Registrationresponse.registrationId + '/payments', {
                            method: 'POST',
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "application/json",
                                "authorization": "token=Bearer " + token
                            },
                            body: JSON.stringify({ "paymentTypeId": 1766, "totalAmountDue": result.totalAmountDue })
                        })
                            .then(response => {
                                if (!response.ok) {
                                    return response.json().then(err => {
                                        const apiError = new Error(err.message || "Payment API Error");
                                        apiError.errorCode = err.errorCode;
                                        apiError.errorDesc = err.errorDesc;
                                        throw apiError;
                                    });
                                }
                                return response.json();
                            })
                            .then(paymentresponse => {
                                dispatch(receiveAddMembership(paymentresponse, Registrationresponse))
                                return Registrationresponse;
                            })
                            .catch(error => {
                                Sentry.captureException(error, {
                                    extra: {
                                        context: "AddMembership Payment Error",
                                        registrationId: Registrationresponse.registrationId,
                                        errorCode: error.errorCode,
                                        errorDesc: error.errorDesc
                                    }
                                });

                                if (error && error.errorDesc) {
                                    dispatch(receiveAddMembershipError({
                                        title: error.message,
                                        content: error.errorDesc
                                    }));
                                } else {
                                    dispatch(receiveAddMembershipError({
                                        title: "Payment Error",
                                        content: "Failed to process payment. Please try again."
                                    }));
                                }
                            });
                    })
                    .catch(error => {
                        Sentry.captureException(error, {
                            extra: {
                                context: "AddMembership ShoppingCart Error",
                                registrationId: Registrationresponse.registrationId
                            }
                        });

                        console.log(error);
                        // Sentry.captureException(error);
                    });
            })
            // .catch(error => {
            //     Sentry.captureException(error);
            //     if (JSON.parse(error.message).errorDesc == 'Member has NESA lifetime registration') {
            //         dispatch(receiveAddMembershipError('Our records indicate you already have a Lifetime NESA membership. If you believe this is in error, please contact NESA at 972-580-2000.'))
            //     } else {
            //         dispatch(receiveAddMembershipError('Error occurred while processing request. Please try again in 24 hours'))
            //     }
            // });
            .catch(error => {
                const sentryError = new Error(error.message || "AddMembership API Error");

                Sentry.captureException(sentryError, {
                    level: "error",
                    extra: {
                        context: "AddMembership Flow Error",
                        errorCode: error.errorCode,
                        errorDesc: error.errorDesc,
                        payload: payload
                    }
                });

                if (error && error.errorDesc) {
                    if (error.errorDesc === 'Member has NESA lifetime registration') {
                        dispatch(receiveAddMembershipError(
                            'Our records indicate you already have a Lifetime NESA membership. If you believe this is in error, please contact NESA at 972-580-2000.'
                        ));
                    } else {
                        dispatch(receiveAddMembershipError({
                            title: error.message,
                            content: error.errorDesc
                    }));
                    }
                } else {
                    dispatch(receiveAddMembershipError(
                        'Error occurred while processing request. Please try again in 24 hours.'
                    ));
                }
            });
    }
}

function requestAddMembership() {
    return {
        type: ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION_LOADING,
    }
}

function receiveAddMembership(response, regresponse) {
    return {
        type: ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION,
        response: response,
        regresponse: regresponse
    }
}

export function receiveAddMembershipError(error) {
    if (error) {

        const isObject = typeof error === "object";

        Modal.error({
            className: "ErrorModal",
            title: isObject ? (error.title || "Error") : "Error",
            content: isObject ? error.content : error
        });
    }

    return {
        type: ACTIONTYPES.ADD_MEMBERSHIP_RESGISTRATION_ERROR,
        error: error
    }
}

function requestCashPayment() {
    return {
        type: ACTIONTYPES.CASH_PAYMENT_INITIATED,
    }
}

function receiveCashPayment(response) {
    return {
        type: ACTIONTYPES.CASH_PAYMENT_COMPLETED,
        response: response,
    }
}

function receiveCashPaymentError(error) {
    return {
        type: ACTIONTYPES.CASH_PAYMENT_ERROR,
        error
    }
}

export function getAlumniInfo(personGUID, by) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let url = ""
    by == "admin" ? url = ESB_PERSONS + 'v2/' + personGUID + `/personprofile` : url = ESB_PERSONS + personGUID + `/alumniProfile`
    return function (dispatch) {
        dispatch(requestAlumniInfo())
        fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        dispatch(recActivateStatus(response))
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Alumni has not made their profile public',
                            okText: 'Back',
                            onOk() {
                                history.push('/alumni-search')
                            }
                        });
                    } else if (response.status == 401) {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'You are not authorized to access this profile',
                            okText: 'Back',
                            onOk() {
                                if (window.location.pathname.includes('/quick-search')) {
                                    history.push('/quick-search')
                                } else if (window.location.pathname.includes('/list-and-search')) {
                                    history.push('/list-and-search')
                                }
                            }
                        });
                    }

                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(profileinfo => {
                dispatch(receiveAlumniinfo(profileinfo));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${url}`), { extra: { api: url, error } });
                if (error == "Forbidden") {
                    // dispatch(sessionTimeOut())
                }
                console.log(error);
            });
    }
}

function requestAlumniInfo() {
    return {
        type: ACTIONTYPES.ALUMNI_INFO_LOADING
    }
}

function receiveAlumniinfo(profileinfo) {
    return {
        type: ACTIONTYPES.ALUMNI_INFO,
        profileinfo: profileinfo
    }
}


export function getAlumniEagleInfo(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqalumnieagleinfo())
        fetch(ESB_PERSONS + personGUID + `/eagleInformation`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(eagleinfo => {
                dispatch(recalumnieagleinfo(eagleinfo));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/eagleInformation`}`), { extra: { api: ESB_PERSONS + personGUID + `/eagleInformation`, error } });
                console.log(error);
            });

    }
}

function reqalumnieagleinfo() {
    return {
        type: ACTIONTYPES.ALUMNI_EAGLE_INFO_LOADING,
    }
}

function recalumnieagleinfo(eagleinfo) {
    return {
        type: ACTIONTYPES.ALUMNI_EAGLE_INFO_RECEIVED,
        eagleinfo: eagleinfo
    }
}

export function getNESARegistrations(personGUID, isRenewal) {
    let options = {};
    let loggedinUser;
    let token;

    if (isRenewal) {
        options = {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
            }
        }
    } else {
        loggedinUser = JSON.parse(localStorage.getItem('user'))
        token = loggedinUser.token;
        options = {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        }
    }

    return function (dispatch) {
        dispatch(reqNESAreg())
        fetch(ESB_PERSONS + personGUID + `/nesaRegistrations`, options)
            .then(async response => {
                if (!response.ok) {
                    const errorText = await response.text();
                    Sentry.captureException(new Error(`nesaRegistrations API Error: ${response.status} ${response.statusText}`), {
                        extra: { personGUID, isRenewal, status: response.status, statusText: response.statusText, responseBody: errorText }
                    });

                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(reg => {
                Sentry.captureEvent({
                    message: `nesaRegistrations Response for personGUID=${personGUID}`,
                    level: 'info',
                    extra: { personGUID, isRenewal, response: reg }
                });

                dispatch(recNESAreg(reg));
            })
            .catch(error => {
                Sentry.captureException(new Error(`nesaRegistrations Fetch Exception: ${error}`), {
                    extra: { personGUID, isRenewal }
                });

                dispatch(recNESAreg("error"));
                console.log(error);
            });

    }
}

function reqNESAreg() {
    return {
        type: ACTIONTYPES.NESA_REGISTRATION_LOADING,
    }
}

function recNESAreg(reg) {
    return {
        type: ACTIONTYPES.NESA_REGISTRATION_RECEIVED,
        reg: reg
    }
}


export function getSAFRegistrations(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqSAFreg())
        fetch(ESB_PERSONS + personGUID + `/alumniRegistrations`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(reg => {
                dispatch(recSAFreg(reg));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/alumniRegistrations`}`), { extra: { api: ESB_PERSONS + personGUID + `/alumniRegistrations`, error } });
                dispatch(recSAFreg("error"));
                console.log(error);
            });

    }
}

function reqSAFreg() {
    return {
        type: ACTIONTYPES.SAF_REGISTRATION_LOADING,
    }
}

function recSAFreg(reg) {
    return {
        type: ACTIONTYPES.SAF_REGISTRATION_RECEIVED,
        reg: reg
    }
}



export function updateProfilePicture(personGUID, img, picturemethod, msg) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqUpdateProPic())
        fetch(ESB_PERSONS + personGUID + `/profilePicture`, {
            method: picturemethod,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "picture": img,
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(getProfileInfo(personGUID, true))
                dispatch(recUpdateProPic(status));
                Modal.success({
                    title: 'Success',
                    content: 'Profile Picture ' + msg + ' Successfully!',
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/profilePicture`}`), { extra: { api: ESB_PERSONS + personGUID + `/profilePicture`, error } });
                console.log(error);
            });

    }
}

function reqUpdateProPic() {
    return {
        type: ACTIONTYPES.PROFILE_PICTURE_UPDATING,
    }
}

function recUpdateProPic(status) {
    return {
        type: ACTIONTYPES.PROFILE_PICTURE_UPDATED,
        status: status
    }
}


export function getMaritalstatuses() {
    return function (dispatch) {
        dispatch(requestMaritalstatus())
        fetch(GET_MARITALSTATUS, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(recMaritalstatus(status));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_MARITALSTATUS}`), { extra: { api: GET_MARITALSTATUS, error } });
                console.log(error);
            });
    }
}

function requestMaritalstatus() {
    return {
        type: ACTIONTYPES.MARITAL_STATUS_LOADING
    }
}

function recMaritalstatus(status) {
    return {
        type: ACTIONTYPES.MARITAL_STATUS_LOADED,
        status: status
    }
}


export function getMyRanks(memberid) {
    return function (dispatch) {
        dispatch(reqMyRanks())
        fetch(ADULT_ADVANCEMENTS + memberid + '/ranks', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(ranks => {
                dispatch(recMyRanks(ranks));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ADULT_ADVANCEMENTS + memberid + '/ranks'}`), { extra: { api: ADULT_ADVANCEMENTS + memberid + '/ranks', error } });
                console.log(error);
            });
    }
}

function reqMyRanks() {
    return {
        type: ACTIONTYPES.MY_RANKS_LOADING
    }
}

function recMyRanks(ranks) {
    return {
        type: ACTIONTYPES.MY_RANKS_LOADED,
        ranks: ranks
    }
}

// export function getAllRanks() {
//     return function (dispatch) {
//         dispatch(reqRanks())
//         fetch(GET_RANKS, {
//             method: 'GET',
//             credentials: 'include',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             }
//         })
//             .then(response => {
//                 if (!response.ok) {
//                     return Promise.reject(response.statusText);
//                 }
//                 return response.json();
//             })
//             .then(ranks => {
//                 dispatch(recRanks(ranks));
//             })
//             .catch(error => {
//                 console.log(error);
//             });
//     }
// }

function reqRanks() {
    return {
        type: ACTIONTYPES.ALL_RANKS_LOADING
    }
}

function recRanks(ranks) {
    return {
        type: ACTIONTYPES.ALL_RANKS_LOADED,
        ranks: ranks
    }
}

export function getAllAffinityGroups() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqAllAffinityGroups())
        fetch(ESB_LOOKUP + 'alumni/affinityGroups', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(affinities => {
                dispatch(recallAffinityGroups(affinities));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_LOOKUP + 'alumni/affinityGroups'}`), { extra: { api: ESB_LOOKUP + 'alumni/affinityGroups', error } });
                console.log(error);
            });
    }
}

export function getAllLocalAwards() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;

    return function (dispatch) {
        dispatch(reqAllLocalAwards())
        fetch(ESB_LOOKUP + 'alumni/localAwards', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(localAwards => {
                dispatch(recallLocalAwards(localAwards));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_LOOKUP + 'alumni/localAwards'}`), { extra: { api: ESB_LOOKUP + 'alumni/localAwards', error } });
                console.log(error);
            });
    }
}


export function getallscoutingassociations() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqallscoutingassociation())
        fetch(ESB_LOOKUP + 'alumni/scoutingAssociations', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(scoutings => {
                dispatch(recallscoutingassociation(scoutings));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_LOOKUP + 'alumni/scoutingAssociations'}`), { extra: { api: ESB_LOOKUP + 'alumni/scoutingAssociations', error } });
                console.log(error);
            });
    }
}

function reqallscoutingassociation() {
    return {
        type: ACTIONTYPES.LOADING_SCOUTINGS
    }
}

function reqAllAffinityGroups() {
    return {
        type: ACTIONTYPES.LOADING_AFFINITIES
    }
}

function reqAllLocalAwards() {
    return {
        type: ACTIONTYPES.LOADING_LOCALAWARDS
    }
}

function recallscoutingassociation(scoutings) {
    return {
        type: ACTIONTYPES.LOADED_SCOUTINGS,
        scoutings: scoutings
    }
}

function recallAffinityGroups(affinities) {
    return {
        type: ACTIONTYPES.LOADED_AFFINITIES,
        affinities: affinities
    }
}

function recallLocalAwards(localAwards) {
    return {
        type: ACTIONTYPES.LOADED_LOCALAWARDS,
        localAwards: localAwards
    }
}

export function getAllOrganizationCouncils() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqOrganizationCouncils())
        fetch(ESB_ORGANIZATIONS + 'councils', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(councils => {
                dispatch(recOrganizationCouncils(councils));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + 'councils'}`), { extra: { api: ESB_ORGANIZATIONS + 'councils', error } });
                console.log(error);
            });
    }
}


export function getallcouncils() {
    // const loggedinUser = JSON.parse(localStorage.getItem('user'))
    // let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqallcouncils())
        fetch(ESB_LOOKUP + 'alumni/councilAffiliations', {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                // "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(councils => {
                dispatch(recallcouncils(councils));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_LOOKUP + 'alumni/councilAffiliations'}`), { extra: { api: ESB_LOOKUP + 'alumni/councilAffiliations', error } });
                console.log(error);
            });
    }
}

function reqallcouncils() {
    return {
        type: ACTIONTYPES.LOADING_COUNCILS
    }
}

function reqOrganizationCouncils() {
    return {
        type: ACTIONTYPES.LOADING_ORGANIZATION_COUNCILS
    }
}

function recallcouncils(councils) {
    return {
        type: ACTIONTYPES.LOADED_COUNCILS,
        councils: councils
    }
}

function recOrganizationCouncils(councils) {
    return {
        type: ACTIONTYPES.LOADED_ORGANIZATION_COUNCILS,
        councils: councils
    }
}

export function getNationalAwards() {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqNationalAwards())
        fetch(`${ESB_URL}/advancements/akelaAwards`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(nationalAwards => {
                dispatch(recNationalAwards(nationalAwards));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_URL}/advancements/akelaAwards`}`), { extra: { api: `${ESB_URL}/advancements/akelaAwards`, error } });
                console.log(error);
            });
    }
}

function reqNationalAwards() {
    return {
        type: ACTIONTYPES.LOADING_NATIONAL_AWARDS
    }
}

function recNationalAwards(nationalAwards) {
    return {
        type: ACTIONTYPES.LOADED_NATIONAL_AWARDS,
        nationalAwards: nationalAwards
    }
}

export function acceptNewEagleReq_RecordInfo(eagleRequestId, eagleBoardReviewDate, shouldAddEagleScoutRank, userId) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {

        fetch(ESB_PERSONS + `v2/eagleRequest/${eagleRequestId}/submit`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(result => Promise.reject(new Error(result)));
                }
                return response.json();
            })
            .then(async response => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Updated successfully!",
                    onOk() {
                        dispatch(getAlumniEagleInfo(response.personGuid));
                    }
                });
                dispatch(recAddNewEagleDetailsRepairInfo());

                if (shouldAddEagleScoutRank) {
                    await addEagleScoutRankInBackground(response.personGuid, eagleBoardReviewDate, token, dispatch, userId);
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + `v2/eagleRequest/${eagleRequestId}/submit`}`), { extra: { api: ESB_PERSONS + `v2/eagleRequest/${eagleRequestId}/submit`, error } });
                dispatch(failedAddNewEagleDetailsRepairInfo())
                console.log(error);
                let err = JSON.parse(error)
                Modal.error({
                    className: "ErrorModal",
                    title: `${err.errorCode} ${err.message}`,
                    content: err.errorDesc,
                    onOk() {

                    }
                });
            });
    }
}

export function AddNewEagleDetailsRepairInfo(values, profile, personGUID, needToUpdateDOB) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGuid = personGUID;
    const getHomeAddress = profile.addresses.find(address => address.isPrimary);
    let isUsCitizen = true;
    if (getHomeAddress) {
        isUsCitizen = Boolean(getHomeAddress.country == "USA")
    }

    const getPrimaryPhone = profile.phones.find(phone => phone.isPrimary);
    let phoneNumber;
    if (getPrimaryPhone) {
        phoneNumber = `${getPrimaryPhone.countryCode ?`+${getPrimaryPhone.countryCode} `: ''}${getPrimaryPhone.areaCode ? getPrimaryPhone.areaCode : ''}-${getPrimaryPhone.prefix ? getPrimaryPhone.prefix : ''}-${getPrimaryPhone.lineNumber ? getPrimaryPhone.lineNumber : ''}`
    }

    const getPrimaryEmail = profile.emails.find(email => email.isPrimary);
    let email;
    if (getPrimaryEmail) {
        email = getPrimaryEmail.email
    }
    return function (dispatch) {
        dispatch(reqAddNewEagleDetailsRepairInfo())
        fetch(ESB_PERSONS + 'v2/eagleRequest/add', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token 
            },
            body: JSON.stringify({
                "memberId": Number(profile.profile.memberId),
                "firstName": profile.profile.firstName,
                "middleName": profile.profile.middleName ? profile.profile.middleName : undefined,
                "lastName": profile.profile.lastName,
                "dateOfBirth": needToUpdateDOB ? moment(values.dob).format('YYYY-MM-DD') : profile.profile.dateOfBirth,
                "gender": profile.profile.gender,
                "isUsCitizen": isUsCitizen,
                "phoneNumber": phoneNumber,
                "email": email,
                "validatedBy": values.validatedBy,
                "validatedDt": values.validatedDate ? moment(values.validatedDate).format('YYYY-MM-DD') : "",
                "personCouncilNumber": values.currentCouncilNumber.toString().padStart(3, '0'),
                "eagleCouncilNumber": values.eagleCouncilNumber.toString().padStart(3, '0'),
                // "unitGuid": "00203D80-2B7B-427B-908C-908C2FF8A363",
                "unitType": values.eagleProgram,
                "unitNumber": values.eagleUnit,
                "eagleCity": values.unitCity,
                "eagleState": values.unitState,
                "eagleCountry": values.eagleCountry,
                "boardOfReviewDate": values.boardOfReviewDate ? moment(values.boardOfReviewDate).format('YYYY-MM-DD') : "",
                // "firstClassBoardOfReviewDate": "1999-01-01",
                "certifiedBy": values.certifiedBy,
                "certifiedDt": values.certifiedDate ? moment(values.certifiedDate).format('YYYY-MM-DD') : "",
            }
                //     {
                //     "eagleUnitType": values.eagleProgram,
                //     "eagleUnitNumber": values.eagleUnit,
                //     "eagleUnitCity": values.unitCity,
                //     "eagleUnitState": values.unitState,
                //     "eagleUnitGuid": values.councilId,
                //     // "certifiedBy": values.createdBy,
                //     // "certifiedDt": values.certifiedDate,
                //     "validatedBy": values.validatedBy,
                //     "eagleCertificateBy": values.certifiedBy,
                //     "eagleCertificateDt": values.certifiedDate ? moment(values.certifiedDate).format('YYYY-MM-DD') : "",
                //     "boardOfReviewDt": values.boardOfReviewDate ? moment(values.boardOfReviewDate).format('YYYY-MM-DD') : "",
                //     "updateCurrentOrganization": values.updateCurrentOrganization ? values.updateCurrentOrganization : false,
                // }
            )
        })

            .then(response => {
                if (!response.ok) {
                    return response.text().then(result => Promise.reject(new Error(result)));
                }
                return response.json();
            })
            .then(response => {
                const eagleBoardReviewDate = values.boardOfReviewDate ? moment(values.boardOfReviewDate).format('YYYY-MM-DD') : "";
                const shouldAddEagleScoutRank = values.eagleScoutRank === 'Eagle Scout';
                const userId = profile && profile.profile ? profile.profile.userId : undefined;
                dispatch(acceptNewEagleReq_RecordInfo(response.eagleRequestId, eagleBoardReviewDate, shouldAddEagleScoutRank, userId))
                if(needToUpdateDOB) dispatch(getAlumniInfo(personGUID, "admin"))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/eagleRequest/add'}`), { extra: { api: ESB_PERSONS + 'v2/eagleRequest/add', error } });
                dispatch(failedAddNewEagleDetailsRepairInfo())
                console.log(error);
                let err = JSON.parse(error.message)
                Modal.error({
                    className: "ErrorModal",
                    title: `${err.errorCode} ${err.message}`,
                    content: err.errorDesc,
                    onOk() {

                    }
                });
            });
    }

}


function reqAddNewEagleDetailsRepairInfo() {
    return {
        type: ACTIONTYPES.ADD_NEW_EAGLE_DETAILS
    }
}

function recAddNewEagleDetailsRepairInfo() {
    return {
        type: ACTIONTYPES.ADDED_NEW_EAGLE_DETAILS,
    }
}

function failedAddNewEagleDetailsRepairInfo() {
    return {
        type: ACTIONTYPES.FAILED_NEW_EAGLE_DETAILS
    }
}

export function updateAdminRepairInfo(values, personGUID, eagleId, needToUpdateDOB, userId) {
    return async function (dispatch) {
        dispatch(reqAddAdminRepairInfo());

        const loggedinUser = JSON.parse(localStorage.getItem('user'));
        const token = loggedinUser.token;

        try {
            const eagleBody = {
                eagleUnitType: values.eagleProgram,
                eagleUnitNumber: values.eagleUnit,
                eagleUnitCity: values.unitCity,
                eagleUnitState: values.unitState,
                eagleUnitGuid: values.councilId,
                validatedBy: values.validatedBy,
                eagleCertificateBy: values.certifiedBy,
                eagleCertificateDt: values.certifiedDate ? moment(values.certifiedDate).format('YYYY-MM-DD') : "",
                boardOfReviewDt: values.boardOfReviewDate ? moment(values.boardOfReviewDate).format('YYYY-MM-DD') : "",
                updateCurrentOrganization: !!values.updateCurrentOrganization,
            };

            const fetchEagleInfo = fetch(ESB_PERSONS + 'v2/' + personGUID + '/eagleInformation/' + eagleId, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(eagleBody),
            });

            let fetchDOB;
            if (needToUpdateDOB) {
                fetchDOB = fetch(ESB_PERSONS + 'v2/' + personGUID + `/profile`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        dateOfBirth: moment(values.dob).format('YYYY-MM-DD'),
                    }),
                });
            }

            const [eagleResponse, dobResponse] = await Promise.all([
                fetchEagleInfo,
                needToUpdateDOB ? fetchDOB : Promise.resolve({ ok: true, json: async () => ({}) })
            ]);

            if (!eagleResponse.ok) {
                const errorData = await eagleResponse.json().catch(() => null);
                throw errorData || { message: eagleResponse.statusText };
            }

            if (needToUpdateDOB && !dobResponse.ok) {
                const errorData = await dobResponse.json().catch(() => null);
                throw errorData || { message: dobResponse.statusText };
            }

            const eagleData = await eagleResponse.json();
            const dobData = needToUpdateDOB ? await dobResponse.json() : null;

            console.log('updateEagleInfoResponse:', eagleData);
            if (dobData) {
                console.log('updateDOBResponse:', dobData);
            }

            Modal.success({
                className: "ErrorModal",
                title: 'Success',
                content: "Updated successfully!",
            });

            dispatch(recAddAdminRepairInfo(eagleData));
            dispatch(getAlumniEagleInfo(personGUID));

            if(needToUpdateDOB) dispatch(getAlumniInfo(personGUID, "admin"))

            if (values.eagleScoutRank === 'Eagle Scout') {
                const eagleBoardReviewDate = values.boardOfReviewDate ? moment(values.boardOfReviewDate).format('YYYY-MM-DD') : "";
                await addEagleScoutRankInBackground(personGUID, eagleBoardReviewDate, token, dispatch, userId);
            }
        } catch (responseError) {
            let errorTitle = "Error";
            let errorMessage = "Something went wrong while updating Eagle Information.";

            if (responseError && typeof responseError === "object") {
                errorTitle = `${responseError.errorCode || ""} ${responseError.message || ""}`.trim();
                errorMessage = responseError.errorDesc || errorMessage;
            } else if (typeof responseError === "string") {
                errorMessage = responseError;
            }

            dispatch(failAddAdminRepairInfo(errorMessage));

            Modal.error({
                className: "ErrorModal",
                title: errorTitle,
                content: errorMessage
            });
        }
    };
}

function reqAddAdminRepairInfo() {
    return {
        type: ACTIONTYPES.ADD_ADMINREPAIR
    }
}

function recAddAdminRepairInfo(status) {
    return {
        type: ACTIONTYPES.ADDED_ADMINREPAIR,
        status: status
    }
}

function failAddAdminRepairInfo(error) {
    return { type: ACTIONTYPES.ADD_ADMINREPAIR_FAILED, error }
}

export function addLocalAwards(value, personGuid, forSelfViewOnly) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqAddLocalAwards())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "alumniLocalAwards": [
                    {
                        "localAward": value
                    }
                ]
            })
        })

            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Local Award added successfully!",
                    onOk() {

                    }
                });
                forSelfViewOnly ? dispatch(getAlumniAndLocalAwards()) : dispatch(getProfileInfo(personGUID, true))
                dispatch(recAddLocalAwards(status));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings'}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings', error } });
                console.log(error);
            });
    }
}

export function addAffinities(value, personGuid, forSelfViewOnly) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqAddAffinities())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "alumniAffinityGroups": [
                    {
                        "affinityGroup": value
                    }
                ]
            })
        })

            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Affinity Group added successfully!",
                    onOk() {

                    }
                });
                forSelfViewOnly ? dispatch(getAffinityGroups()) : dispatch(getProfileInfo(personGUID, true));
                dispatch(recAddAffinities(status));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings'}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings', error } });
                console.log(error);
            });
    }
}

export function addCouncils(value, personGuid, forSelfViewOnly) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqaddcouncils())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "alumniCouncilAffiliations": [
                    {
                        "councilAffiliation": value
                    }
                ]
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Council Affiliation added successfully!",
                    onOk() {

                    }
                });
                forSelfViewOnly ? dispatch(getCouncilAffiliations()) : dispatch(getProfileInfo(personGUID, true));
                dispatch(recaddcouncils(status));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings'}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings', error } });
                console.log(error);
            });
    }
}

function reqAddLocalAwards() {
    return {
        type: ACTIONTYPES.ADD_LOCALAWARDS
    }
}

function recAddLocalAwards(status) {
    return {
        type: ACTIONTYPES.ADDED_LOCALAWARDS,
        status: status
    }
}

function reqAddAffinities() {
    return {
        type: ACTIONTYPES.ADD_AFFINITIES
    }
}

function recAddAffinities(status) {
    return {
        type: ACTIONTYPES.ADDED_AFFINITIES,
        status: status
    }
}

function reqaddcouncils() {
    return {
        type: ACTIONTYPES.ADD_COUNCILS
    }
}

function recaddcouncils(status) {
    return {
        type: ACTIONTYPES.ADDED_COUNCILS,
        status: status
    }
}

export function addScoutings(value, personGuid, forSelfViewOnly) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqaddscoutings())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "alumniScoutingAssociations": [
                    {
                        "scoutingAssociation": value
                    }
                ]
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Scouting Affiliation added successfully!",
                    onOk() {

                    }
                });
                forSelfViewOnly ? dispatch(getScoutingAffiliations()) : dispatch(getProfileInfo(personGUID, true));
                dispatch(recaddscouting(status));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings'}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings', error } });
                console.log(error);
            });
    }
}

function reqaddscoutings() {
    return {
        type: ACTIONTYPES.ADD_SCOUTING
    }
}

function recaddscouting(status) {
    return {
        type: ACTIONTYPES.ADDED_SCOUTING,
        status: status
    }
}

export function deleteLocalAward(id, fromManageMemberID, personGuid) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqdeleteLocalAwards())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings/' + id, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Local Award deleted successfully!",
                    onOk() {

                    }
                });
                fromManageMemberID ? dispatch(getmemberid(personGUID, true)) : dispatch(getAlumniAndLocalAwards())
                dispatch(recdeleteLocalAwards(status))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings/' + id}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings/' + id, error } });
                console.log(error);
                Modal.error({
                    className: "ErrorModal",
                    title: 'Failed to delete the award',
                    content: error,
                    onOk() {

                    }
                });
            });
    }
}

export function deleteAffinity(id, fromManageMemberID, personGuid) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        dispatch(reqdeleteaffinities())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings/' + id, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Affinity deleted successfully!",
                    onOk() {

                    }
                });
                // dispatch(getProfileInfo(personGUID, true))
                dispatch(getAffinityGroups())
                dispatch(recdeleteaffinities(status))
                fromManageMemberID && dispatch(getmemberid(personGUID, true))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings/' + id}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings/' + id, error } });
                console.log(error);
                notification.open({
                    message: error.errorCode ? error.errorCode : "Error",
                    description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
            });
    }
}


export function deleteScouting(from, id, fromManageMemberID, personGuid) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = personGuid ? personGuid : loggedinUser.personGuid;
    return function (dispatch) {
        from === 'scoutings' ? dispatch(reqdeletescoutings()) : dispatch(reqdeletecouncils())
        fetch(ESB_PERSONS + personGUID + '/alumniSettings/' + id, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: from === 'scoutings' ? "Scouting Affiliation deleted successfully!" : "Council Affiliation deleted successfully!",
                    onOk() {

                    }
                });
                // dispatch(getProfileInfo(personGUID, true))
                if (from === 'scoutings') {
                    dispatch(getScoutingAffiliations())
                    dispatch(recdeletescoutings(status))
                } else {
                    dispatch(recdeletecouncils(status));
                    dispatch(getCouncilAffiliations())
                }
                if (fromManageMemberID) dispatch(getmemberid(personGUID, true))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniSettings/' + id}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniSettings/' + id, error } });
                console.log(error);
                notification.open({
                    message: error.errorCode ? error.errorCode : "Error",
                    description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
            });
    }
}
function reqdeletecouncils() {
    return {
        type: ACTIONTYPES.DELETE_COUNCILS
    }
}

function recdeletecouncils(status) {
    return {
        type: ACTIONTYPES.DELETED_COUNCILS,
        status: status
    }
}

function reqdeleteaffinities() {
    return {
        type: ACTIONTYPES.DELETE_AFFINITIES
    }
}

function recdeleteaffinities(status) {
    return {
        type: ACTIONTYPES.DELETED_AFFINITIES,
        status: status
    }
}

function reqdeleteLocalAwards() {
    return {
        type: ACTIONTYPES.DELETE_LOCALAWARDS
    }
}

function recdeleteLocalAwards(status) {
    return {
        type: ACTIONTYPES.DELETED_LOCALAWARDS,
        status: status
    }
}

function reqdeletescoutings() {
    return {
        type: ACTIONTYPES.DELETE_SCOUTINGS
    }
}

function recdeletescoutings(status) {
    return {
        type: ACTIONTYPES.DELETED_SCOUTINGS,
        status: status
    }
}

const fetchAwards = (personGUID, by) => {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return fetch(ESB_PERSONS + personGUID + '/alumniAwards', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": "Bearer " + token
        }
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
}
const memoizedFetchAwards = memoize(
    (personGUID, by) => fetchAwards(personGUID, by),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentPersonGuid] = lastArgs;
        const [newPersonGuid] = newArgs;
        return currentPersonGuid === newPersonGuid;
    });

export function getAwards(personGUID, by) {
    return function (dispatch) {
        by == 'alumni' ? dispatch(reqalumniAwards()) : dispatch(reqAwards())
        memoizedFetchAwards(personGUID, by)
            .then(awards => {
                by == 'alumni' ? dispatch(recalumniAwards(awards)) : dispatch(recAwards(awards))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/alumniAwards'}`), { extra: { api: ESB_PERSONS + personGUID + '/alumniAwards', error } });
                console.log(error);
            });
    }
}

function reqAwards() {
    return {
        type: ACTIONTYPES.LOADING_AWARDS
    }
}

function recAwards(awards) {
    return {
        type: ACTIONTYPES.LOADED_AWARDS,
        awards: awards
    }
}

function reqalumniAwards() {
    return {
        type: ACTIONTYPES.LOADING_ALUMNI_AWARDS
    }
}

function recalumniAwards(awards) {
    return {
        type: ACTIONTYPES.LOADED_ALUMNI_AWARDS,
        awards: awards
    }
}

export function deleteWebContacts(personGUID, id) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(requpdateWebContacts())
        fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "type": "webContact",
                "id": id
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Web contacts deleted successfully!",
                    onOk() {
                        dispatch(recupdateWebContactsStatus("deleted"))
                        dispatch(getProfileInfo(personGUID, true))
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                console.log(error);
            });
    }
}
export function deleteExistingHobbies(personGUID, extentedProfileIds) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    if (extentedProfileIds.length > 0) {
        return function (dispatch) {
            dispatch(requpdateWebContacts())
            extentedProfileIds.map(eachExtentedProfileId => {
                fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json; version = 1',
                        "Authorization": "Bearer " + token
                    },
                    body: JSON.stringify({
                        "type": "hobbies",
                        "id": Number(eachExtentedProfileId)
                    })
                })
                    .then(response => {
                        if (!response.ok) {
                            return Promise.reject(response.statusText);
                        }
                        return response.json();
                    })
                    .then(status => {
                        console.log('Existing Hobbies deleted Successfully!');
                    })
                    .catch(error => {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                        console.log(error);
                    });
            })
        }
    }
}


export function deleteEmail(personGUID, id, by) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdatecontact()) : dispatch(reqAlumniUpdatecontact())
        fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "type": "email",
                "id": Number(id)
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Email Deleted successfully!",
                    onOk() {
                        if (by == 'alumni') {
                            dispatch(recMyUpdateContact(status))
                            dispatch(getProfileInfo(personGUID, true))
                        } else {
                            dispatch(recAlumniUpdateContact(status))
                            dispatch(getAlumniInfo(personGUID, "admin"))
                        }
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                console.log(error);
                (by == 'alumni') ? dispatch(failedMyUpdateContact(error)) : dispatch(failedAlumniUpdateContact(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Delete Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}



export function deletemobile(personGUID, id, by) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdatecontact()) : dispatch(reqAlumniUpdatecontact())
        fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "type": "phone",
                "id": Number(id)
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Number Deleted successfully!",
                    onOk() {
                        if (by == 'alumni') {
                            dispatch(recMyUpdateContact(status))
                            dispatch(getProfileInfo(personGUID, true))
                        } else {
                            dispatch(recAlumniUpdateContact(status))
                            dispatch(getAlumniInfo(personGUID, "admin"))
                        }
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                console.log(error);
                (by == 'alumni') ? dispatch(failedMyUpdateContact(error)) : dispatch(failedAlumniUpdateContact(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Delete Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}


export function deleteaddress(personGUID, id, by) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdatecontact()) : dispatch(reqAlumniUpdatecontact())
        fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "type": "address",
                "id": Number(id)
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Address Deleted successfully!",
                    onOk() {
                        if (by == 'alumni') {
                            dispatch(recMyUpdateContact(status))
                            dispatch(getProfileInfo(personGUID, true))
                        } else {
                            dispatch(recAlumniUpdateContact(status))
                            dispatch(getAlumniInfo(personGUID, "admin"))
                        }
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                console.log(error);
                (by == 'alumni') ? dispatch(failedMyUpdateContact(error)) : dispatch(failedAlumniUpdateContact(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Delete Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}

export function getAddressTypes() {
    return function (dispatch) {
        dispatch(reqaddresstypes())
        fetch(GET_ADDRESS_TYPES, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(types => {
                dispatch(recaddresstypes(types));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_ADDRESS_TYPES}`), { extra: { api: GET_ADDRESS_TYPES, error } });
                console.log(error);
            });
    }
}

function reqaddresstypes() {
    return {
        type: ACTIONTYPES.ADDRESS_TYPES_LOADING
    }
}

function recaddresstypes(types) {
    return {
        type: ACTIONTYPES.ADDRESS_TYPES_LOADED,
        types: types
    }
}

export function AddSuspendFlag(personGUID, value) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(requpdatealumniinfobyadmin())
        fetch(ESB_PERSONS + 'v2/' + personGUID + `/profile`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "ineligibleFlag": value,
                "ineligibleDate": moment().format('YYYY-MM-DD')
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                dispatch(recupdatealumniinfobyadmin(status))
                dispatch(getAlumniInfo(personGUID, "admin"))
                let successmsg = value ? "Profile suspended successfully!" : "Profile activated successfully!"
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: successmsg,
                    onOk() {
                        dispatch(redirectDashboard())
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/profile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/profile`, error } });
                console.log(error);
                dispatch(failedupdatealumniinfobyadmin(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Update Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}

export function AddDeceasedFlag(personGUID, value) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(requpdatealumniinfobyadmin())
        fetch(ESB_PERSONS + 'v2/' + personGUID + `/profile`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "deceasedDate": value ? moment().format('YYYY-MM-DD') : null
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                dispatch(recupdatealumniinfobyadmin(status))
                dispatch(getAlumniInfo(personGUID, "admin"))
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Deceased Flag changed successfully!",
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/profile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/profile`, error } });
                console.log(error);
                dispatch(failedupdatealumniinfobyadmin(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Update Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}

export function deleteEmployerDetails(personGUID, adminViewsAlumniProfile) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqDeleteEmployerDetails())
        fetch(ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 1',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "type": "employer"
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(deletedEmployerDetails())
                adminViewsAlumniProfile ? dispatch(getAlumniInfo(personGUID, "admin")) : dispatch(getProfileInfo(personGUID, true))
                // } else {
                //     dispatch(recupdatealumniinfobyadmin(status))
                //     dispatch(getAlumniInfo(personGUID, "admin"))
                // }
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: `${adminViewsAlumniProfile ? "The alumni's" : 'Your'} employer details removed successfully!`,
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo'}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + '/deleteProfileInfo', error } });
                console.log(error);
            });
    }
}

function reqDeleteEmployerDetails() {
    return {
        type: ACTIONTYPES.DELETING_EMPLOYER_DETAILS
    }
}

export function deletedEmployerDetails() {
    return {
        type: ACTIONTYPES.DELETED_EMPLOYER_DETAILS
    }
}

export function addOrRemoveHobbies(values, personGUID, method, adminViewsAlumniProfile) { //method == add / update / delete
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    
    let options = '', URL = '';
    if (method == 'add') {
        // if (Array.isArray(values) && values.length > 0) {
        //     payload = values.map(eachHobby => ({
        //         "hobby": {
        //             "hobby": eachHobby
        //         }
        //     }))
        // } else {
        URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`;
        options = {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "hobby": {
                    "hobby": values
                }
            })
        }
        // }
    } else if (method == 'update') {
        URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`;
        options = {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "hobby": {
                    "id": values.extendedProfileId ? Number(values.extendedProfileId) : undefined,
                    "hobby": values.attributeVal.toString()
                }
            })
        }
    } else {
        URL = ESB_PERSONS + personGUID + '/alumniSettings/' + values.extendedProfileId;
        options = {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            }
        }
    }

    return function (dispatch) {
        dispatch(reqToAddOrRemoveHobbies())
        fetch(URL, options)
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {

                // if (view == 'alumni') {
                dispatch(updatedHobbies())
                adminViewsAlumniProfile ? dispatch(getAlumniInfo(personGUID, "admin")) : dispatch(getProfileInfo(personGUID, true))
                // } else {
                //     dispatch(recupdatealumniinfobyadmin(status))
                //     dispatch(getAlumniInfo(personGUID, "admin"))
                // }
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: `${adminViewsAlumniProfile ? "The alumni's" : 'Your'} Hobbies and Interests updated successfully!`,
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                console.log(error);
            });
    }
}


function reqToAddOrRemoveHobbies() {
    return {
        type: ACTIONTYPES.ADDING_OR_REMOVING_HOBBIES
    }
}

export function updatedHobbies(status) {
    return {
        type: ACTIONTYPES.HOBBIES_ADDED_OR_REMOVED_SUCCESSFULLY
    }
}

export function updatedBusinessAndEmployerDetails(values, personGUID, toUpdate, toDelete, adminViewsAlumniProfile) { //toUpdate == business/employer
    let profileInfo = '';
    let customSuccessMessage = `${adminViewsAlumniProfile ? "The alumni's" : "Your"} `;

    if (toDelete == 'business') {
        customSuccessMessage += 'Business and Career removed successfully!';
    } else if (toUpdate == 'business') {
        customSuccessMessage += 'Business and Career updated successfully!';
    } else {
        customSuccessMessage += 'Employer Details updated successfully!';
    }

    if (toUpdate == 'business' || toDelete == 'business') {
        profileInfo = {
            "occupation": values
        }
    } else {
        if (values.businessDetails && values.businessDetails.includes('(Other)')) values.businessDetails = values.businessDetails.replace('(Other)', '').trim();
        profileInfo = {
            "employer": values.employerDetails ? values.employerDetails : undefined,
            "occupation": values.businessDetails ? values.businessDetails : undefined
        }
    }
    return function (dispatch) {
        if (toUpdate == 'business') {
            dispatch(reqToUpdateBusiness())
        } else dispatch(reqToUpdateEmployerDetails());
        fetch(ESB_PERSONS + 'v2/' + personGUID + `/profile`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify(profileInfo)
        })

            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {

                // if (view == 'alumni') {
                if (toUpdate == 'business') {
                    dispatch(updatedBusiness())
                } else {
                    dispatch(updatedEmployer())
                }
                adminViewsAlumniProfile ? dispatch(getAlumniInfo(personGUID, "admin")) : dispatch(getProfileInfo(personGUID, true))
                // } else {
                //     dispatch(recupdatealumniinfobyadmin(status))
                //     dispatch(getAlumniInfo(personGUID, "admin"))
                // }

                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: customSuccessMessage,
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/' + personGUID + `/profile`}`), { extra: { api: ESB_PERSONS + 'v2/' + personGUID + `/profile`, error } });
                console.log(error);
            });
    }
}


function reqToUpdateBusiness() {
    return {
        type: ACTIONTYPES.ADDING_OR_REMOVING_BUSINESS
    }
}

export function updatedBusiness() {
    return {
        type: ACTIONTYPES.BUSINESS_ADDED_OR_REMOVED_SUCESSFULLY
    }
}

function reqToUpdateEmployerDetails() {
    return {
        type: ACTIONTYPES.UPDATING_EMPLOYER_DETAILS
    }
}

export function updatedEmployer() {
    return {
        type: ACTIONTYPES.UPDATED_EMPLOYER_DETAILS
    }
}

export function UpdateAlumniInfo(values, personGUID, view) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let ProfileInfo = {}, URL = '';
    if (view == 'alumni') {
        URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`
        ProfileInfo = {
            "firstName": values.firstname && values.firstname.trim() !== "" ? values.firstname.trim() : null,
            "middleName": values.middlename && values.middlename.trim() !== "" ? values.middlename.trim() : null,
            "lastName": values.lastname && values.lastname.trim() !== "" ? values.lastname.trim() : null,
            "prefixId": values.prefix != "" ? parseInt(values.prefix) : null,
            "nameSuffixId": values.suffix != "" ? parseInt(values.suffix) : null,
            "nickName": values.nickname,
            "ethnicity": typeof values.ethnicity == 'object' ? {
                "id": values.ethnicity.extendedProfileId ? values.ethnicity.extendedProfileId : undefined,
                "ethnicBackground": values.ethnicity.short
            } : undefined,
            //"nickName": values.nickname != "" ? values.nickname : values.firstname,
            "certificateName": values.certificatename,
            "dateOfBirth": moment(values.dob).format('YYYY-MM-DD')
        }
    } else {
        URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`
        ProfileInfo = {
            "firstName": values.firstname && values.firstname.trim() !== "" ? values.firstname.trim() : null,
            "middleName": values.middlename && values.middlename.trim() !== "" ? values.middlename.trim() : null,
            "lastName": values.lastname && values.lastname.trim() !== "" ? values.lastname.trim() : null,
            "prefixId": values.prefix ? parseInt(values.prefix) : null,
            "nameSuffixId": values.suffix ? parseInt(values.suffix) : null,
            "nickName": values.nickname,
            "ethnicity": typeof values.ethnicity == 'object' ? {
                "id": values.ethnicity.extendedProfileId ? values.ethnicity.extendedProfileId : undefined,
                "ethnicBackground": values.ethnicity.short
            } : undefined,
            //"nickName": values.nickname != "" ? values.nickname : values.firstname,
            "certificateName": values.certificatename,
            "dateOfBirth": moment(values.dob).format('YYYY-MM-DD')
        }
    }
    return function (dispatch) {
        (view == 'alumni') ? dispatch(requpdatealumniinfo()) : dispatch(requpdatealumniinfobyadmin())
        fetch(URL, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify(ProfileInfo)
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {

                if (view == 'alumni') {
                    dispatch(recupdatealumniinfo(status))
                    dispatch(getProfileInfo(personGUID, true))
                } else {
                    dispatch(recupdatealumniinfobyadmin(status))
                    dispatch(getAlumniInfo(personGUID, "admin"))
                }
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Alumni Information Updated successfully!",
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                console.log(error);
                (view == 'alumni') ? dispatch(failedupdatealumniinfo(error)) : dispatch(failedupdatealumniinfobyadmin(error))
                Modal.error({
                    className: "ErrorModal",
                    title: `${error.errorCode || ""} ${error.message || "Update Failed"}`,
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });
    }
}

function requpdatealumniinfobyadmin() {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATING_BY_ADMIN
    }
}

function recupdatealumniinfobyadmin(status) {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATED_BY_ADMIN,
        status: status
    }
}

function failedupdatealumniinfobyadmin(error) {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATE_FAILED_BY_ADMIN,
        error: error
    }
}

function requpdatealumniinfo() {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATING
    }
}

function recupdatealumniinfo(status) {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATED,
        status: status
    }
}

function failedupdatealumniinfo(error) {
    return {
        type: ACTIONTYPES.ALUMNI_INFORMATION_UPDATE_FAILED,
        error: error
    }
}


export function UpdateAdditionalInfo(id, values) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = loggedinUser.personGuid;
    let method = '', ethnic_url = ''
    if (id) {
        method = 'PUT'
        ethnic_url = ESB_PERSONS + personGUID + `/profile/` + id + `/extendedProfile`
    } else {
        method = 'POST'
        ethnic_url = ESB_PERSONS + personGUID + `/profile/extendedProfile`
    }
    return function (dispatch) {
        dispatch(reqadditionalinfo())
        fetch(ethnic_url, {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "extendedProfile": {
                    "attributeId": "1",
                    "attribute": values.ethnic
                }
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                const loggedinUser = JSON.parse(localStorage.getItem('user'))
                let personGUID = loggedinUser.personGuid;
                dispatch(getProfileInfo(personGUID, true))
                dispatch(recadditionalinfo(status));
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Alumni Information Updated successfully!",
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ethnic_url}`), { extra: { api: ethnic_url, error } });
                console.log(error);
            });
    }
}

function reqadditionalinfo() {
    return {
        type: ACTIONTYPES.ADDITIONAL_INFORMATION_UPDATING
    }
}

function recadditionalinfo(status) {
    return {
        type: ACTIONTYPES.ADDITIONAL_INFORMATION_UPDATED,
        status: status
    }
}

function reqMyUpdatecontact() {
    return {
        type: ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATING
    }
}

function recMyUpdateContact(status) {
    return {
        type: ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATED,
        status: status
    }
}

function failedMyUpdateContact(error) {
    return {
        type: ACTIONTYPES.MY_CONTACT_INFORMATION_UPDATE_FAILED,
        error: error
    }
}


function reqAlumniUpdatecontact() {
    return {
        type: ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATING
    }
}

function recAlumniUpdateContact(status) {
    return {
        type: ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATED,
        status: status
    }
}

function failedAlumniUpdateContact(error) {
    return {
        type: ACTIONTYPES.ALUMNI_CONTACT_INFORMATION_UPDATE_FAILED,
        error: error
    }
}

export const UpdateSocialMeidaLinks = (personGUID, types, values, by) => {
    let webcontactslength = values.webcontactskeys.length
    let showmsg = false

    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return async dispatch => {
        dispatch(requpdateWebContacts())
        let body = []
        URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`
        let method = 'PUT'
        values.webcontactskeys.map(keys => {
            body.push({
                "id": values.webcontactID[keys] ? values.webcontactID[keys] : undefined,
                "typeId": types[keys] ? types[keys] : undefined,
                "address": values.SocialMediaValues[keys] ? values.SocialMediaValues[keys] : undefined,
            })
        })
        // for (let i = 0; i < webcontactslength; i++) {
        //     let webcontactID = values.webcontactID[i]
        //     let type = types[i]
        //     let address = values.SocialMediaValues[i]
        //     URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`
        //     let method = 'PUT'

        //     // if (webcontactID == '') {
        //         // URL = ESB_PERSONS + '/persons/v2/' + personGUID + `/profile`
        //         // method = 'PUT'
        //     // } else {
        //     //     URL = ESB_PERSONS + '/persons/v2/' + personGUID + `/profile`
        //     //     method = 'PUT'
        //     // }
        //     // await UpdateWebContact(URL, method, type, address, webcontactID)
        //     // if ((i + 1) == webcontactslength) {
        //     //     setTimeout(() => {
        //     //         Modal.success({
        //     //             className: "ErrorModal",
        //     //             title: 'Success',
        //     //             content: "Web contacts updated successfully!",
        //     //             onOk() {
        //     //                 dispatch(recupdateWebContactsStatus("updated"))
        //     //                 window.location.reload();
        //     //                 dispatch(getProfileInfo(personGUID, true))
        //     //             }
        //     //         });
        //     //     }, 5000);
        //     // }
        // }

        try {
            fetch(URL, {
                method: method,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    "Authorization": "Bearer " + token,
                },
                body: JSON.stringify({ "webContacts": body })
            })
                .then(response => {
                    if (!response.ok) {
                        return Promise.reject(response.statusText);
                    }
                    return response.json();
                })
                .then(status => {
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: `Web contacts updated successfully! 
                        Your added social media information can be accessed from your profile banner`,
                        onOk() {
                            dispatch(recupdateWebContactsStatus("updated"))
                            // window.location.reload();
                            dispatch(getProfileInfo(personGUID, true))
                        }
                    });
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                    console.log(error);
                    Modal.error({
                        className: "ErrorModal",
                        title: 'Failed',
                        content: error,
                    })
                });
        }
        catch (error) {
            console.log(error);
            Modal.error({
                className: "ErrorModal",
                title: 'Failed',
                content: error,
            })
        }
    }
}

const UpdateWebContact = (URL, method, type, address, webcontactID) => {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    try {
        const APIContactResponse = fetch(URL, {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                "webContacts": [{
                    "id": webcontactID ? webcontactID : undefined,
                    "typeId": type,
                    "address": address
                }]
            })
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                return status
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                console.log(error);
            });
    }
    catch (error) {
        console.log(error);
    }
}

function requpdateWebContacts() {
    return {
        type: ACTIONTYPES.WEB_CONTACT_INFORMATION_UPDATING
    }
}

function recupdateWebContactsStatus(status) {
    return {
        type: ACTIONTYPES.WEB_CONTACT_INFORMATION_UPDATED,
        status: status
    }
}


export function showContactMsg(personGUID, by) {
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdatecontact()) : dispatch(reqAlumniUpdatecontact())
        setTimeout(() => {
            if (by == 'alumni') {
                dispatch(recMyUpdateContact('success'))
                dispatch(getProfileInfo(personGUID, true))
            } else {
                dispatch(recAlumniUpdateContact('success'))
                dispatch(getAlumniInfo(personGUID, "admin"))
            }
            Modal.success({
                className: "ErrorModal",
                title: 'Success',
                content: "Contact Information Updated successfully!",
            });
        }, 10000);
    }
}


export function updateMyEmail(personGUID, emailid, values, typeId, by, isUndeliverable) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let method = 'PUT', data = {}
    let update_email_url = ESB_PERSONS + 'v2/' + personGUID + `/profile`
    data = {
        "emails": {
            'id': Number(emailid),
            "typeId": Number(typeId) || undefined,
            "email": values.email,
            "isPrimary": true,
            "isUndeliverable": isUndeliverable
        }
    }
    if (typeId == "0") {
        // method = 'PUT' //'POST'
        typeId = "1"
        // update_email_url = ESB_PERSONS + 'v2/' + personGUID + `/profile` //ESB_PERSONS + personGUID + `/profile/emails`
        data = {
            "emails": {
                "typeId": Number(typeId) || undefined,
                "email": values.email,
                "isPrimary": true
            }
        }
    }
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdatecontact()) : dispatch(reqAlumniUpdatecontact())
        fetch(update_email_url, {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                setTimeout(() => {
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: "Contact Information Updated successfully!",
                        onOk() {
                            if (by == 'alumni') {
                                dispatch(recMyUpdateContact(status))
                                dispatch(getProfileInfo(personGUID, true))
                            } else {
                                dispatch(recAlumniUpdateContact(status))
                                dispatch(getAlumniInfo(personGUID, "admin"))
                            }

                        }
                    });
                }, 10000);
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${update_email_url}`), { extra: { api: update_email_url, error } });
                console.log(error);
            });

    }
}

// export const updateProfileEmail = async (personGUID, PrimarySelected, currentPrimary, values, by) => {
//     let Emaillength = values.emailkeys.length
//     let showmsg = false, isPrimary = false, primaryIndex = 0
//     for (let i = 0; i < Emaillength; i++) {

//         //UPDATE CURRENT PRIMARY
//         if (PrimarySelected == i) {
//             let EmailId = values.primaryEmail[i]
//             let EmailTypeId = values.emailtype[i]
//             let Email = values.email[i]
//             isPrimary = true
//             primaryIndex = i
//             let URL = '', method = ''
//             if (EmailId == '') {
//                 URL = ESB_PERSONS + personGUID + `/profile/emails`
//                 method = 'POST'
//                 //isPrimary = 'False'
//             } else {
//                 URL = ESB_PERSONS + personGUID + `/profile/` + EmailId + `/emails`
//                 method = 'PUT'
//             }

//             await updateEmail(URL, method, EmailTypeId, Email, isPrimary, by)

//         }
//     }

//     for (let j = 0; j < Emaillength; j++) {
//         if (j != primaryIndex) {
//             let EmailId = values.primaryEmail[j]
//             let EmailTypeId = values.emailtype[j]
//             let Email = values.email[j]
//             let URL = '', method = ''
//             if (EmailId == '') {
//                 URL = ESB_PERSONS + personGUID + `/profile/emails`
//                 method = 'POST'
//                 //isPrimary = 'False'
//             } else {
//                 URL = ESB_PERSONS + personGUID + `/profile/` + EmailId + `/emails`
//                 method = 'PUT'
//             }
//             await updateEmail(URL, method, EmailTypeId, Email, false, by)
//         }
//     }
// }

const updateEmail = async (URL, method, emailInfo, by) => {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;

    const APIResponse = await fetch(URL, {
        method: method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": "Bearer " + token,
        },
        body: JSON.stringify({
            "emails": emailInfo
        })
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(status => {
            return status
        })
        .catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
            console.log(error);
        });



}

export const updateProfilePhone = async (personGUID, PrimarySelected, currentPrimary, PrimarySelectedEmail, currentPrimaryEmail, values, by, updatedPhoneKeys, updatedEmailKeys) => {
    let Phonelength = values.phonekeys.length
    let showmsg = false, isPrimaryPhone = false, primaryPhoneIndex = 0;
    const updatePhoneInfo = [], createPhoneInfo = [], updateEmailInfo = [], createEmailInfo = [];

    let URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`
    let method = 'PUT'
    for (let i = 0; i < Phonelength; i++) {

        //UPDATE CURRENT PRIMARY
        if (PrimarySelected == i) {
            let phoneInfo = {}
            isPrimaryPhone = true
            primaryPhoneIndex = i;
            let phoneid = Number(values.primary[i]);
            let phone = values.phone[i];

            if (phoneid) {
                phoneInfo.id = phoneid ? phoneid : ''
            }
            phoneInfo.typeId = Number(values.phoneTypeID[i])
            phoneInfo.phoneCountryId = Number(values.phonecountryID[i])
            phoneInfo.phone = phone
            phoneInfo.areaCode = phone.slice(0, 3)
            phoneInfo.prefix = phone.slice(3, 6)
            phoneInfo.lineNumber = phone.slice(6, 10)
            phoneInfo.isPrimary = true,
                phoneInfo.extension = ""

            if (Number(values.phonecountryID[i]) != 636) {
                phoneInfo.areaCode = ""
                phoneInfo.prefix = ""
                phoneInfo.lineNumber = values.phone[i]
            }
            if (phoneid == '') {
                createPhoneInfo.push(phoneInfo)
            }
            else {
                updatePhoneInfo.push(phoneInfo);
            }
        }
    }
    if (updatedPhoneKeys.length > 0) {
        updatedPhoneKeys.map(each => {
            if (primaryPhoneIndex != each) {
                let phoneInfo = {}
                let phoneid = Number(values.primary[each]);
                let phone = values.phone[each];
                if (phoneid) {
                    phoneInfo.id = phoneid ? phoneid : ''
                }

                phoneInfo.typeId = Number(values.phoneTypeID[each])
                phoneInfo.phoneCountryId = Number(values.phonecountryID[each])
                phoneInfo.phone = phone
                phoneInfo.areaCode = phone.slice(0, 3)
                phoneInfo.prefix = phone.slice(3, 6)
                phoneInfo.lineNumber = phone.slice(6, 10),
                    phoneInfo.isPrimary = false,
                    phoneInfo.extension = ""

                if (Number(values.phonecountryID[each]) != 636) {
                    phoneInfo.areaCode = ""
                    phoneInfo.prefix = ""
                    phoneInfo.lineNumber = phone
                }
                if (phoneid == '') {
                    createPhoneInfo.push(phoneInfo)
                    // isPrimary = 'False'
                }
                else {
                    updatePhoneInfo.push(phoneInfo);
                }
            }

        })
    }
    if (createPhoneInfo.length != 0) {
        UpdatePhone(URL, method, createPhoneInfo, by)
    }
    if (updatePhoneInfo.length != 0) {
        UpdatePhone(URL, method, updatePhoneInfo, by)
    }


    let Emaillength = values.emailkeys.length
    // let showmsg = false,
    let isPrimaryEmail = false, primaryEmailIndex = 0
    for (let i = 0; i < Emaillength; i++) {

        //UPDATE CURRENT PRIMARY
        if (PrimarySelectedEmail == i) {
            let emailInfo = {};
            primaryEmailIndex = i;
            let EmailId = values.primaryEmail[i]

            if (EmailId) {
                emailInfo.id = EmailId ? Number(EmailId) : ''
            }
            emailInfo.typeId = Number(values.emailtype[i])
            emailInfo.email = values.email[i]
            emailInfo.isPrimary = true

            if (EmailId == '') {
                createEmailInfo.push(emailInfo)
            } else {
                updateEmailInfo.push(emailInfo)
            }
        }
    }

    if (updatedEmailKeys.length > 0) {
        updatedEmailKeys.map(each => {
            if (primaryEmailIndex != each) {
                let emailInfo = {};
                let EmailId = values.primaryEmail[each];

                if (EmailId) {
                    emailInfo.id = EmailId ? Number(EmailId) : ''
                }
                emailInfo.typeId = Number(values.emailtype[each])
                emailInfo.email = values.email[each]
                emailInfo.isPrimary = false

                if (EmailId == '') {
                    createEmailInfo.push(emailInfo)
                } else {
                    updateEmailInfo.push(emailInfo)
                }

            }
        })
    }
    if (createEmailInfo.length != 0) {
        updateEmail(URL, method, createEmailInfo, by)
    }
    if (updateEmailInfo.length != 0) {
        updateEmail(URL, method, updateEmailInfo, by)
    }

}


const UpdatePhone = async (URL, method, PhoneInfo, by) => {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;


    const APIResponse = await fetch(URL, {
        method: method,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization": "Bearer " + token,
        },
        body: JSON.stringify(
            {
                "phones": PhoneInfo
            }
        )
    })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(status => {

            return status

        })
        .catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
            console.log(error);
        });
}

export function updateMyAddress(personGUID, addressid, values, stateId, typeId, isPrimary, by) {
    if (typeof isPrimary === 'string') {
        isPrimary = isPrimary.toLowerCase() == "false" ? false : true
    }
    if (values.addressline3 && values.addressline3.indexOf(',') > -1) {
        values.addressline3 = values.addressline3.replaceAll(',', ' ')
    }

    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let URL = ESB_PERSONS + 'v2/' + personGUID + `/profile`;
    let method = 'PUT'
    let addresses;


    if (addressid == '') {
        isPrimary = false
        addresses = [{
            "typeId": Number(typeId),
            "addressLine1": values.addressline1 ? values.addressline1 : "",
            "addressLine2": values.addressline2 ? values.addressline2 : "",
            "addressLine3": values.addressline3 ? values.addressline3 : "",
            "city": values.city ? values.city : "",
            "zip": values.zipcode ? values.zipcode : "",
            "stateId": stateId ? Number(stateId) : null,
            "countryId": values.country ? Number(values.country) : "",
            "isPrimary": isPrimary
        }]
    } else {

        addresses = [{
            'id': Number(addressid),
            "typeId": Number(typeId),
            "addressLine1": values.addressline1 ? values.addressline1 : "",
            "addressLine2": values.addressline2 ? values.addressline2 : "",
            "addressLine3": values.addressline3 ? values.addressline3 : "",
            "city": values.city ? values.city : "",
            "zip": values.zipcode ? values.zipcode : "",
            "stateId": stateId ? Number(stateId) : null,
            "countryId": values.country ? Number(values.country) : "",
            "isPrimary": isPrimary
        }]
    }
    return function (dispatch) {
        (by == 'alumni') ? dispatch(reqMyUpdateAdd()) : dispatch(reqAlumniUpdateAdd())
        fetch(URL, {
            method: method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                addresses
            })
        })
            .then(async response => {
                if (!response.ok) {
                    const errorData = await response.json().catch(() => null);
                    return Promise.reject(errorData || { message: response.statusText });
                }
                return response.json();
            })
            .then(status => {
                if (by == 'alumni') {
                    // const loggedinUser = JSON.parse(localStorage.getItem('user'))
                    // let personGUID = loggedinUser.personGuid;
                    dispatch(getProfileInfo(personGUID, true))
                    dispatch(recMyUpdatedAdd(status))
                } else {
                    dispatch(getAlumniInfo(personGUID, "admin"))
                    dispatch(recAlumniUpdatedAdd(status))
                }
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Address Updated successfully!",
                    onOk() {
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${URL}`), { extra: { api: URL, error } });
                console.log(error);
                (by == 'alumni') ? dispatch(failedMyUpdateAdd(error)) : dispatch(failedAlumniUpdateAdd(error))
                Modal.error({
                    className: "ErrorModal",
                    title: error.message || 'Update Failed',
                    content: error.errorDesc || "Something went wrong. Please try again later."
                });
            });

    }
}

function reqMyUpdateAdd() {
    return {
        type: ACTIONTYPES.MY_ADDRESS_UPDATING
    }
}

function recMyUpdatedAdd(status) {
    return {
        type: ACTIONTYPES.MY_ADDRESS_UPDATED,
        status: status
    }
}

function failedMyUpdateAdd(error) {
    return {
        type: ACTIONTYPES.MY_ADDRESS_UPDATE_FAILED,
        error: error
    }
}


function reqAlumniUpdateAdd() {
    return {
        type: ACTIONTYPES.ALUMNI_ADDRESS_UPDATING
    }
}

function recAlumniUpdatedAdd(status) {
    return {
        type: ACTIONTYPES.ALUMNI_ADDRESS_UPDATED,
        status: status
    }
}

function failedAlumniUpdateAdd(error) {
    return {
        type: ACTIONTYPES.ALUMNI_ADDRESS_UPDATE_FAILED,
        error: error
    }
}


export function getCommunicationTypes() {
    return function (dispatch) {
        dispatch(reqcommunicationtypes())
        fetch(GET_COMMUNICATION_TYPES, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(types => {
                dispatch(reccommunicationtypes(types));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_COMMUNICATION_TYPES}`), { extra: { api: GET_COMMUNICATION_TYPES, error } });
                console.log(error);
            });
    }
}

function reqcommunicationtypes() {
    return {
        type: ACTIONTYPES.COMMUNICATION_TYPES_LOADING
    }
}

function reccommunicationtypes(types) {
    return {
        type: ACTIONTYPES.COMMUNICATION_TYPES_LOADED,
        types: types
    }
}


export function getHomeAddress(value) {
    return function (dispatch) {
        dispatch(reqHomeAddress())
        fetch(MELISSA_ADDRESS + value + '&id=116097596&format=json&maxrecords=8', {
            method: 'GET',
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(address => {
                dispatch(recHomeAddress(address));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${MELISSA_ADDRESS + value + '&id=116097596&format=json&maxrecords=8'}`), { extra: { api: MELISSA_ADDRESS + value + '&id=116097596&format=json&maxrecords=8', error } });
                console.log(error);
            });
    }
}

function reqHomeAddress() {
    return {
        type: ACTIONTYPES.HOME_ADDRESS_LOADING
    }
}

function recHomeAddress(address) {
    return {
        type: ACTIONTYPES.HOME_ADDRESS_RECEIVED,
        address: address
    }
}

export function getGender() {
    return function (dispatch) {
        dispatch(reqGender())
        fetch(GET_GENDER, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(genders => {
                dispatch(recGender(genders));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_GENDER}`), { extra: { api: GET_GENDER, error } });
                console.log(error);
            });
    }
}

function reqGender() {
    return {
        type: ACTIONTYPES.GENDERS_LOADING
    }
}

function recGender(genders) {
    return {
        type: ACTIONTYPES.GENDERS_RECEIVED,
        genders: genders
    }
}


export function getPrefix() {
    return function (dispatch) {
        dispatch(reqprefix())
        fetch(GET_PREFIX, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(prefixes => {
                dispatch(recprefix(prefixes));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_PREFIX}`), { extra: { api: GET_PREFIX, error } });
                console.log(error);
            });
    }
}

function reqprefix() {
    return {
        type: ACTIONTYPES.PREFIX_LOADING
    }
}

function recprefix(prefixes) {
    return {
        type: ACTIONTYPES.PREFIX_RECEIVED,
        prefixes: prefixes
    }
}


export function getSuffix() {
    return function (dispatch) {
        dispatch(reqsuffix())
        fetch(GET_SUFFIX, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(suffixes => {
                dispatch(recsuffix(suffixes));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GET_SUFFIX}`), { extra: { api: GET_SUFFIX, error } });
                console.log(error);
            });
    }
}

function reqsuffix() {
    return {
        type: ACTIONTYPES.SUFFIX_LOADING
    }
}

function recsuffix(suffixes) {
    return {
        type: ACTIONTYPES.SUFFIX_RECEIVED,
        suffixes: suffixes
    }
}




function fetchComPrefer(personGUID) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return fetch(ESB_PERSONS + personGUID + `/subscriptions`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        },
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    })
}

const memoizedComPrefer = memoize(
    (personGUID) => fetchComPrefer(personGUID),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentPersonGuid] = lastArgs;
        const [newPersonGuid, refresh] = newArgs;
        return !refresh && currentPersonGuid === newPersonGuid;
    });

//get profile info (Dashboard)
export function getComPrefer(personGUID, refresh = false) {
    return function (dispatch) {
        dispatch(reqComPrefer())
        memoizedComPrefer(personGUID, refresh)
            .then(communication => {
                dispatch(recComPrefer(communication))
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + `/subscriptions`}`), { extra: { api: ESB_PERSONS + personGUID + `/subscriptions`, error } });
                if (error == "Forbidden") {
                    dispatch(sessionTimeOut())
                }
                else {
                    notification.open({
                        message: error.errorCode ? error.errorCode : "Error",
                        description: error.errorDesc ? error.errorDesc : 'Please try again later...',
                        icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                    });
                }
                console.log(error);
            });
    }
}


function reqComPrefer() {
    return {
        type: ACTIONTYPES.LOADING_COM_PREFER
    }
}

function recComPrefer(communication) {
    return {
        type: ACTIONTYPES.COM_PREFER,
        communication: communication
    }
}

export function updateComPrefer(communication, communicationid) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let token = loggedinUser.token;
    let url = '', method = '', data = {}
    if (communicationid == 0) {
        url = ESB_PERSONS + personGUID + `/subscriptions`
        method = 'POST'
        data = {
            "topicId": 3,
            "optOutFlag": communication,
            "effectiveDt": today,
        }
    } else {
        url = ESB_PERSONS + personGUID + `/subscriptions/` + communicationid
        method = 'PUT'
        data = {
            "topicId": 3,
            "optOutFlag": communication,
            "effectiveDt": today,
        }
    }
    return function (dispatch) {
        fetch(url, {
            method: method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    if (response.status == 422) {
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: 'Please try again...',
                        });
                    }
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(status => {
                dispatch(getComPrefer(personGUID, true))
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "Communication Preference Updated!",
                    onOk() {

                    }
                });
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${url}`), { extra: { api: url, error } });
                console.log(error);
            });
    }
}


export function expiryMembership(registrationId, personPositionId, alumniPersonGUID, Reason, calculatedExpireDate, getSubsequentMembership) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let personGUID = loggedinUser.personGuid;
    let expireDate = calculatedExpireDate ? calculatedExpireDate : today;
    return function (dispatch) {
        dispatch(reqexpiryMembership())
        // fetch(`${ESB_URL}/persons/${alumniPersonGUID}/positions`, {
        //     method: 'GET',
        //     credentials: 'include',
        //     headers: {
        //         "Content-Type": "application/json",
        //         "authorization": "Bearer " + token
        //     }
        // }) 
        //     .then(response => {
        //         if (!response.ok) {
        //             return Promise.reject(response.statusText);
        //         }
        //         return response.json();
        //     })
        //     .then(result => {
        //         try {
        //             let getNESAposition = result.find(item => item.PositionLong == "National Eagle Scout Association")
        //             let positions = result;

        //             // Find which registration has been passed
        //             let selectedRegistration = registrations.filter(reg => reg.registrationId ==  registrationId);
        //             let registrationEffectiveDate = selectedRegistration[0].effectiveDate ? moment(selectedRegistration[0].effectiveDate).format('MM/DD/YYYY') : ''
        //             let registrationExpireDate = selectedRegistration[0].expireDate ? moment(selectedRegistration[0].expireDate).format('MM/DD/YYYY') : ''
        //             let selectedPositionId;

        //             // check which position item matches the selected registration
        //             if(selectedRegistration) {
        //                 for (let i=0; i<=positions.length; i++) {

        //                     let positionEffectiveDate = positions[i].EffectiveDt ? moment(positions[i].EffectiveDt).format('MM/DD/YYYY') : ''
        //                     let positionExpireDate = positions[i].ExpiryDt ? moment(positions[i].ExpiryDt).format('MM/DD/YYYY') : ''

        //                     // Checking if PKPersonPositionId belongs to registrationId
        //                     if (registrationEffectiveDate == positionEffectiveDate &&  registrationExpireDate == positionExpireDate) {
        //                         selectedPositionId = positions[i].PKPersonPositionId;
        //                         break
        //                     }
        //                 }
        //             }

        //             if (selectedPositionId) {
        fetch(`${ESB_URL}/registrations/v2/${alumniPersonGUID}/expireRegistration`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "personPositionId": Number(personPositionId),
                "registrationId": Number(registrationId),
                "expireDate": expireDate,
                "reason": Reason
            })
        })
            .then(async response => {
                const data = await response.json().catch(() => null);

                if (!response.ok) {
                    return Promise.reject(data || response.statusText);
                }

                return data;
            })
            .then(status => {
                const handleSubsequentMemberships = async () => {
                    try {
                        const fetchPromises = getSubsequentMembership.map(eachMembership => {
                            const { susequantMembershipRegID, calculatedEffectiveDate, calculatedExpireDate } = eachMembership;
                            return fetch(`${ESB_PERSONS}${alumniPersonGUID}/membershipRegistrations/${susequantMembershipRegID}`, {
                                method: 'PUT',
                                credentials: 'include',
                                headers: {
                                    "Content-Type": "application/json",
                                    "authorization": "Bearer " + token
                                },
                                body: JSON.stringify({
                                    "effectiveDt": calculatedEffectiveDate,
                                    "expiryDt": calculatedExpireDate ? calculatedExpireDate : undefined,
                                })
                            }).then(async response => {
                                if (!response.ok) {
                                    const data = await response.json().catch(() => null);
                                    throw new Error((data && (data.errorDesc || data.message)) || response.statusText);
                                }
                                return response.json();
                            });
                        });

                        // Wait for all fetch requests to complete
                        await Promise.all(fetchPromises);

                        // Dispatch actions after all requests are successful
                        dispatch(recexpiryMembership());
                        dispatch(getNESARegistrations(alumniPersonGUID));

                        // Show success popup
                        Modal.success({
                            className: "SuccessModal",
                            title: 'Success',
                            content: 'NESA Membership Expired Successfully!',
                            onOk() { }
                        });
                    } catch (error) {
                        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}${alumniPersonGUID}/membershipRegistrations/{registrationId}`}`), { extra: { api: `${ESB_PERSONS}${alumniPersonGUID}/membershipRegistrations/{registrationId}`, error } });
                        // Show error popup if any of the requests fail
                        Modal.error({
                            className: "ErrorModal",
                            title: 'Error',
                            content: `An error occurred: ${error.message}`,
                            onOk() { }
                        });
                    }
                };

                // try {
                if (getSubsequentMembership.length > 0) {
                    handleSubsequentMemberships();
                } else {
                    dispatch(recexpiryMembership());
                    dispatch(getNESARegistrations(alumniPersonGUID));
                    Modal.success({
                        className: "ErrorModal",
                        title: 'Success',
                        content: 'NESA Membership Expired Successfully!',
                        onOk() { }
                    });
                }
                // } catch (error) {
                //     dispatch(recexpiryMembership());
                //     console.log(error);
                //     Modal.error({
                //         className: "ErrorModal",
                //         title: 'Failed',
                //         content: 'Failed to expire the NESA Membership!',
                //         onOk() { }
                //     });
                // }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_URL}/registrations/v2/${alumniPersonGUID}/expireRegistration`}`), { extra: { api: `${ESB_URL}/registrations/v2/${alumniPersonGUID}/expireRegistration`, error } });
                dispatch(recexpiryMembership());
                console.log(error);

                var content = 'Failed to expire the NESA Membership!';

                if (error && error.errorDesc) {
                    content = error.errorDesc;
                } else if (error && error.message) {
                    content = error.message;
                }

                Modal.error({
                    className: "ErrorModal",
                    title: 'Failed',
                    content: content,
                    onOk() { }
                });
            });
        //     } else {
        //         throw new Error('Can\'t get personPositionId')
        //     }
        // } catch (error) {
        //     dispatch(recexpiryMembership())
        //     console.log(error);
        //     Modal.error({
        //         className: "ErrorModal",
        //         title: 'Failed',
        //         content: error,
        //         onOk() {
        //         }
        //     });
        // }

        // })

    }
}


export function alumniBulkUpload(data, gifterEmail) {
    return function (dispatch) {
        dispatch(reqAlumniBulkupload())

        Sentry.captureMessage("bulkNESA Payload: file uploaded", {
            level: "info",
            extra: { fileInfo: data && data.name ? data.name : "file" }
        });

        fetch(NESA_BULK, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "authorization": "Bearer " + token,
            },
            body: data
        })
            .then(function (response) {
                if (!response.ok) {
                    if (response.status == 400 || response.status == 422) {
                        return response.json().then(function (error) {
                            Sentry.captureException(new Error("bulkNESA Error: " + (error.message || "Invalid Request")), {
                                extra: { error: error }
                            });

                            Modal.error({
                                className: "ErrorModal",
                                title: error.message || 'Invalid Request',
                                content: error.errorDesc || '',
                            });
                            return Promise.reject(response.statusText);
                        });
                    } else {
                        Sentry.captureException(new Error("bulkNESA HTTP Error: " + response.status), {
                            extra: { status: response.status }
                        });
                        return Promise.reject(response.statusText);
                    }
                }
                return response.json();
            })
            .then(status => {
                Sentry.captureEvent({
                    message: "bulkNESA Response",
                    level: "info",
                    extra: {
                        response: JSON.stringify(status, null, 2)
                    }
                });

                BULK_Membership = status
                dispatch(recAlumniBulkUpload(status))
                dispatch(InitOrbitalPayments(
                    status.totalAmountdue,
                    "BULK NESA",
                    NESA_MID,
                    status,
                    gifterEmail,
                    ''
                ))
            })
            .catch(error => {
                Sentry.captureException(error, {
                    extra: { context: "alumniBulkUpload Error" }
                });

                console.log('error', error);
                dispatch(failedAlumniBulkUpload())
            });
    }

}

function reqAlumniBulkupload() {
    return {
        type: ACTIONTYPES.ALUMNI_BULK_UPLOADING
    }
}

function recAlumniBulkUpload(recBulkUpload) {
    return {
        type: ACTIONTYPES.ALUMNI_BULK_UPLOADED,
        res: recBulkUpload
    }

}
function failedAlumniBulkUpload() {
    return {
        type: ACTIONTYPES.ALUMNI_BULK_UPLOAD_ERROR,
    }

}

const recexpiryMembership = () => {
    return {
        type: ACTIONTYPES.RES_OF_EXPIRE_MEMBERSHIP
    }
}
const reqexpiryMembership = () => {
    return {
        type: ACTIONTYPES.REQ_TO_EXPIRE_MEMBERSHIP
    }
}

export function adminBulkUpload(data) {
    return function (dispatch) {
        dispatch(reqBulkupload())

        Sentry.captureMessage("bulkNESA Payload: file uploaded", {
            level: "info",
            extra: { fileInfo: data && data.name ? data.name : "file" }
        });

        fetch(NESA_BULK, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "authorization": "Bearer " + token,
            },
            body: data
        })
            .then(function (response) {
                if (!response.ok) {
                    if (response.status == 400) {
                        return response.json().then(function (error) {
                            Sentry.captureException(new Error("bulkNESA Error: " + (error.message || "Invalid Request")), {
                                extra: { error: error }
                            });

                            Modal.error({
                                className: "ErrorModal",
                                title: error.message || 'Invalid Request',
                                content: error.errorDesc || '',
                            });
                            return Promise.reject(response.statusText);
                        });
                    } else {
                        Sentry.captureException(new Error("bulkNESA HTTP Error: " + response.status), {
                            extra: { status: response.status }
                        });
                        return Promise.reject(response.statusText);
                    }
                }
                return response.json();
            })
            .then(status => {
                Sentry.captureEvent({
                    message: "bulkNESA Response",
                    level: "info",
                    extra: {
                        response: JSON.stringify(status, null, 2)
                    }
                });

                dispatch(recBulkUpload(status))
                Modal.success({
                    className: "ErrorModal",
                    title: 'Success',
                    content: "File Uploaded Successfully!",
                    onOk() {
                    }
                });
            })
            .catch(error => {
                Sentry.captureException(error, {
                    extra: { context: "bulkNESA Error"}
                });

                console.log(error);
            });
    }

}

function reqBulkupload() {
    return {
        type: ACTIONTYPES.BULK_UPLOADING
    }
}

function recBulkUpload(recBulkUpload) {
    return {
        type: ACTIONTYPES.BULK_UPLOADED,
        res: recBulkUpload
    }
}


export function getAlumniAndLocalAwards() {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return function (dispatch) {
        dispatch(requestToGetAlumniAndLocalAwards());
        fetch(`${ESB_PERSONS}v2/alumniAwards`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username
            })
        }).then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
            .then(awards => {
                dispatch(receivedAlumniAndLocalAwards(awards));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/alumniAwards`}`), { extra: { api: `${ESB_PERSONS}v2/alumniAwards`, error } });
                dispatch(failedToGetAlumniAndLocalAwards())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetAlumniAndLocalAwards() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_ALUMNI_AND_LOCAL_AWARDS,
    }
}
function receivedAlumniAndLocalAwards(awards) {
    return {
        type: ACTIONTYPES.RECEIVED_ALUMNI_AND_LOCAL_AWARDS,
        awards
    }
}
function failedToGetAlumniAndLocalAwards() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_ALUMNI_AND_LOCAL_AWARDS,
    }
}

export function GetRanksByUserName() {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return function (dispatch) {
        dispatch(requestToGetRanksByUserName());
        fetch(`${ESB_PERSONS}v2/alumniRanks`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username
            })
        }).then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
            .then(alumniRanks => {
                dispatch(receivedRanksByUserName(alumniRanks));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/alumniRanks`}`), { extra: { api: `${ESB_PERSONS}v2/alumniRanks`, error } });
                dispatch(failedToGetRanksByUserName())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetRanksByUserName() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_RANKS_BY_USERNAME,
    }
}

function receivedRanksByUserName(alumniRanks) {
    return {
        type: ACTIONTYPES.RECEIVED_RANKS_BY_USERNAME,
        alumniRanks
    }
}
function failedToGetRanksByUserName() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_RANKS_BY_USERNAME,
    }
}

export function getScoutingAffiliations() {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return function (dispatch) {
        dispatch(requestToGetScoutingAffiliations());
        fetch(`${ESB_PERSONS}v2/alumniScoutingAssociations`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username
            })
        }).then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
            .then(scoutingAffiliations => {
                dispatch(receivedScoutingAffiliations(scoutingAffiliations));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/alumniScoutingAssociations`}`), { extra: { api: `${ESB_PERSONS}v2/alumniScoutingAssociations`, error } });
                dispatch(failedToGetScoutingAffiliations())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetScoutingAffiliations() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_SCOUTINGS_AFFILIATIONS,
    }
}
function receivedScoutingAffiliations(scoutingAffiliations) {
    return {
        type: ACTIONTYPES.RECEIVED_SCOUTINGS_AFFILIATIONS,
        scoutingAffiliations
    }
}
function failedToGetScoutingAffiliations() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_SCOUTINGS_AFFILIATIONS,
    }
}

export function getCouncilAffiliations() {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return function (dispatch) {
        dispatch(requestToGetCouncilAffiliations());
        fetch(`${ESB_PERSONS}v2/alumniCouncilAffiliations`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username
            })
        }).then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
            .then(councilAffiliations => {
                dispatch(receivedCouncilAffiliations(councilAffiliations));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/alumniCouncilAffiliations`}`), { extra: { api: `${ESB_PERSONS}v2/alumniCouncilAffiliations`, error } });
                dispatch(failedToGetCouncilAffiliations())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetCouncilAffiliations() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_COUNCIL_AFFILIATIONS,
    }
}
function receivedCouncilAffiliations(councilAffiliations) {
    return {
        type: ACTIONTYPES.RECEIVED_COUNCIL_AFFILIATIONS,
        councilAffiliations
    }
}
function failedToGetCouncilAffiliations() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_COUNCIL_AFFILIATIONS,
    }
}

export function getAffinityGroups() {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    let username = loggedinUser.account.username
    return function (dispatch) {
        dispatch(requestToGetAffinityGroups());
        fetch(`${ESB_PERSONS}v2/alumniAffinityGroups`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "userName": username
            })
        }).then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
            .then(affinityGroups => {
                dispatch(receivedAffinityGroups(affinityGroups));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/alumniAffinityGroups`}`), { extra: { api: `${ESB_PERSONS}v2/alumniAffinityGroups`, error } });
                dispatch(failedToGetAffinityGroups())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetAffinityGroups() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_AFFINITIES,
    }
}
function receivedAffinityGroups(affinityGroups) {
    return {
        type: ACTIONTYPES.RECEIVED_AFFINITIES,
        affinityGroups
    }
}
function failedToGetAffinityGroups() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_AFFINITIES,
    }
}

const memoizedGetCouncilByZipCode = memoize(
    (zipCode) => councilByZipCode(zipCode),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentZipCode] = lastArgs;
        const [newZipCode] = newArgs;
        return currentZipCode === newZipCode;
    });

const councilByZipCode = (zipCode) => {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;

    return fetch(`${ESB_ORGANIZATIONS}v2/zip/${zipCode}/council`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        }
    }).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    })
}
export function getCouncilByZipCode(zipCode) {

    return function (dispatch) {

         if (!zipCode || zipCode === '*****' || zipCode.includes('*')) {
            return;
        }

        dispatch(requestToGetCouncilByZipCode()); 
        memoizedGetCouncilByZipCode(zipCode)
            .then(councilByZip => {
                dispatch(receivedCouncilByZipCode(councilByZip));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_ORGANIZATIONS}v2/zip/${zipCode}/council`}`), { extra: { api: `${ESB_ORGANIZATIONS}v2/zip/${zipCode}/council`, error } });
                dispatch(failedToGetCouncilByZipCode())
                notification.open({
                    message: error.message ? `${error.message}` : "Error",
                    description: `${error.errorDesc}`,
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                });
                console.log(error);
            })
    }
}

function requestToGetCouncilByZipCode() {
    return {
        type: ACTIONTYPES.REQUESTED_TO_GET_COUNCIL_BY_ZIPCODE,
    }
}
function receivedCouncilByZipCode(councilByZip) {
    return {
        type: ACTIONTYPES.RECEIVED_COUNCIL_BY_ZIPCODE,
        councilByZip
    }
}
function failedToGetCouncilByZipCode() {
    return {
        type: ACTIONTYPES.FAILED_TO_GET_COUNCIL_BY_ZIPCODE,
    }
}

export function getEagleNesaMemberships() {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    let username = loggedInUser.account.username;
    const token = loggedInUser.token;

    return function (dispatch) {
        dispatch(reqEagleNesaMemberships());

        fetch(`${GET_NESA_MEMBERSHIP}/nesaRegistrations?userName=${username}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(membershipInfo => {
                dispatch(recEagleNesaMemberships(membershipInfo));
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${GET_NESA_MEMBERSHIP}/nesaRegistrations?userName=${username}`}`), { extra: { api: `${GET_NESA_MEMBERSHIP}/nesaRegistrations?userName=${username}`, error } });
                Modal.error({
                    className: "ErrorModal",
                    title: 'Error',
                    content: error,
                });
                dispatch(errorEagleNesaMemberships(error))
            });
    }
}

function reqEagleNesaMemberships() {
    return {
        type: ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_LOADING,
    };
}

function recEagleNesaMemberships(memberIds) {
    return {
        type: ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_RECEIVED,
        memberIds: memberIds
    };
}

function errorEagleNesaMemberships(error) {
    return {
        type: ACTIONTYPES.EAGLE_NESA_MEMBERSHIPS_ERROR,
        error: error
    };
}

export function getAssignRolesPositions(getLoggedInUserPosition) { //memberId - to get the positions of logged in user
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";
            let loggedInUserMID = loggedinUser.membership || {};
            loggedInUserMID = getLoggedInUserPosition && loggedInUserMID && loggedInUserMID.memberId ? loggedInUserMID.memberId : '';
            
            dispatch(requestAssignRolesPositions());

            let positionIds = getLoggedInUserPosition && loggedInUserMID ? [getLoggedInUserPosition] : ['AlumniCouncilCommittee', 'AlumniCSTSupport', 'AlumniAdmin'];
            const allPositionList = [];

            for (let positionId of positionIds) {
            let url = getLoggedInUserPosition && loggedInUserMID ? `${ESB_PERSONS}v2/NESAPositionsDictionary?memberId=${loggedInUserMID}` : `${ESB_PERSONS}v2/NESAPositionsDictionary?positionContext=${positionId}`
            
                const response = await fetch(url, {
                    method: 'GET',
                    credentials: 'include',
                    cache: 'no-cache',
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": `Bearer ${token}`
                    },
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText} (Status: ${response.status})`);
                }

                const positionList = await response.json();

                if (!positionList || typeof positionList !== 'object') {
                    throw new Error(`Invalid position list response for position ${positionId}`);
                }

                allPositionList.push(...positionList);
            }
                
            dispatch(receiveAssignRolesPositions(allPositionList));
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/NESAPositionsDictionary`}`), { extra: { api: `${ESB_PERSONS}v2/NESAPositionsDictionary`, error } });
            console.error('Error fetching organization positions:', error);
            dispatch(errorFetchingAssignRolesPositions(error.message));
        }
    };
}

function requestAssignRolesPositions() {
    return {
        type: ACTIONTYPES.ASSIGN_ROLES_POSITIONS_LOADING,
    };
}

function receiveAssignRolesPositions(positionList) {
    return {
        type: ACTIONTYPES.ASSIGN_ROLES_POSITIONS,
        positionList,
    };
}

function errorFetchingAssignRolesPositions(error) {
    return {
        type: ACTIONTYPES.ASSIGN_ROLES_POSITIONS_ERROR,
        error,
    };
}

 function assignFunctional(personGUID, positionOrgGuid, positionId, effectiveDate, expiryDate){
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const token = loggedInUser.token;

    return fetch(ESB_PERSONS + `positions/` + personGUID + `/assignFunctional`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        },
        body: JSON.stringify({
            "PositionId": positionId,
            "OrganizationGuid": positionOrgGuid,
            "EffectiveDt": effectiveDate,
            "ExpiryDt": expiryDate
        })
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(error => Promise.reject(error));
            }
            return response.json();
        })
 }

export function assignRolesFunctional(personGuid, MID, Role, TerritoryID, CouncilsID, effectiveDate, expiryDate, positionOrgGuid) {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const token = loggedInUser.token;

    return function (dispatch) {
        dispatch(requestUserFunctionalRoles());

        let roleAssignments = [];

        if (Role === "AlumniCouncilCommittee") {
            const positionId = 781
            // roleAssignments = CouncilsID.map(orgGuid => {
            //    return assignFunctional(personGuid, orgGuid, positionId, effectiveDate, expiryDate)
            //     .then(res => {
            //         console.log("Assigning to:", MID, "with orgGuid:", orgGuid);
            //         return fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, {
            //             method: "POST",
            //             headers: {
            //                 "Content-Type": "application/json",
            //                 "authorization": `Bearer ${token}`,
            //             },
            //             body: JSON.stringify({
            //                 organizationGuid: orgGuid,
            //                 positionContext: Role,
            //                 effectiveDate,
            //                 expiryDate,
            //             }),
            //         })
            //         .then(res => {
            //             if (!res.ok) {
            //                 return res.json().then(err => Promise.reject({ status: res.status, ...err }));
            //             }
            //             return res.json(); 
            //         });
            //     })
            // });
            roleAssignments.push(
                assignFunctional(personGuid, positionOrgGuid, positionId, effectiveDate, expiryDate)
                // .then(res => {
                //     return new Promise(resolve => setTimeout(resolve, 180000))
                    .then(res => {
                        return Promise.all(
                            CouncilsID.map(orgGuid =>
                                fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "authorization": `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({
                                        organizationGuid: orgGuid,
                                        positionContext: Role,
                                        effectiveDate,
                                        expiryDate,
                                    }),
                                }).then(res => {
                                    if (!res.ok) {
                                        return res.json().then(err => Promise.reject({ status: res.status, ...err }));
                                    }
                                    return res.json();
                                })
                            )
                        );
                    })
                // })
            );
        } else {
            let orgGuid = "", positionId = '';
            if (Role === "AlumniCSTSupport"){ 
                orgGuid = TerritoryID;
                positionId = 782
            }
            if (Role === "AlumniAdmin"){ 
                orgGuid = NationalGUID;
                positionId = 783
            }

            roleAssignments.push(
                assignFunctional(personGuid, positionOrgGuid, positionId, effectiveDate, expiryDate)
                // .then(res => {
                // return new Promise(resolve => setTimeout(resolve, 180000))
                .then(res => {
                fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        organizationGuid: orgGuid,
                        positionContext: Role,
                        effectiveDate,
                        expiryDate,
                    }),
                })
                .then(res => {
                    if (!res.ok) {
                        return res.json().then(err => Promise.reject({ status: res.status, ...err }));
                    }
                    return res.json();
                });
            })
        // })
            );
        }

        return Promise.all(roleAssignments)
            .then(roleInfo => {
                dispatch(receiveUserFunctionalRoles(roleInfo));
                Modal.success({
                    className: "SuccessModal",
                    title: "Success",
                    content: "Role assigned successfully!",
                });
                return roleInfo;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`}`), { extra: { api: `${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, error } });
                console.error("API Error:", error);

                let message = "Role assignment failed.";
                let errorDesc = "Something went wrong.";

                if (error && error.message) message = error.message;
                if (error && error.errorDesc) errorDesc = error.errorDesc;

                Modal.error({
                    className: "ErrorModal",
                    title: message,
                    content: errorDesc,
                });

                dispatch(errorUserFunctionalRoles(errorDesc));
                throw error;
            });
    };
}

//AG-1370 Extends a role directly via NESAPersonPosition/assign, bypassing assignFunctional,
// for the case where the person's position (per GET /organizations/v2/organizations/{positionId}) is not yet expired.
export function assignPersonPositionDirect(MID, organizationGuid, positionContext, effectiveDate, expiryDate) {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const token = loggedInUser.token;

    return function (dispatch) {
        dispatch(requestUserFunctionalRoles());

        return fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({
                organizationGuid,
                positionContext,
                effectiveDate,
                expiryDate,
            }),
        })
            .then(res => {
                if (!res.ok) {
                    return res.json().then(err => Promise.reject({ status: res.status, ...err }));
                }
                return res.json();
            })
            .then(roleInfo => {
                dispatch(receiveUserFunctionalRoles(roleInfo));
                Modal.success({
                    className: "SuccessModal",
                    title: "Success",
                    content: "Role assigned successfully!",
                });
                return roleInfo;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`}`), { extra: { api: `${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, error } });
                console.error("API Error:", error);

                let message = "Role assignment failed.";
                let errorDesc = "Something went wrong.";

                if (error && error.message) message = error.message;
                if (error && error.errorDesc) errorDesc = error.errorDesc;

                Modal.error({
                    className: "ErrorModal",
                    title: message,
                    content: errorDesc,
                });

                dispatch(errorUserFunctionalRoles(errorDesc));
                throw error;
            });
    };
}

// When adding a role, if the person already holds this exact role (per getAssignRolesPersonGuid's
// userInfo, matched on PositionLong), skip assignFunctional/registration entirely and just
// (re)confirm NESAPersonPosition/assign for the newly selected org(s).
export function assignPersonPositionDirectForRole(MID, Role, TerritoryID, CouncilsID, effectiveDate, expiryDate) {
    const loggedInUser = JSON.parse(localStorage.getItem('user'));
    const token = loggedInUser.token;

    const callAssign = (organizationGuid) =>
        fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({
                organizationGuid,
                positionContext: Role,
                effectiveDate,
                expiryDate,
            }),
        }).then(res => {
            if (!res.ok) {
                return res.json().then(err => Promise.reject({ status: res.status, ...err }));
            }
            return res.json();
        });

    return function (dispatch) {
        dispatch(requestUserFunctionalRoles());

        let orgGuids = [];
        if (Role === "AlumniCouncilCommittee") {
            orgGuids = CouncilsID;
        } else if (Role === "AlumniCSTSupport") {
            orgGuids = [TerritoryID];
        } else if (Role === "AlumniAdmin") {
            orgGuids = [NationalGUID];
        }

        return Promise.all(orgGuids.map(callAssign))
            .then(roleInfo => {
                dispatch(receiveUserFunctionalRoles(roleInfo));
                Modal.success({
                    className: "SuccessModal",
                    title: "Success",
                    content: "Role assigned successfully!",
                });
                return roleInfo;
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`}`), { extra: { api: `${ESB_PERSONS}v2/${MID}/NESAPersonPosition/assign`, error } });
                console.error("API Error:", error);

                let message = "Role assignment failed.";
                let errorDesc = "Something went wrong.";

                if (error && error.message) message = error.message;
                if (error && error.errorDesc) errorDesc = error.errorDesc;

                Modal.error({
                    className: "ErrorModal",
                    title: message,
                    content: errorDesc,
                });

                dispatch(errorUserFunctionalRoles(errorDesc));
                throw error;
            });
    };
}

function requestUserFunctionalRoles() {
    return {
        type: ACTIONTYPES.USER_FUNCTIONAL_ROLES_LOADING,
    };
}

function receiveUserFunctionalRoles(roleData) {
    return {
        type: ACTIONTYPES.USER_FUNCTIONAL_ROLES_RECEIVED,
        roleData: roleData,
    };
}

function errorUserFunctionalRoles(error) {
    return {
        type: ACTIONTYPES.USER_FUNCTIONAL_ROLES_ERROR,
        error,
    };
}

export function getOrganizationPostion() {
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";

            dispatch(requestGetOrganizationPostion());

            const positionIds = [781, 782, 783, 717];
            const allPositionList = [];

            for (let positionId of positionIds) {
                const response = await fetch(`${GET_POSITION_TYPE}organizations/${positionId}`, {
                    method: 'GET',
                    credentials: 'include',
                    cache: 'no-cache',
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": `Bearer ${token}`
                    },
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText} (Status: ${response.status})`);
                }

                const positionList = await response.json();

                if (!positionList || typeof positionList !== 'object') {
                    throw new Error(`Invalid position list response for position ${positionId}`);
                }

                allPositionList.push(...positionList);
            }

            dispatch(receiveGetOrganizationPostion(allPositionList));
            return allPositionList;
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${GET_POSITION_TYPE}organizations/{positionId}`}`), { extra: { api: `${GET_POSITION_TYPE}organizations/{positionId}`, error } });
            console.error('Error fetching organization positions:', error);
            dispatch(errorFetchingAssignRolesPositions(error.message));
            return [];
        }
    };
}

function requestGetOrganizationPostion() {
    return {
        type: ACTIONTYPES.ORGANIZATION_POSITIONS_LOADING,
    };
}

function receiveGetOrganizationPostion(personPositionList) {
    return {
        type: ACTIONTYPES.ORGANIZATION_POSITIONS_RECEIVE,
        personPositionList,
    };
}

function errorFetchingAssignRolesPositions(error) {
    return {
        type: ACTIONTYPES.ORGANIZATION_POSITIONS_ERROR,
        error,
    };
}

export function expirePosition({ position, MID, Role, effectiveDate, oneActiveRegistrationForMultipleCouncil }) {
    let loggedInUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedInUser.token;

    return function (dispatch) {
        dispatch(requestRoleExpire());
        // dispatch(requestRemoveUserRole());

        return fetch(`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/expire`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                organizationGuid: position.organizationGuid,
                positionContext: Role,
                effectiveDate: effectiveDate ? moment(effectiveDate).format('YYYY-MM-DD') : undefined
            })
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(text => { throw new Error(text); });
                }
                return response.text();
            })
            .then(res => {
                if(oneActiveRegistrationForMultipleCouncil){
                    dispatch(receiveRoleExpire(null));
                    // dispatch(receiveRemoveUserRole(null));
                    return { success: true };
                }
            })
        .catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${MID}/NESAPersonPosition/expire`}`), { extra: { api: `${ESB_PERSONS}v2/${MID}/NESAPersonPosition/expire`, error } });
            console.error("API Error:", error);
            let rolesError;
            try {
                rolesError = JSON.parse(error.message);
            } catch (err) {
                rolesError = { errorDesc: error.message || "Unknown error" };
            }
            // Modal.error({
            //     className: "ErrorModal",
            //     title: 'Failed',
            //     content: `${rolesError.errorDesc || "Unknown error"}`,
            // });
            dispatch(errorRoleExpire(rolesError.errorDesc));
            // dispatch(errorRemoveUserRole(rolesError.errorDesc));
            throw error;
        });
    };
}
export function expireFunctional({ personGuid, positionId, pkPersonPositionId, organizationGuid, expiryDt}) {
    let loggedInUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedInUser.token;

    return function (dispatch) {
        // dispatch(requestRoleExpire());
        dispatch(requestRemoveUserRole());

        return fetch(`${ESB_PERSONS}positions/${personGuid}/expireFunctional`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        PositionId: positionId,
                        OrganizationGuid: organizationGuid,
                        PkPersonPositionId: pkPersonPositionId,
                        ExpiryDt: expiryDt ? moment(expiryDt).format('YYYY-MM-DD') : undefined
                    })
                })
                    .then(response => {
                        if (!response.ok) {
                            return response.text().then(text => { throw new Error(text); });
                        }
                        return response.text();
                    })
                    .then(() => {
                        // dispatch(receiveRoleExpire(null));
                        dispatch(receiveRemoveUserRole(null));
                        return { success: true };
                    })
        .catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}positions/${personGuid}/expireFunctional`}`), { extra: { api: `${ESB_PERSONS}positions/${personGuid}/expireFunctional`, error } });
            console.error("API Error:", error);
            let rolesError;
            try {
                rolesError = JSON.parse(error.message);
            } catch (err) {
                rolesError = { errorDesc: error.message || "Unknown error" };
            }
            // Modal.error({
            //     className: "ErrorModal",
            //     title: 'Failed',
            //     content: `${rolesError.errorDesc || "Unknown error"}`,
            // });
            // // dispatch(errorRoleExpire(rolesError.errorDesc));
            dispatch(errorRemoveUserRole(rolesError.errorDesc));
            throw error;
        });
    };
}

function requestRoleExpire() {
    return {
        type: ACTIONTYPES.ROLES_EXPIRE_LOADING,
    };
}

function receiveRoleExpire(expireRemoveData) {
    return {
        type: ACTIONTYPES.ROLES_EXPIRE_SUCCESS,
        expireRemoveData: expireRemoveData
    };
}

function errorRoleExpire(error) {
    return {
        type: ACTIONTYPES.ROLES_EXPIRE_ERROR,
        error: error
    };
}

function requestRemoveUserRole() {
    return {
        type: ACTIONTYPES.REMOVE_USER_ROLE_LOADING,
    };
}

function receiveRemoveUserRole(roleRemoveData) {
    return {
        type: ACTIONTYPES.REMOVE_USER_ROLE_SUCCESS,
        roleRemoveData: roleRemoveData
    };
}

function errorRemoveUserRole(error) {
    return {
        type: ACTIONTYPES.REMOVE_USER_ROLE_ERROR,
        error: error
    };
}

export function globalSearch(values) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;

    return function (dispatch) {
        dispatch(reqSearchGlobal());

        return fetch(ESB_PERSONS + 'v2/globalSearch', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json; version = 2',
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                "firstName": values.scout_first_name,
                "lastName": values.scout_last_name,
                "memberId": values.scout_member_id ? parseInt(values.scout_member_id) : undefined
            })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then((error) => {
                        return Promise.reject(error);
                    });
                }
                return response.json();
            })
            .then(eagle => {
                dispatch(recGlobalStatus(eagle));

                 if (eagle && eagle.length > 0) {
                    const personGuid = eagle[0].personGuid;
                    return dispatch(getAlumniInfo(personGuid, "admin"));
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/globalSearch'}`), { extra: { api: ESB_PERSONS + 'v2/globalSearch', error } });
                Modal.error({
                    title: `${error.message}`,
                    content: `${error.errorDesc}`,
                    onOk() {
                        // window.location.reload()
                    }
                });
                dispatch(recGlobalStatusErr(error));
            });
    }
}


function reqSearchGlobal() {
    return {
        type: ACTIONTYPES.SEARCHING_GLOBAL,
    }
}

function recGlobalStatus(eagle) {
    return {
        type: ACTIONTYPES.SEARCHED_GLOBAL,
        eagle: eagle
    }
}

function recGlobalStatusErr(errorMessage) {
    return {
        type: ACTIONTYPES.SEARCHED_GLOBAL_ERROR,
        error: errorMessage
    }
}

// export function getAssignRolesPersonGuid(personGUID) {
//     let loggedinUser = JSON.parse(localStorage.getItem('user'))
//     let token = loggedinUser.token;
//     return function (dispatch) {
//         dispatch(assignPersonGuidLoading())
//         return fetch(ESB_PERSONS + personGUID + `/positions`, {
//             method: 'GET',
//             credentials: 'include',
//             headers: {
//                 "Content-Type": "application/json",
//                 "authorization": "Bearer " + token
//             }
//         })
//             .then(response => {
//                 if (!response.ok) {
//                     return response.json().then(error => Promise.reject(error));
//                 }
//                 return response.json();
//             })
//             .then(userInfo => {
//                 if (Array.isArray(userInfo) && userInfo.length === 0) {
//                     Modal.error({
//                         title: 'Failed',
//                         content: 'There is no council level paid position for this alumni',
//                         centered: true,
//                         onOk() {
//                             // window.location.reload()
//                         }
//                     });
//                 } else {
//                     const paidPosition = userInfo.find(position => position.IsPaidPosition === true);

//                     if (paidPosition) {
//                         const orgGuid = paidPosition.OrganizationGuid;

//                         if (orgGuid) {
//                             dispatch(assignPersonGuidInfo(userInfo));
//                             return orgGuid;
//                         }
//                     }
//                 }
//             })
//             .catch(error => {
//                 Modal.error({
//                     title: error.message,
//                     content: error.errorDesc,
//                     centered: true
//                 });
//                 dispatch(assignPersonGuidError(error));
//             });
//     }
// }

export function getAssignRolesPersonGuid(personGUID, ForExtendRole) {
  let loggedinUser = JSON.parse(localStorage.getItem('user'));
  let token = loggedinUser.token;

  return function (dispatch) {
    if(ForExtendRole) dispatch(getActiveRegistrationsLoading());
    else dispatch(assignPersonGuidLoading());

    return fetch(ESB_PERSONS + personGUID + '/positions', {
      method: 'GET',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        "authorization": "Bearer " + token
      }
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(error => Promise.reject(error));
        }
        return response.json();
      })
      .then(userInfo => {
        if(ForExtendRole) dispatch(receivedActiveRegistrations(Array.isArray(userInfo) ? userInfo : []));
        else dispatch(assignPersonGuidInfo(Array.isArray(userInfo) ? userInfo : []));
    })
      .catch(error => {
        Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + personGUID + '/positions'}`), { extra: { api: ESB_PERSONS + personGUID + '/positions', error } });
        Modal.error({
          title: error.message,
          content: error.errorDesc,
          centered: true
        });
        if(ForExtendRole) dispatch(failedActiveRegistrations(error));
        else dispatch(assignPersonGuidError(error));
      });
  };
}

function assignPersonGuidLoading() {
    return {
        type: ACTIONTYPES.ROLES_PERSONSGUID_LOADING,
    }
}

function assignPersonGuidInfo(userInfo) {
    return {
        type: ACTIONTYPES.ROLES_PERSONSGUID_RECEIVE,
        userInfo: userInfo
    }
}

function assignPersonGuidError(errorMessage) {
    return {
        type: ACTIONTYPES.ROLES_PERSONSGUID_ERROR,
        error: errorMessage
    };
}

function getActiveRegistrationsLoading() {
    return {
        type: ACTIONTYPES.GETTING_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE,
    }
}

function receivedActiveRegistrations(activeRegistrations) {
    return {
        type: ACTIONTYPES.RECEIVED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE,
        activeRegistrations: activeRegistrations
    }
}

function failedActiveRegistrations(errorMessage) {
    return {
        type: ACTIONTYPES.FAILED_ACTIVE_REGISTRATIONS_FOR_EXTEND_ROLE,
        error: errorMessage
    };
}

const memoizedFetchChildOrganizationsGuid = memoize(
    (orgGUID) => fetchChildOrganizationsGuid(orgGUID),
    (newArgs, lastArgs) => {
        if (newArgs.length !== lastArgs.length) {
            return false;
        }
        const [currentOrgGUID] = lastArgs;
        const [newOrgGUID] = newArgs;
        return currentOrgGUID === newOrgGUID;
    });

export function fetchChildOrganizationsGuid(orgGuid) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return fetch(ESB_ORGANIZATIONS + orgGuid + `/childOrganizations`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        }
    })
        .then(response => {
            if (!response.ok) {
                return response.json().then(error => Promise.reject(error));
            }
            return response.json();
        })
}

export function getChildOrganizationsGuid(orgGuid) {
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(childOrgGuidLoading())
        
        if (!orgGuid) {
            const error = new Error("Organization GUID is required.");
            dispatch(childOrgGuidError(error));
            Modal.error({
                title: "Missing Organization GUID",
                content: "Please provide a valid organization GUID.",
                centered: true,
            });
            return;
        }

        memoizedFetchChildOrganizationsGuid(orgGuid, token)
            .then((orgInfo) => {
                dispatch(childOrgGuidInfo(orgInfo));
            })
            .catch((error) => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_ORGANIZATIONS + orgGuid + `/childOrganizations`}`), { extra: { api: ESB_ORGANIZATIONS + orgGuid + `/childOrganizations`, error } });
                dispatch(childOrgGuidError(error));
                Modal.error({
                    title: error.message || "Error fetching data",
                    content: error.errorDesc || "Something went wrong while fetching organization data.",
                    centered: true,
                });
            });
    };
}

function childOrgGuidLoading() {
    return {
        type: ACTIONTYPES.CHILD_ORG_LOADING,
    }
}

function childOrgGuidInfo(orgInfo) {
    return {
        type: ACTIONTYPES.CHILD_ORG_RECEIVE,
        orgInfo: orgInfo
    }
}

function childOrgGuidError(errorMessage) {
    return {
        type: ACTIONTYPES.CHILD_ORG_ERROR,
        error: errorMessage
    };
}




export function getCouncilsByTerritory(TerritoryGuid) {
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";

            dispatch(requestCouncils());

            return fetch(`${ESB_ORGANIZATIONS}${TerritoryGuid}/childOrganizations`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `Bearer ${token}`
                },
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(error => Promise.reject(error));
                    }
                    return response.json();
                })
                .then(councils => {
                    dispatch(receiveCouncils(councils));
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_ORGANIZATIONS}${TerritoryGuid}/childOrganizations`}`), { extra: { api: `${ESB_ORGANIZATIONS}${TerritoryGuid}/childOrganizations`, error } });
                    console.error("API Error:", error);
                    Modal.error({
                        className: "ErrorModal",
                        title: error.message || "Error",
                        content: error.errorDesc || "Something went wrong.",
                    });
                    dispatch(errorFetchingCouncils(error.errorDesc || error.message));
                    throw error;
                });
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_ORGANIZATIONS}${TerritoryGuid}/childOrganizations`}`), { extra: { api: `${ESB_ORGANIZATIONS}${TerritoryGuid}/childOrganizations`, error } });
            console.error('Error fetching Councils:', error);
            dispatch(errorFetchingCouncils(error.message));
        }
    };
}

function requestCouncils() {
    return {
        type: ACTIONTYPES.GET_COUNCILS_LOADING,
    };
}

function receiveCouncils(councils) {
    return {
        type: ACTIONTYPES.GET_COUNCILS_RECEIVE,
        GetAllCouncils: councils,
    };
}

function errorFetchingCouncils(error) {
    return {
        type: ACTIONTYPES.GET_COUNCILS_ERROR,
        error,
    };
}

export function getSuperAdmin() {
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";

            dispatch(reqSuperAdmin());

            return fetch(`${ESB_ORGANIZATIONS}v2/organizations/717`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `Bearer ${token}`
                },
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(error => Promise.reject(error));
                    }
                    return response.json();
                })
                .then(superadmininfo => {
                    dispatch(recSuperAdmin(superadmininfo));
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_ORGANIZATIONS}v2/organizations/717`}`), { extra: { api: `${ESB_ORGANIZATIONS}v2/organizations/717`, error } });
                    console.error('Error fetching Councils:', error);
                    dispatch(errorFetchingCouncils(error.message || error.errorDesc));
                });

        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_ORGANIZATIONS}v2/organizations/717`}`), { extra: { api: `${ESB_ORGANIZATIONS}v2/organizations/717`, error } });
            console.error('Error fetching Councils:', error);
            dispatch(errorFetchingCouncils(error.message));
        }
    };
}

function reqSuperAdmin() {
    return {
        type: ACTIONTYPES.SUPER_ADMIN_LOADING,
    };
}

function recSuperAdmin(superadmininfo) {
    return {
        type: ACTIONTYPES.SUPER_ADMIN_RECEIVE,
        superadmininfo: superadmininfo,
    };
}

export function getAllRanks(userId) {
    return async function (dispatch) {
        try {
            if (!userId) {
                console.error("No userId provided to getAllRanks()");
                return;
            }

            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";
            // const userID = loggedinUser.account.userId || undefined;

            dispatch(requestRanks());

            // return fetch(GET_RANKS, {
            return fetch(YOUTH_ADVANCEMENTS + userId + '/ranks', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `Bearer ${token}`
                },
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(error => Promise.reject(error));
                    }
                    return response.json();
                })
                .then(ranks => {
                    const allRanks = ranks.program ? ranks.program.flatMap(p => p.ranks || []) : [];
                    dispatch(receiveRanks(allRanks));
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${YOUTH_ADVANCEMENTS + userId + '/ranks'}`), { extra: { api: YOUTH_ADVANCEMENTS + userId + '/ranks', error } });
                    console.error("API Error:", error);
                    Modal.error({
                        className: "ErrorModal",
                        title: error.message || "Error",
                        content: error.errorDesc || "Something went wrong.",
                    });
                    dispatch(errorFetchingRanks(error.errorDesc || error.message));
                    throw error;
                });
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${YOUTH_ADVANCEMENTS + userId + '/ranks'}`), { extra: { api: YOUTH_ADVANCEMENTS + userId + '/ranks', error } });
            console.error('Error fetching Ranks:', error);
            dispatch(errorFetchingRanks(error.message));
        }
    };
}

function requestRanks() {
    return {
        type: ACTIONTYPES.GET_RANKS_LOADING,
    };
}

function receiveRanks(ranks) {
    return {
        type: ACTIONTYPES.GET_RANKS_RECEIVE,
        GetAllRanks: ranks,
    };
}

function errorFetchingRanks(error) {
    return {
        type: ACTIONTYPES.GET_RANKS_ERROR,
        error,
    };
}

// AAG-1417: shared PUT for /rank, used both by the interactive "add rank"
// action below and by the Record Repair Tool's auto-add-Eagle-Scout flow.
// For Eagle Scout, dateEarned/leaderApprovedDate must match the Board of
// Review date from Eagle Information rather than today's date;
// markedCompletedDate always reflects the actual date the rank is added.
// For every other rank, all three fields are that same actual add date,
// captured once so the stored value won't drift on later days.
async function putRankRecord(personGuid, rankId, rankName, eagleBoardReviewDate, token) {
  const today = new Date();
  const isEagleScout = rankName === 'Eagle Scout';

  let dateEarned, markedCompletedDate, leaderApprovedDate;

  if (isEagleScout && eagleBoardReviewDate) {
    dateEarned = new Date(eagleBoardReviewDate);
    leaderApprovedDate = new Date(eagleBoardReviewDate);
    markedCompletedDate = today;
  } else {
    dateEarned = today;
    markedCompletedDate = today;
    leaderApprovedDate = today;
  }

  const formatDate = function (d) {
    return d.toISOString().split("T")[0];
  };

  const response = await fetch(`${ESB_PERSONS}v2/${personGuid}/rank`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      "Content-Type": "application/json",
      "authorization": "Bearer " + token
    },
    body: JSON.stringify({
      rankId: Number(rankId),
      dateEarned: formatDate(dateEarned),
      markedCompletedDate: formatDate(markedCompletedDate),
      leaderApprovedDate: formatDate(leaderApprovedDate)
    })
  });

  let result = null;
  try {
    result = await response.json();
  } catch (e) {
    result = null;
  }

  return { ok: response.ok, status: response.status, statusText: response.statusText, result };
}

async function addEagleScoutRankInBackground(personGuid, eagleBoardReviewDate, token, dispatch, userId) {
  try {
    const ranksResponse = await fetch(`${ESB_URL}/advancements/v2/ranks`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        "authorization": `Bearer ${token}`
      },
    });

    let ranksResult = null;
    try {
      ranksResult = await ranksResponse.json();
    } catch (e) {
      ranksResult = null;
    }

    if (!ranksResponse.ok) {
      const errorCode = (ranksResult && ranksResult.errorCode) ? ranksResult.errorCode : ranksResponse.status;
      const message = (ranksResult && ranksResult.message) ? ranksResult.message : ranksResponse.statusText || "Error";
      const errorDesc = (ranksResult && ranksResult.errorDesc) ? ranksResult.errorDesc : "Failed to look up ranks while adding the Eagle Scout rank.";

      Modal.error({
        className: "ErrorModal",
        title: `${errorCode} ${message}`,
        content: errorDesc
      });
      return;
    }

    const eagleScoutRank = Array.isArray(ranksResult) ? ranksResult.find(r => r.name === 'Eagle Scout') : null;

    if (eagleScoutRank) {
      const rankResult = await putRankRecord(personGuid, eagleScoutRank.id, 'Eagle Scout', eagleBoardReviewDate, token);

      if (!rankResult.ok) {
        const errorCode = (rankResult.result && rankResult.result.errorCode) ? rankResult.result.errorCode : rankResult.status;
        const message = (rankResult.result && rankResult.result.message) ? rankResult.result.message : rankResult.statusText || "Error";
        const errorDesc = (rankResult.result && rankResult.result.errorDesc) ? rankResult.result.errorDesc : "Something went wrong while adding the Eagle Scout rank.";

        Modal.error({
          className: "ErrorModal",
          title: `${errorCode} ${message}`,
          content: errorDesc
        });
      } else if (dispatch && userId) {
        dispatch(getAllRanks(userId));
      }
    }
  } catch (rankError) {
    Modal.error({
      className: "ErrorModal",
      title: "Error",
      content: "Something went wrong while adding the Eagle Scout rank."
    });
  }
}

export function updateRank(personGuid, rankId, rankName, eagleBoardReviewDate) {
  return async function (dispatch) {
    try {
      const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
      const token = loggedinUser.token || "";

      dispatch(requestUpdateRank());

      const { ok, status, statusText, result } = await putRankRecord(personGuid, rankId, rankName, eagleBoardReviewDate, token);

      if (!ok) {
        var errorCode = (result && result.errorCode) ? result.errorCode : status;
        var message = (result && result.message) ? result.message : statusText || "Error";
        var errorDesc = (result && result.errorDesc) ? result.errorDesc : "Something went wrong while updating rank.";

        Modal.error({
          className: "ErrorModal",
          title: errorCode + " " + message,
          content: errorDesc
        });

        dispatch(errorUpdatingRank(errorDesc));
        return;
      }

      dispatch(receiveUpdateRank(result));

      Modal.success({
        title: "Rank Updated",
        content: (
            <span>
                <b>{rankName}</b> rank updated successfully.
            </span>
        ),
        okText: "OK",
        className: "SuccessModal"
      });

    } catch (error) {
      Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${personGuid}/rank`}`), { extra: { api: `${ESB_PERSONS}v2/${personGuid}/rank`, error } });
      console.error("API Error:", error);

      Modal.error({
        className: "ErrorModal",
        title: "Error",
        content: "Something went wrong while updating rank."
      });

      dispatch(errorUpdatingRank(error.message));
    }
  };
}

function requestUpdateRank() {
    return {
        type: ACTIONTYPES.UPDATE_RANK_LOADING,
    };
}

function receiveUpdateRank(result) {
    return {
        type: ACTIONTYPES.UPDATE_RANK_SUCCESS,
        payload: result,
    };
}

function errorUpdatingRank(error) {
    return {
        type: ACTIONTYPES.UPDATE_RANK_ERROR,
        error,
    };
}

export function deleteRank(personGuid, rankId, rankName) {
  return async function (dispatch) {
    try {
      dispatch(requestDeleteRank());

      const loggedinUser = JSON.parse(localStorage.getItem("user") || "{}");
      const token = loggedinUser.token || "";

      const response = await fetch(`${ESB_PERSONS}v2/${personGuid}/rank/${rankId}`, {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }

      const result = await response.json().catch(() => ({})); 

      dispatch(receiveDeleteRank(result)); 

      Modal.success({
        title: "Rank Deleted",
        content: (
            <span>
                <b>{rankName}</b> rank deleted successfully.
            </span>
        ),
        okText: "OK",
        className: "SuccessModal",
      });
    } catch (error) {
      Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_PERSONS}v2/${personGuid}/rank/${rankId}`}`), { extra: { api: `${ESB_PERSONS}v2/${personGuid}/rank/${rankId}`, error } });
      console.error("Delete API Error:", error);
      Modal.error({
        className: "ErrorModal",
        title: error.message || "Error",
        content: error.errorDesc || "Something went wrong while deleting rank.",
      });
      dispatch(errorDeletingRank(error.errorDesc || error.message));
    }
  };
}

function requestDeleteRank() {
  return {
    type: ACTIONTYPES.DELETE_RANK_LOADING,
  };
}

function receiveDeleteRank(result) {
  return {
    type: ACTIONTYPES.DELETE_RANK_SUCCESS,
    payload: result,
  };
}

function errorDeletingRank(error) {
  return {
    type: ACTIONTYPES.DELETE_RANK_ERROR,
    error,
  };
}

export function getAllLookupsRanks() {
  return async function (dispatch) {
    try {
      const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
      const token = loggedinUser.token || "";

      dispatch(requestLookupsRanks());

      const response = await fetch(`${ESB_URL}/advancements/v2/ranks`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }

      const GetAllLookupsRanks = await response.json();

      dispatch(receiveLookupsRanks(GetAllLookupsRanks));

    } catch (error) {
      Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_URL}/advancements/v2/ranks`}`), { extra: { api: `${ESB_URL}/advancements/v2/ranks`, error } });
      console.error("Error fetching Ranks:", error);
      Modal.error({
        className: "ErrorModal",
        title: error.message || "Error",
        content: error.errorDesc || "Something went wrong.",
      });
      dispatch(errorLookupsRanks(error.errorDesc || error.message));
    }
  };
}

function requestLookupsRanks() {
  return { type: ACTIONTYPES.GET_LOOKUPS_RANKS_LOADING };
}

function receiveLookupsRanks(lookupsRanks) {
  return {
    type: ACTIONTYPES.GET_LOOKUPS__RANKS_RECEIVE,
    GetAllLookupsRanks: lookupsRanks, 
  };
}

function errorLookupsRanks(error) {
  return { type: ACTIONTYPES.GET_LOOKUPS_RANKS_ERROR, error };
}

export function addPerson(values) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'));
    let token = loggedinUser.token;

    return function (dispatch) {
        dispatch(requestAddPerson());

        return new Promise((resolve, reject) => {
            fetch(ESB_PERSONS + 'v2/addPerson', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json; version = 2',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(values)
            })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(error => Promise.reject(error));
                    }
                    return response.json();
                })
                .then(result => {
                    dispatch(receiveAddPerson(result));

                    Modal.success({
                        title: 'Person Created Successfully',
                        content: (
                            <div style={{ marginTop: 10 }}>
                                <p>The new person has been created successfully.</p>
                                <p style={{ marginTop: 6 }}>
                                    <strong>Assigned MID:</strong> {result.memberId}
                                </p>
                            </div>
                        )
                    });

                    resolve(result); 
                })
                .catch(error => {
                    Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_PERSONS + 'v2/addPerson'}`), { extra: { api: ESB_PERSONS + 'v2/addPerson', error } });
                    Modal.error({
                        title: `${error.message || 'Add Person Failed'}`,
                        content: `${error.errorDesc || 'Something went wrong. Please try again.'}`
                    });
                    dispatch(receiveAddPersonErr(error));
                    reject(error); 
                });
        });
    };
}

function requestAddPerson() {
    return {
        type: ACTIONTYPES.ADD_PERSON_REQUEST
    };
}

function receiveAddPerson(data) {
    return {
        type: ACTIONTYPES.ADD_PERSON_SUCCESS,
        personData: data
    };
}

function receiveAddPersonErr(error) {
    return {
        type: ACTIONTYPES.ADD_PERSON_ERROR,
        error
    };
}

export function getCommunityOrgTypes() {
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";

            dispatch(loadingCommunityTypes());

            return fetch(COMMUNITY_ORG_TYPES_API, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `Bearer ${token}`
                },
            })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                if (data.response_code === "1") {
                    dispatch(receiveCommunityTypes(data.categories || []));
                } else {
                    throw new Error(data.response_message || "Failed to fetch community organization types");
                }

            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${COMMUNITY_ORG_TYPES_API}`), { extra: { api: COMMUNITY_ORG_TYPES_API, error } });
                console.error("API Error:", error);

                Modal.error({
                    className: "ErrorModal",
                    title: "Error",
                    content: error.message || "Something went wrong."
                });

                dispatch(failedCommunityTypes(error.message));
            });

        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${COMMUNITY_ORG_TYPES_API}`), { extra: { api: COMMUNITY_ORG_TYPES_API, error } });
            console.error('Error fetching Community Types:', error);
            dispatch(failedCommunityTypes(error.message));
        }
    };
}

function loadingCommunityTypes() {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_LOADING,
    };
}

function receiveCommunityTypes(categories) {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_RECEIVE,
        categories,
    };
}

function failedCommunityTypes(error) {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_ERROR,
        error,
    };
}

export function getCommunityOrgLookup() {
    return async function (dispatch) {
        try {
            const loggedinUser = JSON.parse(localStorage.getItem('user') || '{}');
            const token = loggedinUser.token || "";

            dispatch(loadingCommunityLookup());

            const response = await fetch(ESB_LOOKUP + `organizations/communityOrganizations/types`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "authorization": `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || "Failed to fetch lookup data");
            }

            const data = await response.json();

            dispatch(receiveCommunityLookup(data || []));
            console.log('Lookup action value:', data);
            
        } catch (error) {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${ESB_LOOKUP + `organizations/communityOrganizations/types`}`), { extra: { api: ESB_LOOKUP + `organizations/communityOrganizations/types`, error } });
            console.error("Lookup API Error:", error);

            Modal.error({
                className: "ErrorModal",
                title: "Error",
                content: error.message || "Something went wrong."
            });

            dispatch(failedCommunityLookup(error.message));
        }
    };
}

function loadingCommunityLookup() {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_LOOKUP_LOADING
    };
}

function receiveCommunityLookup(payload) {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_LOOKUP_SUCCESS,
        payload
    };
}

function failedCommunityLookup(error) {
    return {
        type: ACTIONTYPES.GET_COMMUNITY_LOOKUP_ERROR,
        error
    };
}

// Fetches an alumni lookup once; repeat calls are no-ops while loading or after a successful load.
const fetchAlumniLookup = (key) => (dispatch, getState) => {
    const current = (getState().alumniLookupsReducer || {})[key];
    if (current && (current.loading || current.list)) return;

    const token = JSON.parse(localStorage.getItem('user')).token;
    dispatch({ type: ACTIONTYPES.ALUMNI_LOOKUP_LOADING, key });

    fetch(`${ESB_LOOKUP}alumni/${key}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "authorization": "Bearer " + token
        }
    })
        .then(response => response.ok ? response.json() : Promise.reject(response.statusText))
        .then(payload => dispatch({ type: ACTIONTYPES.ALUMNI_LOOKUP_SUCCESS, key, payload: payload || [] }))
        .catch(error => {
            Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${`${ESB_LOOKUP}alumni/${key}`}`), { extra: { api: `${ESB_LOOKUP}alumni/${key}`, error } });
            console.log(error);
            dispatch({ type: ACTIONTYPES.ALUMNI_LOOKUP_ERROR, key });
        });
};

export const getScoutingAssociationsLookup = () => fetchAlumniLookup('scoutingAssociations');
export const getAffinityGroupsLookup = () => fetchAlumniLookup('affinityGroups');

export function getNewReportColumn(userRole) {
    const loggedinUser = JSON.parse(localStorage.getItem('user'))
    let token = loggedinUser.token;
    return function (dispatch) {
        dispatch(reqNewReportGetColumn());
        fetch(GENERATE_REPORT_GET_COLUMNS, {
            method: 'GET',
            credentials: 'include',
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
                "authorization": "Bearer " + token
            }
        })
            .then(response => {
                if (!response.ok) {
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(getColumn => {
                if (getColumn.response_code != 1) {
                    throw new Error(getColumn.response_message || "Failed to Get columns");
                } else {
                    const defaultColumns = ['alumniPrivacy', 'totalrecordcount'];

                    const merged = [
                        ...getColumn.columns,
                        ...defaultColumns.map(col => ({
                            name: col,
                            caption: col
                        }))
                    ];

                    const columns = Array.from(
                        new Map(merged.map(item => [item.name, item])).values()
                    );
                    
                    dispatch(receiveNewReportGetColumn(columns));
                }
            })
            .catch(error => {
                Sentry.captureException(new Error(`${(error && (error.message || error.errorDesc || error.statusText)) || "API Error"} - ${GENERATE_REPORT_GET_COLUMNS}`), { extra: { api: GENERATE_REPORT_GET_COLUMNS, error } });
                console.error("getNewReportColumn failed:", error);
          
                dispatch(failedNewReportGetColumn());
              
                const parsed = parseError(error);
                notification.open({
                    message: parsed.code || "Error!",
                    description: parsed.message || "Search failed.",
                    icon: <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" />,
                  });
            });
    }
}

function reqNewReportGetColumn() {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST_LOADING,
    }
}

function failedNewReportGetColumn() {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST_ERROR,
    }
}

function receiveNewReportGetColumn(columnlist) {
    return {
        type: ACTIONTYPES.COMPLETE_COLUMN_LIST,
        getColumn: columnlist
    }
}


const downloadCSVFunction = (response, fileName) => {
    const blob = new Blob([response], {
        type: 'text/csv;charset=utf-8;'
    });

    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);

    downloadLink.href = url;
    downloadLink.download = `${fileName}.csv`;

    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
}


// WEBPACK FOOTER //
// ./src/actions/index.js